<script>
import { clienteDaConversa } from '@modules/aawz-intelligence-v2/utils/cliente-da-conversa'
import SendMessage from '@modules/aawz-intelligence-v2/components/send-message/send-message.vue'
import Messages from '@modules/aawz-intelligence-v2/components/messages/messages.vue'
import ChatSidebar from '@modules/aawz-intelligence-v2/components/chat-sidebar/chat-sidebar.vue'
import ChatClienteEscopo from '@modules/aawz-intelligence-v2/components/chat-cliente-escopo/chat-cliente-escopo.vue'
import apiListaClientes from '@/src/api/listaClientes'
import EmptyMessages from '@modules/aawz-intelligence-v2/components/empty-messages/empty-messages.vue'
import SuporteWhatsappCard from '@modules/aawz-intelligence-v2/components/suporte-whatsapp/suporte-whatsapp-card.vue'
import ComposerAtencao from '@modules/aawz-intelligence-v2/components/composer-atencao/composer-atencao.vue'
import BoasVindasFalada from '@modules/aawz-intelligence-v2/components/boas-vindas-falada/boas-vindas-falada.vue'
import AvatarDaConversa from '@modules/aawz-intelligence-v2/components/avatar-da-conversa/avatar-da-conversa.vue'
import ComposerAviso from '@modules/aawz-intelligence-v2/components/composer-aviso/composer-aviso.vue'
import ConfirmarPerfilCard from '@modules/aawz-intelligence-v2/components/confirmar-perfil-card/confirmar-perfil-card.vue'
import PersonaAviso from '@modules/aawz-intelligence-v2/components/persona-aviso/persona-aviso.vue'
import RunStatusChip from '@modules/aawz-intelligence-v2/components/run-status-chip/run-status-chip.vue'
// [spec-003 T302] O relatório do lote — mora ao lado do chip porque o lote é
// do RUN, não de uma mensagem: o mapa de propostas vive no estado do run.
import RelatorioDoLote from '@modules/aawz-intelligence-v2/components/relatorio-do-lote/relatorio-do-lote.vue'
import ConditionalTeleport from '@components/teleport/conditional-teleport.vue'
import { viewChatLoteMixin } from '@modules/aawz-intelligence-v2/views/chat/view-chat-lote.mixin'
import { viewChatEspecialistaMixin } from '@modules/aawz-intelligence-v2/views/chat/view-chat-especialista.mixin'
import { bloqueioOverflowAncestralMixin } from '@modules/aawz-intelligence-v2/mixins/bloqueio-overflow-ancestral'
import { avisoDeCreditosMixin } from '@modules/aawz-intelligence-v2/mixins/aviso-de-creditos'

import { GlobalBus } from '@services/bus'
import { deveVerSoFeeFixo } from '@utils/escritorioFeeFixoMigracao'
import { CHAT_IA_EVENTOS } from '@constants/Text'
import { apiChat } from '@modules/aawz-intelligence-v2/api/apiChat'
// ★ [conversas paralelas, 18/09/2026] O registro das conversas VIVAS. Com uma
// conversa viva, esta tela lê/escreve no namespace DELA e fala com o motor
// DELA; sem, cai no namespace e no motor únicos de sempre — o comportamento
// das outras quatro superfícies (popup, painel do Hub, Fee-Based, ai-framework)
// não muda em byte nenhum.
import {
  abrirConversaViva,
  amarrarAoServidor,
  vivaPorIdServidor,
} from '@modules/aawz-intelligence-v2/api/registro-de-conversas'
// Namespace do store principal — fonte única (`api/chat-event-handlers.js`),
// nunca a string solta: um `registerModule` com outro nome quebraria cada ponto.
import { STORE_PRINCIPAL as STORE } from '@modules/aawz-intelligence-v2/api/chat-event-handlers'
import {
  motorDeVoz,
  iniciarFalaProgressiva as iniciarFalaProgressivaMotor,
  finalizarFalaProgressiva as finalizarFalaProgressivaMotor,
} from '@modules/aawz-intelligence-v2/utils/motor-de-voz'
// [spec-008 T030c] A `/ia` é a ÚNICA superfície do piloto de voz em tempo
// real (D-9/N13), e é ela quem entrega o `delegar` do `ContextoDeSessao` —
// o `POST /chat` de sempre, que é onde o cérebro e o RBAC ficam na AAWZ (D-4).
import {
  contarRespostasDoAssistente,
  houveAvancoDaRun,
  DESFECHO_SEM_RESPOSTA,
  lerDesfechoDoTurnoFalado,
  lerValorParcialDoTurnoFalado,
  SUPERFICIE_IA_OPERACIONAL,
} from '@modules/aawz-intelligence-v2/utils/contexto-de-voz-tempo-real'
import { foiCancelado } from '@modules/aawz-intelligence-v2/utils/api'
import {
  descartarFilasComPrefixo,
  anexosAguardandoCliente,
  removerAnexosAguardandoCliente,
  resetarFilaDeAnexos,
} from '@modules/aawz-intelligence-v2/utils/anexos-pendentes'
import { apiAnexosAnalise } from '@modules/aawz-intelligence-v2/api/apiAnexosAnalise'
import { ESCOPO_CLIENTE_TEXT } from '@modules/aawz-intelligence-v2/constants/Text.escopo-cliente'
import { normalizeText } from '@utils/Format'
import { MODULE_KEY_ATALHOS_DE_NEGOCIO } from '@modules/aawz-intelligence-v2/constants/acoes-por-modulo'
import {
  clienteDaEntregaDoTurno,
  precisaReancorar,
} from '@modules/aawz-intelligence-v2/utils/cliente-da-entrega'
import { atalhoDigitado } from '@modules/aawz-intelligence-v2/utils/atalho-digitado'
import {
  desregistrarProvedoresDoApiChat,
  registrarProvedoresDoApiChat,
} from '@modules/aawz-intelligence-v2/utils/provedores-do-api-chat'
import { resolverConfirmacao } from '@modules/aawz-intelligence-v2/ui-registry/confirmadores'
import {
  ACAO_AVANCAR_ETAPA,
  ACAO_CONECTAR_FERRAMENTA,
  ACAO_EXECUTAR_ATALHO,
  ACAO_RESPONDER_PERGUNTAS,
  PREFIXO_RESPOSTAS_DO_ONBOARDING,
} from '@modules/aawz-intelligence-v2/ui-registry/chave-do-onboarding'
import { modalDoConector } from '@modules/aawz-intelligence-v2/constants/Conectores'
import { montarRespostasPareadas } from '@modules/aawz-intelligence-v2/utils/perguntas-ao-gestor'
import {
  apiConversations,
  CONVERSAS_LIMITE_CARGA,
  CONTEXT_TODAS_AS_PERSONAS,
  respostaTemLista,
} from '@modules/aawz-intelligence-v2/api/apiConversations'
import { apiMessages } from '@modules/aawz-intelligence-v2/api/apiMessages'
import { apiPromptSuggestions } from '@modules/aawz-intelligence-v2/api/apiPromptSuggestions'
import { apiAtalhos } from '@modules/aawz-intelligence-v2/api/apiAtalhos'
import { apiChatAtalhos } from '@modules/aawz-intelligence-v2/api/apiChatAtalhos'
import { aguardarPisoDeCarga } from '@modules/aawz-intelligence-v2/utils/piso-de-carga'
import { mensagemAmigavelDoErro } from '@modules/aawz-intelligence-v2/utils/mensagem-de-erro'
import { aawzIntelligenceRoutes } from '@modules/aawz-intelligence-v2/constants/Text'
import {
  APRESENTACAO_EM_CURSO,
  CLIENTE_REANCORADO,
  COMPOSER_CHAT,
  ERRO_AO_ABRIR_CONVERSA,
  ESTADO_INSIGHTS,
  PRIMEIRA_PERGUNTA_DO_PRIMEIRO_CONTATO,
} from '@modules/aawz-intelligence-v2/constants/TextChat'
import {
  AGENTE_FEE_FIXO,
  agenteIdPorAgentSlug,
  agenteIdPorPersona,
  agentesVisiveis,
  agentSlugRequisitavel,
  getAgente,
} from '@modules/aawz-intelligence-v2/constants/Agentes'
import {
  getPersona,
  PERSONA_IA_OPERACIONAL,
  ORIGEM_INTELLIGENCE_V2,
} from '@modules/aawz-intelligence-v2/constants/Personas'
// [VERIFY-3b] Modo Agente + trava-scroll extraídos (regra HARD ≤ 500 linhas).
import { idDaPropostaParaOCartao } from '@modules/aawz-intelligence-v2/utils/proposta-do-cartao'
import { TEXTOS as COPY_DO_ONBOARDING } from '@modules/aawz-intelligence-v2/ui-registry/cartoes/onboarding/copy'
import { ehFalaDoCartaoDeOnboarding } from '@modules/aawz-intelligence-v2/utils/falas-do-onboarding'
import { viewChatModoAgenteMixin } from './view-chat-modo-agente.mixin'
import { viewChatDegradacaoDeGateMixin } from './view-chat-degradacao-de-gate.mixin'
// [spec-009 US-3] A plataforma passa a lembrar quem é a pessoa — a proposta
// nasce do texto do turno (fala ou digitação) e só o clique grava.
import { viewChatMemoriaDoPerfilMixin } from './view-chat-memoria-do-perfil.mixin'
// [spec-009 US-2] A fiação da boas-vindas do primeiro contato — quem decide se
// ela deve acontecer é o SERVIDOR; aqui só se pergunta, mostra e marca.
import { viewChatBoasVindasMixin } from './view-chat-boas-vindas.mixin'
// ⚠️ DEPOIS do irmão acima na lista de mixins: ele é quem declara
// `superficieDaBoasVindas`/`boasVindasDoServidor`, que este lê.
import { viewChatPrimeiraPerguntaMixin } from './view-chat-primeira-pergunta.mixin'
// ★ [18/09/2026] A conversa por VOZ do primeiro contato é com o AVATAR, não com
// o modo de voz (direção do owner). O mixin é ADITIVO e inerte enquanto
// `conversaComAvatarAtiva` for falso — o fluxo do chat não muda em nada.
import { viewChatConversaComAvatarMixin } from './view-chat-conversa-com-avatar.mixin'
// ★ [19/09/2026] A volta à tela reconfere os conectores da etapa 3 — o cartão
// desenha o retrato do TURNO, e conectar acontece fora dele (OAuth recarrega a
// página; o WhatsApp pareia dentro dela). Inerte sem etapa 3 no thread.
import { viewChatConectoresDoOnboardingMixin } from './view-chat-conectores-do-onboarding.mixin'

/**
 * A copy de falha de envio — o FALLBACK, e não a primeira escolha ([T024]).
 *
 * Quando o servidor explica o que houve (`r.message`), é a explicação DELE que
 * vai à tela: ela diz qual ferramenta caiu, qual acesso falta, o que tentar.
 * Esta frase entra quando não há explicação nenhuma — e é ela que carrega a
 * consequência que só a tela conhece: a conversa não foi salva.
 */
const COPY_FALHA_DE_ENVIO =
  'Não foi possível enviar a mensagem. A conversa não foi salva.'

// Prefixo da chave da fila de anexos desta view (`utils/anexos-pendentes.js`).
/**
 * ★ [spec-009 T013] Status em que o anexo NÃO volta a ser candidato a
 * vínculo, e por isso sai da espera (`contracts/anexo-analise.md` §2):
 * `409` tem dono (outro cliente), `404` não existe mais (ou é de outro
 * escritório — 404 opaco) e `410` expirou. Insistir a cada troca de cliente
 * só repetiria a mesma recusa na tela.
 *
 * ⚠️ `403` fica DE FORA de propósito: ele fala do CLIENTE escolhido (fora da
 * visão do profissional), não do arquivo — com outro cliente o mesmo anexo
 * pode ser vinculado, então ele continua esperando.
 */
const STATUS_SEM_VOLTA_DO_VINCULO = [404, 409, 410]

const PREFIXO_FILA_DE_ANEXOS = 'view-chat-'

// Ctrl/Cmd+Shift+O: nova conversa (mesma tecla do ChatGPT e do Claude).
const TECLA_NOVA_CONVERSA = 'o'
// `keyCode` da composição de IME: Enter/tecla durante acento não é atalho.
const KEYCODE_COMPOSICAO_IME = 229

// ★ [#214] As duas decisões que um cartão com confirmador despacha no Modo
// Agente. Os valores são do enum FECHADO do contrato de eventos
// (`events_agente.schema.json`, `d_decisao.decisao: ['aprovar','rejeitar',
// 'editar']`) — `editar` não entra porque nenhum cartão o emite pelo `respond`;
// a proposta editada tem porta própria (`onPedirNovaProposta`).
const DECISAO_APROVAR_DO_CARTAO = 'aprovar'
const DECISAO_REJEITAR_DO_CARTAO = 'rejeitar'

/**
 * ★ [spec-008 T076] O teto da espera pela resposta do turno na VOZ.
 *
 * 300 s, e o número vem de medição, não de gosto: a consulta que motivou o
 * conserto ("quantas tarefas eu tenho em aberto", escritório 83) levou **262 s**
 * pelo Modo Agente e **223 s** pelo Modo Chat. Um teto de 180 s cortaria as
 * duas; 300 s dá folga de ~15% sobre a pior medida.
 *
 * ⚠️ O teto NÃO é o que protege a sessão paga — quem faz isso é o
 * `criarVigiaDeLimites` (teto de duração + perda de foco). Este aqui só evita
 * que uma promessa fique pendurada para sempre se o turno morrer calado.
 */
const MS_TETO_DA_RESPOSTA_DO_TURNO = 600000

/**
 * ★ [spec-008 T077] Quanto tempo de SILÊNCIO DA RUN encerra a espera — e é ele,
 * não o teto absoluto, que fecha a promessa no caso normal.
 *
 * **Por que um segundo teto.** Um teto único tem de escolher entre dois erros,
 * e os dois foram medidos em 19/09/2026 contra o worker real (10 runs do
 * `modo-agente`, `aawz_intelligence_v2_run_eventos`):
 *
 * - **curto demais** — com 300 s, a run `15ef6461` foi cortada aos 300 s e a
 *   resposta chegou aos **368 s**. O consultor ouviu "não consegui" com o
 *   número a caminho. É o defeito da [T076] de novo, só que 20× mais tarde.
 * - **longo demais** — a run `43c97361` FALHOU depois de **581 s**. Esperar o
 *   teto absoluto por ela é sessão de voz paga (US$ 0,05/min) queimada num
 *   turno que já estava morto.
 *
 * ★ **O silêncio separa os dois casos, e com folga.** Maior intervalo entre
 * dois eventos consecutivos da run:
 *
 * | run | desfecho | maior silêncio | entre que eventos |
 * |---|---|---|---|
 * | `43c97361` | **failed** | **397 s** | `execucao_iniciada` → `execucao_iniciada` |
 * | `11a3e8e0` | done | 178 s | `execucao_iniciada` → `execucao_iniciada` |
 * | `15ef6461` | done (368 s no total) | 92 s | `tool_result` → `thinking` |
 * | as outras 7 | done | ≤ 77 s | `tool_result` → `thinking` |
 *
 * 240 s fica acima de TODA run que respondeu (a pior calou 178 s) e abaixo da
 * que morreu (397 s) — e encurta o turno morto de 581 s para 240 s.
 *
 * ⚠️ **A tabela acima é de máquina de DESENVOLVIMENTO**, com o worker sendo
 * derrubado e subido durante a sessão: os dois maiores silêncios dela são
 * `execucao_iniciada` → `execucao_iniciada` (execução REINICIADA), o que bate
 * com as causas dominantes de falha na mesma janela — `sem_claim` 41× e
 * `worker_morto_sem_end` 21×. Ou seja, ela mede rodízio de lease, não
 * raciocínio, e sozinha NÃO justificaria 240 s.
 *
 * ★ **Quem justifica é a medição de PRODUÇÃO** (EKS `backend-prod`, 7 dias,
 * 2.981 runs, feita pela sessão que opera o worker — onde `sem_claim` e
 * `worker_morto_sem_end` não aparecem):
 *
 * | par de eventos | n | máx | p95 |
 * |---|---:|---:|---:|
 * | `tool_result` → `tool_call` (raciocínio + escolher a próxima tool) | 103 | **118,4 s** | 51,2 s |
 * | `tool_call` → `tool_result` (tool executando) | 2.772 | 66,7 s | 1,1 s |
 * | `tool_result` → `thinking` | 26 | 18,5 s | — |
 *
 * Com worker estável o modelo não passa de **118,4 s**, e uma tool de
 * long-poll sozinha leva 61 s. **120 s cortaria na margem; 240 s tem folga
 * real.** É este o número que sustenta o literal — não os 397 s de rodízio.
 *
 * ⚠️ E o par que carrega o raciocínio é `tool_result` → `tool_call`, não
 * `tool_result` → `thinking`: `thinking` é raro em produção (55 eventos em 7
 * dias). Quem for remedir precisa olhar o par certo.
 *
 * ⚠️ **Só vale onde há run publicando cursor.** No Modo Chat `runAtual` é
 * `null` (o agent-chat da Central manda `id_run` como trilha de auditoria e
 * `_acompanhaRunPeloMotor()` recusa armar o acompanhamento), e sem cursor não
 * há como distinguir "pensando" de "morto": lá só o teto absoluto vale.
 */
const MS_SEM_PROGRESSO_DA_RUN = 240000

/**
 * ★ [spec-008 T078] O estado em que a run espera um HUMANO, não a máquina.
 *
 * Medido em produção pela sessão que opera o worker (EKS `backend-prod`, 7
 * dias, 2.981 runs): o tempo até a decisão, quando ela vem, é **mín 93 s,
 * média 54 min, máx 3h49** — e **25 de 27 propostas EXPIRARAM** sem decisão
 * nenhuma, cada uma segurando o run por ~34 min (o TTL da proposta).
 *
 * ⚠️ Nenhum teto de silêncio pode correr aqui. `awaiting_approval` mantém o
 * relay SSE aberto em heartbeat até a decisão (US-5/E-22), então do lado de
 * fora isso parece um turno vivo e calado — que é exatamente o que o vigia de
 * progresso foi feito para esperar. Esperar seria cobrar do consultor uma
 * sessão de voz PAGA (US$ 0,05/min) por um clique que talvez nunca venha.
 *
 * ★ E a espera aqui não é só cara, é ERRADA: quem espera calado deixa de
 * dizer que há uma decisão NA TELA. Encerrando na hora, o desfecho sai com o
 * `preview_id` da proposta pendente (`toolParts` já o carrega) e a voz remete
 * ao cartão — em vez de dizer "não consegui" quatro minutos depois.
 */
const ESTADO_DA_RUN_AGUARDANDO_DECISAO = 'awaiting_approval'

/**
 * De quanto em quanto se olha o store. 400 ms é abaixo da percepção de
 * conversa (a fala de acompanhamento sai a cada 8-13 s) e barato: a leitura é
 * um getter em memória, não uma chamada.
 */
const MS_ENTRE_OLHADAS_NO_TURNO = 400

export default {
  name: 'ViewIntelligenceV2Chat',
  components: {
    BoasVindasFalada,
    AvatarDaConversa,
    SendMessage,
    Messages,
    ChatSidebar,
    ChatClienteEscopo,
    EmptyMessages,
    SuporteWhatsappCard,
    ComposerAtencao,
    ComposerAviso,
    ConfirmarPerfilCard,
    PersonaAviso,
    RunStatusChip,
    RelatorioDoLote,
    ConditionalTeleport,
  },
  // ★ merge PR #2242 — `viewChatModoAgenteMixin` (spec-002) entra INTEIRO: os
  // 24 membros dele não colidem com nenhum método desta view (medido no
  // merge). `viewChatScrollLockMixin`, que a branch tinha ao lado, NÃO entra:
  // é a MESMA extração que `bloqueioOverflowAncestralMixin`
  // (`modifiedAncestors`/`lockAncestorOverflow`/`unlockAncestorOverflow`,
  // byte a byte), e a de `desenvolvimento` ainda tem a guarda de idempotência
  // que faltava na outra. O arquivo continua no repo — remover é commit
  // próprio, não deste merge.
  // ★ [17/09/2026] `viewChatDegradacaoDeGateMixin` entra ao lado do Modo
  // Agente, não dentro dele: os dois moram na MESMA instância (o mixin do
  // agente chama `this.degradarParaModoChat` e lê
  // `this.modoAgenteRecusadoPeloBackend` sem ponte nenhuma), e separá-los
  // mantém `view-chat-modo-agente.mixin.js` sob o teto de 500 linhas.
  mixins: [
    viewChatModoAgenteMixin, viewChatDegradacaoDeGateMixin, viewChatMemoriaDoPerfilMixin,
    viewChatBoasVindasMixin, viewChatPrimeiraPerguntaMixin,
    viewChatConversaComAvatarMixin, viewChatLoteMixin,
    viewChatEspecialistaMixin, bloqueioOverflowAncestralMixin, avisoDeCreditosMixin,
    viewChatConectoresDoOnboardingMixin,
  ],
  page: {
    title: 'IA Operacional',
    meta: [
      {
        name: 'description',
        content: 'Chat de IA operacional com dados de CRM',
      },
    ],
  },
  props: {
    // ★ O id LOCAL da conversa viva que ESTA instância renderiza. Vazio =
    // motor e namespace únicos, como sempre foi.
    //
    // ⚠️ É a ÚNICA porta do modo paralelo, e `idDaConversaDaRota` DE PROPÓSITO
    // não abre conversa viva: a URL `/home-ia/c/<uuid>` serve UMA conversa por
    // documento — duas abas do browser já têm stores separados, e não há dois
    // streams disputando nada. O motor único só atrapalha quando N conversas
    // vivem na MESMA aba, e quem monta essas N passa esta prop explicitamente.
    /**
     * A superfície mostra CONVERSAS EM ABAS?
     *
     * Opt-in, e só a imersiva liga (atrás do kill-switch
     * `CONVERSAS_EM_ABAS_ATIVO`). É ela que faz "nova conversa" da lateral
     * abrir uma ABA em vez de zerar a atual — ver `pediuAbaNova`.
     */
    conversasEmAbas: {
      type: Boolean,
      default: false,
    },
    idConversaViva: { type: String, default: '' },
    embedded: { type: Boolean, default: false },
    widget: { type: Boolean, default: false },
    // Default = IA Operacional ⇒ comportamento atual intacto.
    persona: { type: String, default: PERSONA_IA_OPERACIONAL },
    // Superfície de onde a conversa vem (eixo ortogonal à persona) — default preserva o de hoje.
    origemModulo: { type: String, default: ORIGEM_INTELLIGENCE_V2 },
    // Vem da faixa da Jornada. Aplicada UMA única vez, no `created`.
    perguntaInicial: { type: String, default: '' },
    // Com esta prop a pergunta PARTE sozinha; sem ela fica no composer para o
    // gestor revisar antes de enviar. A página do Consultor mantém o segundo
    // comportamento (não passa a prop); o painel do Hub usa o primeiro, porque
    // ali o clique já foi no chip com a pergunta escrita.
    enviarPerguntaInicial: { type: Boolean, default: false },
    iniciarConversaNova: { type: Boolean, default: false },
    /**
     * A conversa pedida pela URL (`/home-ia/c/<uuid>`, param `idConversa`) —
     * decisão do owner, 18/09/2026: *"até para que cada conversa consiga ter um
     * url direto para ela"*.
     *
     * Quem lê a rota é a VIEW DA ROTA (`view-chat-imersivo.vue`) e desce o id
     * por aqui; este componente não conhece router, e não pode conhecer: ele
     * também roda no popup, no painel do Hub e no Fee-Based, onde navegar seria
     * arrastar a plataforma inteira junto.
     *
     * Vazio = comportamento de sempre (`iniciarConversaNova` decide). Com id, a
     * URL VENCE: quem colou o endereço de uma conversa quer aquela conversa.
     */
    idDaConversaDaRota: { type: String, default: '' },
    // Agente escolhido por uma superficie externa (o historico do popup).
    // Vazio = ninguem esta controlando de fora; o agente e so interno.
    agenteId: { type: String, default: '' },
    // A superficie hospedeira ja tem cabecalho proprio e nao quer o header de
    // rota. Necessario porque o `ConditionalTeleport` decide pela FLAG do Nav
    // 2026, nao pela existencia do alvo: com a flag ligada ele teleporta para
    // `page-header-actions`, que so existe na nav-bar do modulo — fora dela o
    // conteudo vira orfao e some; com a flag desligada ele renderiza inline e
    // duplica o cabecalho do hospedeiro. Usada pela visao imersiva.
    semHeaderDeRota: { type: Boolean, default: false },
    // Repassado a' sidebar: liga a marca do escritorio e o gesto de recolher,
    // quando a lateral faz o papel de navegacao da tela (visao imersiva).
    sidebarComoNavegacao: { type: Boolean, default: false },
    // Liga a escolha de ESCOPO (um cliente) na conversa: chip no composer +
    // cartao de contexto acima das mensagens. Opt-in — popup, painel do Hub e
    // as demais superficies nao mudam.
    escopoDeCliente: { type: Boolean, default: false },
    // Repassado ao `Messages`: liga o índice das mensagens do usuário na borda
    // do trilho (traços + popover). Opt-in pela mesma razão das duas acima —
    // só a visão imersiva passa; popup, painel do Hub e ai-framework não mudam.
    comIndiceDeMensagens: { type: Boolean, default: false },
    // Repassado ao `Messages`: liga o índice "Artefatos desta conversa" (chip
    // no canto superior direito do trilho + popover). Mesmo opt-in, mesma
    // razão — só a visão imersiva, onde o modo artefato está ligado.
    comIndiceDeArtefatos: { type: Boolean, default: false },
    // Contagem da faixa no topo do composer, JÁ APURADA pela superfície
    // hospedeira — mesmo arranjo de `sidebarInsights`: esta view não busca
    // nada. `null` = não apurado, e é diferente de `0` (ver o util
    // `sugestoes-a-triar`). A faixa some sozinha nos dois casos.
    sugestoesATriar: { type: Number, default: null },
    // Linhas de insight da lateral, ja filtradas e agrupadas pela superficie
    // hospedeira. Vazio = o bloco some.
    sidebarInsights: {
      type: Array,
      default: () => [],
    },
    // Desfecho do painel do escritório (`ESTADO_INSIGHTS`), apurado pela
    // hospedeira — mesmo arranjo de `sidebarInsights`: esta view não decide,
    // só encaminha. `ok` para quem não tem painel, que é o caso do popup e do
    // chat embutido.
    sidebarInsightsEstado: {
      type: String,
      default: ESTADO_INSIGHTS.OK,
    },
    // Atalhos de módulo da lateral RECOLHIDA, já filtrados pela hospedeira —
    // mesmo arranjo de `sidebarInsights`: esta view não decide, só encaminha.
    sidebarAtalhos: {
      type: Array,
      default: () => [],
    },
    // Dados do painel do cliente em foco, JÁ buscados pela hospedeira. Como os
    // insights: esta view não busca nada, só encaminha. Vazio = a lateral segue
    // mostrando o painel do escritório.
    //
    // ⚠️ O CLIENTE em si não vem por prop — ela já o tem em `clienteEscopo`, do
    // store, e uma segunda fonte para a mesma coisa divergiria.
    sidebarDadosDoCliente: {
      type: Object,
      default: () => ({}),
    },
    // Trava do botão "Personalizar meu painel" — mesmo arranjo de
    // `sidebarInsights`: esta view não decide, só encaminha.
    sidebarPersonalizacaoDisponivel: {
      type: Boolean,
      default: false,
    },
    // Editor de personalização aberto — mesmo arranjo.
    sidebarModoPersonalizacao: {
      type: Boolean,
      default: false,
    },
    // "Salvar" em voo — o `loading` do rodapé do editor.
    sidebarSalvandoPersonalizacao: {
      type: Boolean,
      default: false,
    },
    sidebarItensPersonalizaveisVisiveis: {
      type: Array,
      default: () => [],
    },
    // Catálogo inteiro (visíveis + ocultos), já filtrado por permissão/
    // feature flag do escritório — ver o comentário da prop equivalente em
    // `chat-sidebar.vue`.
    sidebarItensPersonalizaveisCatalogo: {
      type: Array,
      default: () => [],
    },
    // Apaga o bloco de sugestões do estado vazio. Mesmo arranjo de
    // `sidebarInsights`: esta view não decide, só encaminha.
    ocultarSugestoes: {
      type: Boolean,
      default: false,
    },
    // Ancora a pilha do estado vazio no topo em vez de centrá-la — ver o
    // `empty-messages`. Como as outras: esta view não decide, só encaminha.
    // Módulos do menu do "+" do composer, já recortados pela superfície.
    // Destrava o anexo no composer. Opt-in: só a `/ia` passa (vem de
    // `utils/anexos-liberados.js`, a funcionalidade do escritório — spec-003
    // T306), e as outras superfícies seguem com o "+" travado.
    anexosLiberados: {
      type: Boolean,
      default: false,
    },
    // Destrava "Anexar carteira" no palette. Opt-in, e por AGENTE: só a `/ia`
    // passa, e só quando o Especialista Fee-Based está ativo — ver a prop de
    // mesmo nome em `send-message`.
    anexoDeCarteiraLiberado: {
      type: Boolean,
      default: false,
    },
    ferramentasDoComposer: {
      type: Array,
      default: () => [],
    },
    ancorarEstadoVazio: {
      type: Boolean,
      default: false,
    },
    // Composer no formato do ChatGPT — uma linha fina, seletores só-ícone.
    // Como a prop acima: esta view não decide, só encaminha.
    estiloLimpoDoComposer: {
      type: Boolean,
      default: false,
    },
    // Grade/lista de ações por módulo do estado vazio, já filtrada pela
    // superfície hospedeira (`acoesVisiveis`). Vazio = ficam as pílulas de
    // sempre. Mesmo arranjo de `sidebarInsights`: esta view não apura nada,
    // só repassa — EXCETO o filtro ao vivo por texto digitado, que mora aqui
    // porque é aqui que `messageInput` existe (ver `acoesPorModuloFiltradas`).
    acoesPorModulo: {
      type: Array,
      default: () => [],
    },
    // `'grade'` (padrão) ou `'lista'` — repassado ao `layoutDasAcoes` do
    // `empty-messages`. Em `'lista'`, esta view filtra `acoesPorModulo` AO
    // VIVO por `messageInput`, com o mesmo critério de prefixo sem acento do
    // menu "+"/`/módulo` (`composer-ferramentas.vue`) — ver
    // `acoesPorModuloFiltradas`.
    layoutDasAcoes: {
      type: String,
      default: 'grade',
    },
    // ★ [G-R2-4 do QA da spec-001] Uma metade de `acoesPorModulo` FALHOU ao
    // carregar (hoje: o catálogo de atalhos). Esta view só REPASSA — quem
    // sabe o que falhou e como recarregar é a superfície hospedeira, que
    // ouve `aviso-das-acoes-acao` de volta.
    avisoDasAcoes: {
      type: String,
      default: '',
    },
    avisoDasAcoesAcao: {
      type: String,
      default: '',
    },
    // `compacta` ou `ampla` — só repassa, quem decide é a superfície.
    densidadeDaGrade: {
      type: String,
      default: 'compacta',
    },
    // `carrossel` ou `lista`, para as ações do módulo escolhido no "+". Como as
    // demais: esta view não decide, só encaminha.
    layoutDoModuloEmFoco: {
      type: String,
      default: 'carrossel',
    },
    // 'pilulas' (padrão) ou 'lista' (estilo ChatGPT) — repassado direto ao
    // `modoDeSugestao` do `empty-messages`. Esta view não decide, só encaminha.
    modoDeSugestao: {
      type: String,
      default: 'pilulas',
    },
    // Sugestões FIXAS (client-side, `[{text, icon}]`), usadas no modo 'lista'
    // enquanto não há endpoint de sugestões próprio. `null` preserva o
    // caminho antigo (getter `promptSuggestions`) para quem não passa a prop.
    sugestoesFixas: {
      type: Array,
      default: null,
    },
    /**
     * Cartão de suporte abaixo do composer no estado vazio
     * (`suporte-whatsapp-card.vue`). Substitui o link "Suporte no WhatsApp"
     * que morava na linha do hint do composer até 17/09/2026.
     *
     * Opt-in: só a superfície imersiva passa. No popup e no painel do Hub o
     * estado vazio é uma coluna curta, e um cartão a mais ali comeria a altura
     * do composer.
     */
    comCartaoDeSuporte: {
      type: Boolean,
      default: false,
    },
    /**
     * Esconde a dica de teclado do rodapé do composer.
     *
     * [owner, 19/09/2026] *"no modo chat aberto não faça aparecer o texto
     * 'Enter para enviar • Shift+Enter para nova linha'"*. Numa tela cheia de
     * chat ela é ruído permanente — e durante o onboarding chega a mentir: o
     * composer está TRAVADO (`envioTravado`) e a linha segue ensinando a
     * enviar.
     *
     * Opt-in: só a superfície imersiva passa. Popup, painel do Hub e
     * Fee-Based continuam com a dica, onde ela ainda é a única pista de
     * teclado da caixa.
     */
    semDicaDeTeclado: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // ★ [conversas paralelas] A conversa VIVA que esta instância mostra —
      // módulo Vuex e motor de stream próprios. `null` = a tela usa o
      // namespace/motor únicos de sempre.
      //
      // Mora em `data` e NÃO num computed de propósito: `abrirConversaViva`
      // REGISTRA módulo no store — é efeito colateral, e computed é leitura.
      // Quem abre é o ciclo de vida (`created`) e o watcher da prop.
      vivaAtual: null,
      messageInput: '',
      // ★ [19/09/2026] A thread morreu no render (`messages.vue`,
      // `errorCaptured`). Enquanto isto é `true` o envio está BLOQUEADO: no
      // QA da spec-006, com a tela em branco, 13 turnos saíram, chegaram ao
      // backend e foram cobrados (4.986,80 → 4.974,44 em créditos) sem nunca
      // renderizar. Só recarregar limpa — o componente e o turno estão em
      // estado indefinido, e insistir na mesma página leva à mesma exceção.
      trilhoQuebrado: false,
      // ★ [T076] O teto da espera pela resposta do turno na VOZ, em `data`
      // para que a suíte possa encurtá-lo — ver `esperarRespostaDoTurno`.
      tetoDaRespostaDoTurnoMs: MS_TETO_DA_RESPOSTA_DO_TURNO,
      // ★ [T077] O teto de SILÊNCIO da run, pelo mesmo motivo.
      tetoSemProgressoDaRunMs: MS_SEM_PROGRESSO_DA_RUN,
      // ★ merge PR #2242 — os três campos do Modo Agente (spec-002) que o
      // `view-chat-modo-agente.mixin.js` lê e ESCREVE. Ele não declara `data`
      // próprio: sem eles aqui, a escrita cai em propriedade não reativa e o
      // chip/cartão nunca reagem — sem erro nenhum.
      retryIndisponivel: false,
      tentandoNovamente: false,
      pedindoNovaProposta: false,
      // Módulo escolhido no menu do "+". Mora AQUI porque os dois consumidores
      // são irmãos: o composer (que desenha o chip) e o estado vazio (que
      // desenha o carrossel). Nenhum dos dois guarda nada.
      ferramentaSelecionada: null,
      // Trava de reentrância do envio. `chatLoading` NÃO serve: ele só vira
      // true dentro de `apiChat.sendMessage`, depois deste método já ter
      // rodado — e há SEIS chamadores. Quando o texto vem por argumento
      // (sugestão, `ask` do formulário, confirmar/cancelar write-tool),
      // `messageInput = ''` também não protege: o texto não vem do campo.
      // Dois disparos rápidos passavam os dois pelo guard e a mesma pergunta
      // aparecia duas vezes na conversa (incidente de 2026-08-20).
      enviando: false,
      perguntaInicialAplicada: false,
      // ★ Token da carga de conversas. Duas cargas correm juntas o tempo todo —
      // a do `created` (sem filtro) e a do watcher do cliente em foco (com
      // filtro) —, e sem token a que chegar POR ÚLTIMO vence, mesmo sendo a
      // mais velha. Medido: focar num cliente sem conversa devolvia 0 do
      // backend e a lateral seguia mostrando as 30 do escritório.
      //
      // É a regra que o `CLAUDE.md` do repo já registra para troca de contexto:
      // "resete o estado antes do fetch e descarte respostas stale".
      cargaDeConversas: 0,
      // Paginação do histórico da lateral imersiva. `temMaisConversas` nasce
      // `false`: só a primeira carga sabe dizer se há página seguinte.
      carregandoMaisConversas: false,
      temMaisConversas: false,
      // Eixo VISÍVEL da conversa. Nasce da prop `persona` no `created`, para
      // que as superfícies embutidas (que só passam persona) não mudem.
      agenteAtivoId: '',
      // ★ [06/09/2026] Marca que `agenteAtivoId` veio de uma ESCOLHA REAL do
      // usuário (sidebar/palette/composer, via `irParaAgente`) — nunca do
      // default do `created`/da prop. É o que decide se `agenteSolicitado` viaja no
      // corpo do turno (`despacharMensagem`): mandar sempre transformaria
      // "sem escolha" em "escolhi o default", a mesma ambiguidade que o
      // pedido do owner quer eliminar. Resetado em toda `novaConversa()` que
      // NÃO veio de `irParaAgente` (ele mesmo religa logo em seguida).
      escolhaExplicitaDeAgente: false,
      // Guard de reentrância do darFeedback — por messageId, pra 2 cliques
      // rápidos no mesmo botão (ou em thumbs up/down da mesma mensagem) não
      // dispararem 2 requests concorrentes.
      feedbackEmAndamento: {},
      // [spec-013 T014, forma revista na T016] Catálogo de atalhos de
      // negócio do menu do `/` (`/panorama`, `/pré-reunião`), já filtrado
      // por papel NO SERVIDOR — buscado em `carregarAtalhos()` (chamado no
      // `created()`) e passado ADIANTE sem tradução nenhuma: desde a T016,
      // `send-message-atalhos-mixin.js` consome direto a forma do contrato
      // (`{id, label, description, pedeArgumento, placeholderArgumento}`).
      // `[]` até a resposta chegar e como fallback de qualquer falha — ver
      // o comentário de `carregarAtalhos()`.
      atalhosDisponiveis: [],
      /**
       * A pessoa pediu para seguir SEM a apresentação.
       *
       * ★ É a saída incondicional do beco: `onboardingConduzindo` decide pela
       * PRESENÇA do cartão de etapa, não por ele ter conseguido montar — uma
       * etapa reprovada pelo schema cai no `fallback-card` (sem botão) e
       * deixaria o composer travado para sempre.
       *
       * ⚠️ A dispensa é da CONVERSA, e quem a zera é o watcher de
       * `selectedConversation` (a TROCA, venha de onde vier) e
       * `novaConversa` — **não** o ciclo de vida do componente. O comentário
       * daqui dizia "vale para ESTA montagem, e trocar de conversa recomeça",
       * e isso era falso: as duas rotas da imersiva dividem a mesma
       * `meta.chaveDeMontagem` E o mesmo loader memoizado (§5.1, "O 1º envio
       * REMONTAVA a tela"), então a view NÃO remonta ao trocar de conversa.
       * Dispensar a apresentação em uma conversa deixava o composer destravado
       * na SEGUINTE, no meio do roteiro dela.
       */
      apresentacaoDispensada: false,
    }
  },
  computed: {
    /**
     * O composer fica TRAVADO enquanto a apresentação conduz.
     *
     * ★ Pedido do owner (18/09/2026): *"deixar o chat disabled até ele
     * completar o onboarding"*. A apresentação é uma sequência de passos, e
     * cada passo já traz o próprio jeito de responder — o formulário da etapa
     * 1, os botões da 2, a lista da 3, o "Rodar" da 4. Um campo livre ao lado
     * disso convida a sair do trilho no exato momento em que a tela está
     * ensinando qual é o trilho.
     *
     * ⚠️ NÃO impede responder: o formulário e os botões dos cartões mandam
     * pelas rotas próprias deles (`onResponderPerguntas`,
     * `rotearAvancoDoOnboarding`), que não passam pelo composer.
     *
     * ⚠️ Some sozinho quando o roteiro acaba — `onboardingConduzindo` lê a
     * ÚLTIMA mensagem do assistente, não "a conversa já teve onboarding".
     */
    envioTravado() {
      if (this.semCreditos) return true
      // ★ A dispensa vence a apresentação — ver `apresentacaoDispensada`.
      return Boolean(this.onboardingConduzindo && !this.apresentacaoDispensada)
    },
    /**
     * A faixa do composer durante a apresentação — o porquê da trava, e a saída.
     *
     * ⚠️ A de CRÉDITOS vence: ela é bloqueio de verdade (não há o que fazer na
     * tela), esta é condução. Mesma régua da faixa de sugestões a triar.
     */
    /**
     * O placeholder do campo — ele também tem de dizer o que está acontecendo.
     *
     * ⚠️ Computed NOVO em vez de sobrescrever `placeholderDoComposer` (do
     * `mixins/aviso-de-creditos.js`): sombrear o do mixin obrigaria a
     * replicar o caso de crédito aqui, e as duas cópias divergiriam na
     * primeira revisão. Este só acrescenta um caso ANTES de delegar.
     */
    placeholderNaTela() {
      if (this.avisoDaApresentacao) return APRESENTACAO_EM_CURSO.PLACEHOLDER
      return this.placeholderDoComposer
    },
    avisoDaApresentacao() {
      if (this.avisoDeCreditos) return null
      if (!this.envioTravado) return null
      if (this.semCreditos) return null
      return APRESENTACAO_EM_CURSO
    },
    /**
     * O namespace Vuex de quem esta tela está mostrando.
     *
     * ★ Com conversa viva, é o módulo DELA; sem, o `STORE` único. É a única
     * peça que decide de onde a tela lê e para onde escreve — por isso todo
     * `dispatch`/`getters` desta view passa por aqui, e nenhum cita `STORE`
     * direto. Duas conversas na mesma aba param de escrever na mesma
     * `messages[]` por CONSTRUÇÃO, não por guarda.
     */
    ns() {
      return this.vivaAtual ? this.vivaAtual.namespace : STORE
    },
    /**
     * O namespace do HISTÓRICO — a lista de conversas e as pastas.
     *
     * ⚠️ [owner, 20/09/2026] *"pq ao clicar em uma aba os itens no recentes
     * mudam ou somem?"*. Porque eles eram lidos e escritos em `ns`: com as
     * conversas vivas cada aba tem o próprio módulo, e "Recentes" passou a
     * mostrar a CÓPIA daquela aba — vazia na que nunca carregou. As pastas
     * eram pior: `apiFolders.carregar()` não aceita `storeModule` e sempre
     * escreveu no módulo FIXO, então na Home IA elas nunca apareciam.
     *
     * A lista é do PROFISSIONAL, não da conversa — o mesmo `GET
     * /conversations` para todas as abas. Por isso ela mora, sempre, no
     * `STORE` único. Fora da Home IA os dois namespaces coincidem e nada muda.
     *
     * ⚠️ `selectedConversation` NÃO entra aqui: essa é da conversa, e é ela que
     * marca a linha ativa em Recentes.
     */
    nsDoHistorico() {
      return STORE
    },
    /**
     * O motor de stream desta conversa.
     *
     * ★ É o que conserta o sintoma medido pelo owner: `_abrirAbortController`
     * aborta o stream ANTERIOR **da mesma instância** ("UM stream por
     * instância", 15/09/2026). Com o motor único, mandar na conversa B matava
     * o turno da A e o backend gravava `CONTEUDO_TURNO_CANCELADO` — a bolha
     * "Resposta interrompida pelo usuário" sem usuário nenhum ter
     * interrompido. Uma instância por conversa: cada uma aborta só a si.
     */
    motor() {
      return this.vivaAtual ? this.vivaAtual.apiChat : apiChat
    },
    // A fila de anexos das DUAS instâncias do composer (herói e rodapé) — uma
    // por view, para o anexo de outra superfície (drawer do Fee-Based) não
    // entrar aqui. Zerada ao trocar de conversa e no `beforeDestroy`.
    chaveDaFilaDeAnexos() {
      // ⚠️ [20/09/2026, review do #2342] A chave leva TAMBÉM a conversa viva.
      // Só com o `_uid` a fila era da INSTÂNCIA, e a instância não remonta ao
      // trocar de aba: o extrato anexado na aba A reaparecia na B — e lá
      // `canSend` travava o envio por um anexo de outra conversa. O `_uid`
      // fica porque é ele que isola as SUPERFÍCIES (popup e painel do Hub
      // montados juntos, que foi o vazamento original de §6.6).
      const viva = this.vivaAtual ? ':' + this.vivaAtual.idLocal : ''
      return PREFIXO_FILA_DE_ANEXOS + this._uid + viva
    },
    moduleRoutes() {
      return aawzIntelligenceRoutes()
    },
    /**
     * `acoesPorModulo` filtrado AO VIVO por `messageInput`, quando
     * `layoutDasAcoes === 'lista'` (a lista fixa de módulos do estado vazio
     * da `/ia`, 10/09/2026). Mora aqui — e não na visão imersiva, que é quem
     * manda o catálogo — porque é `view-chat.vue` quem tem `messageInput`; a
     * visão imersiva não teria como filtrar sem duplicar esse estado.
     *
     * Mesmo critério de `modulosFiltrados` (`composer-ferramentas.vue`):
     * prefixo do RÓTULO, sem acento/caixa, via `normalizeText` (`@utils/Format`)
     * — a mesma função, pra não duas normalizações de texto divergirem. Campo
     * vazio devolve a lista inteira; texto que não casa com nenhum rótulo
     * devolve array vazio, e é isso que faz o bloco inteiro sumir do
     * `empty-messages` (`temAcoes` cai para `false`) — sem mensagem de "nada
     * encontrado" inventada.
     *
     * `layout: 'grade'` (o padrão de todas as outras superfícies) devolve
     * `acoesPorModulo` intacto: filtro é uma decisão exclusiva do layout
     * `'lista'`.
     */
    acoesPorModuloFiltradas() {
      // ★ [18/09/2026] No PRIMEIRO CONTATO não há sugestão nenhuma: o chat
      // está prestes a escrever o comando pela pessoa, e oferecer atalhos de
      // módulo ao lado disso convida a sair do trilho no exato momento em que
      // a tela está ensinando qual é o trilho — o mesmo argumento do
      // `envioTravado`. Array vazio derruba `temAcoes` no `empty-messages` e o
      // bloco inteiro some, sem mensagem inventada.
      if (this.primeiroContatoEmAberto) return []
      if (this.layoutDasAcoes !== 'lista') return this.acoesPorModulo
      // ★ [18/09/2026] Enquanto a PRIMEIRA PERGUNTA está sendo digitada pelo
      // chat, o campo não é busca: é texto que nós escrevemos. Filtrar por ele
      // esvaziaria a lista de módulos letra a letra — e, medido, este computed
      // recomputa o catálogo INTEIRO uma vez por caractere (13 recomputações
      // numa frase de 13 letras), que é o trabalho mais caro do caminho.
      if (this.primeiraPerguntaEmCurso) return this.acoesPorModulo
      const alvo = normalizeText(this.messageInput || '')
      if (!alvo) return this.acoesPorModulo
      return this.acoesPorModulo.filter(
        (modulo) => normalizeText(modulo.rotulo || '').indexOf(alvo) === 0
      )
    },
    /**
     * A persona que de fato responde neste turno.
     *
     * 1. **O AGENTE ativo** (palette/Ctrl+K do redesign imersivo), quando há um.
     * 2. A prop, enquanto nenhum agente foi resolvido.
     */
    /**
     * As pílulas de sugestão do estado vazio somem no primeiro contato — pelo
     * mesmo motivo da lista de módulos, logo acima.
     *
     * Computed e não a prop crua porque a decisão é de DUAS origens: a
     * superfície (`ocultar-sugestoes`, hoje o modo limpo da imersiva) e o
     * momento do primeiro contato, que só esta view conhece.
     */
    ocultarSugestoesNaTela() {
      return Boolean(this.ocultarSugestoes || this.primeiroContatoEmAberto)
    },
    personaEfetiva() {
      if (!this.agenteAtivoId) return this.persona
      return getAgente(this.agenteAtivoId).persona
    },
    /**
     * Se o palette oferece "Anexar carteira" AGORA.
     *
     * Duas condições, e as duas precisam valer: a superfície autoriza
     * (`anexoDeCarteiraLiberado` — hoje só a `/ia`) e o agente ativo é o
     * Especialista Fee-Based. O gate do AGENTE mora aqui, e não na superfície,
     * porque é esta view que troca de agente pelo palette: a home nunca fica
     * sabendo, e o comando ou apareceria sempre ou nunca.
     */
    ofereceAnexoDeCarteira() {
      return this.anexoDeCarteiraLiberado && this.agenteAtivoId === AGENTE_FEE_FIXO
    },
    // Só na navegação (`/home-ia`) o agente ativo dobra como item de
    // navegação da própria sidebar; ali "Recentes" filtrar por ele escondia
    // conversas dos outros agentes. Na página cheia o agente CONTINUA sendo o
    // filtro — é a navegação de lá.
    //
    // `context` e `persona` são o MESMO eixo (o backend dá precedência ao
    // `context`), então viajam um OU outro, nunca os dois — mandar os dois
    // deixa a intenção ambígua na aba de rede. Aplicado nos dois call sites
    // (`carregarConversas` e `carregarMaisConversas`), senão o scroll
    // infinito da home devolveria uma persona só depois de a primeira
    // página já ter mostrado todas.
    filtroDeConversas() {
      if (this.sidebarComoNavegacao) return { todosAgentes: true }
      return { persona: this.personaEfetiva, context: undefined }
    },
    /**
     * O MESMO eixo de `filtroDeConversas`, como STRING — é o que a
     * `ChatSidebar` repassa aos próprios recarregamentos (mover conversa de
     * pasta, apagar pasta), pra usarem o eixo com que a lista foi CARREGADA
     * em vez do default do backend (`persona='CRM'`).
     *
     * Fora da navegação é a persona efetiva — o mesmo eixo que
     * `filtroDeConversas` manda como `persona`; vazio aqui fazia o recarregar
     * cair no default do backend (CRM) com o Consultor ativo.
     */
    contextoListagem() {
      return this.sidebarComoNavegacao ? CONTEXT_TODAS_AS_PERSONAS : this.personaEfetiva
    },
    // Tudo o mais deriva daqui — nenhuma chamada de função no template.
    personaAtual() {
      return getPersona(this.personaEfetiva)
    },
    temAviso() {
      return Boolean(this.personaAtual.aviso)
    },
    containerStyle() {
      if (this.widget) return { height: '100%', padding: '0' }
      // Página cheia: a altura vem do shell (aawz-intelligence-nav-bar.vue),
      // que já repassa via flexbox a altura real disponível dentro do
      // .nav-v2-shell__content (único dono do scroll). Evita calc(100vh - Npx)
      // fixo, que desatualiza a cada mudança no chrome (topbar global, abas,
      // padding do .content-nav).
      const altura = this.embedded
        ? { height: 'calc(100vh - 200px)', minHeight: '600px' }
        : { height: '100%' }
      return { ...altura, padding: '0' }
    },
    clienteEscopo() {
      return this.$store.getters[`${this.ns}/clienteEscopo`]
    },
    // spec-009 [T008] — o agente ativo desta conversa, para o badge ao lado
    // do "Cliente em foco" (`{agentSlug, hub, motivo}` ou `null`).
    agenteAtualDaConversa() {
      return this.$store.getters[`${this.ns}/agenteAtualDaConversa`]
    },
    /**
     * spec-009 [T006/US-2, AC-2.3] — "Esta conversa fala de <nome>", quando
     * o chip está fixado MANUALMENTE em outro cliente e o servidor acabou de
     * identificar um diferente. Vazio (sem aviso) é o caso comum: sem
     * identificação nenhuma, ou identificação IGUAL ao que já está fixado.
     */
    avisoDeConversaTexto() {
      const identificado = this.clienteDaConversaAtualValidado
      if (!identificado || !identificado.id_cliente_app) return ''
      const idFixado = this.clienteEscopo && this.clienteEscopo.id
      if (!idFixado) return ''
      if (Number(idFixado) === Number(identificado.id_cliente_app)) return ''
      return 'Esta conversa fala de ' + (identificado.nome || 'outro cliente') + '.'
    },
    /** Só o id do cliente que o AVISO oferece trocar — payload do evento `trocar-para-cliente`. */
    idClienteDoAvisoAtual() {
      return this.avisoDeConversaTexto
        ? this.clienteDaConversaAtualValidado.id_cliente_app
        : null
    },
    /**
     * O cliente que viaja no POST. `id` da lista de clientes é
     * `app_clientes.id` — o mesmo que o cartão exibe como `#id` e o mesmo que o
     * backend valida contra a visão do profissional.
     *
     * Três fontes, nunca somadas: com `escopoDeCliente` (chip da imersiva —
     * `/ia` TEM o chip, ver correção abaixo), a escolha do COMPOSER manda —
     * inclusive quando é "escritório inteiro" (`clienteEscopo` null), que não
     * pode ser sobrescrita por um cliente que só está aberto em outra aba do
     * navegador. Sem o chip (popup, painel do Hub, página cheia), cai no
     * cliente da NAVEGAÇÃO client-centric (`navigation/clientePreFiltro`) — é
     * o que ancora a conversa no cliente que já está na tela (barra lateral)
     * sem precisar da UI de escopo.
     *
     * ★ [spec-016 T035, QA it.3 — corrigido em [T044], G-4 da QA it.5]
     * Terceiro fallback (nos dois ramos, com OU sem `escopoDeCliente`): o
     * cliente que a IA resolveu DENTRO da conversa via `abrir_cliente`
     * (`clienteDaConversaAtualValidado`, computed abaixo). O comentário
     * original dizia que era só o caso "sem `escopoDeCliente`" — MEDIDO
     * incorreto: o `/ia` imersivo (`view-chat-imersivo.vue:752`) monta com
     * `escopo-de-cliente` `true`, e com o chip em "escritório inteiro"
     * (`clienteEscopo` null) o código antigo retornava `null` ANTES de
     * chegar a este fallback — "abre o cliente X" + anexar na MESMA
     * conversa nunca disparava o upload, mesmo com `clienteDaConversaAtual`
     * já populado corretamente pelo handler.
     *
     * `null` fora dos três casos: aí a chave nem entra no corpo, e o payload
     * segue byte a byte o de hoje.
     *
     * ⚠️ Repetir nos turnos seguintes é inofensivo por desenho: o backend só
     * VINCULA na criação (conversa retomada não é re-vinculada), mas ESCOPA o
     * modelo a cada turno — é isso que mantém a conversa falando do mesmo
     * cliente do começo ao fim.
     */
    idClienteEmFoco() {
      if (this.escopoDeCliente) {
        if (this.clienteEscopo && this.clienteEscopo.id) {
          return this.clienteEscopo.id
        }
        return this.idClienteDaConversaValidadoOuNull
      }
      const clientePreFiltro =
        this.$store.getters['navigation/clientePreFiltro']
      if (clientePreFiltro && clientePreFiltro.id) return clientePreFiltro.id

      return this.idClienteDaConversaValidadoOuNull
    },
    /**
     * O cliente que vai em `comando.id_cliente` do ATALHO de negócio —
     * separado do `idClienteEmFoco` acima, e a diferença é o que fecha o
     * G-1 do QA sem contrabandear escolha nenhuma.
     *
     * ★ Só a escolha EXPLÍCITA do consultor na tela conta: o chip "Cliente em
     * foco" (ou, na superfície sem chip, o cliente da navegação
     * client-centric). O terceiro degrau de `idClienteEmFoco` — o cliente que
     * a IA resolveu DENTRO da conversa — fica de fora de propósito: o
     * servidor IGNORA essa âncora ao resolver o cliente do atalho
     * (`core/atalhos/cliente.py`: *"assumir o cliente aberto abriria a
     * carteira de alguém sem o usuário ter pedido"*), e mandá-la aqui a
     * transformaria em escolha explícita pela porta dos fundos — abrindo a
     * preparação de um cliente que ninguém pediu.
     *
     * `null` quando não há escolha: aí a chave nem entra no corpo, e a
     * pergunta do servidor ("de qual cliente é a reunião?") é o desfecho
     * CERTO.
     */
    idClienteFixadoParaOAtalho() {
      if (this.escopoDeCliente) {
        return (this.clienteEscopo && this.clienteEscopo.id) || null
      }
      const clientePreFiltro = this.$store.getters['navigation/clientePreFiltro']
      return (clientePreFiltro && clientePreFiltro.id) || null
    },
    /**
     * As ações do módulo de ATALHOS dentro de `acoesPorModulo` — o catálogo
     * que o servidor já filtrou por papel e escritório, e que esta view
     * recebe pronto da superfície hospedeira.
     *
     * É a fonte do atalho DIGITADO (G-2): só o que a tela OFERECE pode ser
     * invocado por texto. Superfície que não recebe atalhos (popup, painel do
     * Hub, Fee-Based) devolve `[]` e nada é interceptado — `/qualquer coisa`
     * segue pergunta livre, byte a byte o de hoje.
     */
    atalhosDeNegocioDoCatalogo() {
      const modulo = this.acoesPorModulo.find(
        (item) => item && item.moduleKey === MODULE_KEY_ATALHOS_DE_NEGOCIO
      )
      if (!modulo) return []
      return (modulo.acoes || []).filter(
        (acao) => acao && acao.comando && acao.comando.slug
      )
    },
    /**
     * O cliente que RECEBE o anexo — separado do `idClienteEmFoco` acima
     * (teste-11, feedback do owner 09/09/2026).
     *
     * O upload grava carteira em `app_dados_ativos_clientes`: errar o destino
     * é extrato de um cliente no cadastro de outro, e ninguém vê. Medido na
     * conversa `51e550c2` (escritório 90083): o consultor criou o cliente
     * 154723 por engano, criou o 154815 em seguida e anexou o extrato DELE —
     * os 4 uploads foram para o 154723. A causa é o `clienteEscopo` do chip,
     * que o `_onClienteIdentificado` deixa de atualizar quando já há
     * `clienteFixadoManualmente` (guard do G-6, correto para o CHIP): o
     * primeiro cliente da conversa trava o foco e passa a decidir a escrita.
     *
     * Aqui a ordem se inverte: manda a ÚLTIMA identificação da conversa
     * (`clienteDaConversaAtualValidado`) — que é o "esta conversa fala de X"
     * que o próprio `apiChat._onClienteIdentificado` grava SEMPRE, sem
     * guard —, e o chip é o fallback. É a única fonte que acompanha o
     * consultor mudando de cliente no meio da conversa.
     *
     * ⚠️ Isto NÃO troca o escopo do turno nem o chip: `idClienteEmFoco`
     * segue intacto, e o chip continua travado onde o G-6 o deixou. E o
     * composer NOMEIA este destino ao lado dos anexos (`nomeClienteAnexo`) —
     * inverter a precedência sem dizer para onde o arquivo vai trocaria um
     * destino errado silencioso por outro.
     */
    idClienteDoAnexo() {
      return this.idClienteDaConversaValidadoOuNull || this.idClienteEmFoco
    },
    /**
     * O rótulo do destino do anexo, para o composer dizer na tela.
     *
     * Lê o nome da MESMA fonte que decidiu o id acima — um nome vindo de
     * outra fonte poderia nomear um cliente e enviar para outro, que é
     * exatamente o defeito que esta dupla existe para fechar.
     */
    nomeClienteAnexo() {
      const daConversa = this.clienteDaConversaAtualValidado
      if (daConversa && daConversa.id_cliente_app) return daConversa.nome || ''
      const escopo = this.clienteEscopo
      if (escopo && escopo.id) return escopo.name || ''
      return ''
    },
    /** Só o `id_cliente_app` de `clienteDaConversaAtualValidado` — evita repetir o `&&` nos dois ramos acima. */
    idClienteDaConversaValidadoOuNull() {
      const cliente = this.clienteDaConversaAtualValidado
      return (cliente && cliente.id_cliente_app) || null
    },
    /**
     * `clienteDaConversaAtual` (T035), só quando é DESTA conversa — guarda
     * contra qualquer resíduo de uma conversa anterior chegar ao POST da
     * atual ([T044], G-4 da QA it.5).
     *
     * `selectedConversation` ausente (unit test que monta sem selecionar
     * nenhuma conversa, ou o instante entre `novaConversa()`/limpar a lista e
     * reabrir uma) não tem o que comparar — aceitar sem checar é mais seguro
     * que recusar um estado que acabou de chegar corretamente do handler
     * `abrir_cliente`. A recusa só acontece quando HÁ uma conversa selecionada
     * E ela diverge do `conversation_id` do payload.
     */
    clienteDaConversaAtualValidado() {
      const clienteDaConversaAtual =
        this.$store.getters[`${this.ns}/clienteDaConversaAtual`]
      if (!clienteDaConversaAtual) return null
      const conv = this.selectedConversation
      const idDaConversaSelecionada = conv && conv.id ? conv.id : null
      if (!idDaConversaSelecionada) return clienteDaConversaAtual
      if (clienteDaConversaAtual.conversation_id !== idDaConversaSelecionada) {
        return null
      }
      return clienteDaConversaAtual
    },
    clientesDoEscritorio() {
      return this.$store.getters['user/allClients'] || []
    },
    hasMessages() {
      const messages =
        this.$store.getters[`${this.ns}/messages`] || []
      return messages.length > 0
    },
    /**
     * O cliente que a LATERAL mostra.
     *
     * ⚠️ Gateado por `sidebarComoNavegacao` além do escopo: o painel do cliente
     * só existe na configuração imersiva. No popup e na rota cheia a lateral é
     * histórico de conversa, e um painel de cliente ali competiria com o menu de
     * módulos da plataforma, que continua na tela.
     */
    clienteDaLateral() {
      if (!this.sidebarComoNavegacao || !this.escopoDeCliente) return null
      return this.clienteEscopo || null
    },
    // ⚠️ Mudo durante a carga da conversa (14/09/2026, print do usuário): ao
    // trocar para uma conversa com cliente fixado, `hasMessages` ainda é false
    // e o cartão nascia FLUTUANTE sobre o spinner, para depois pular para
    // dentro do trilho quando as mensagens chegavam. Escondido até o fim da
    // carga, ele entra de uma vez, já na casa certa, junto com as mensagens.
    temEscopoNaTela() {
      if (this.carregandoMensagens) return false
      return Boolean(this.escopoDeCliente && this.clienteEscopo)
    },
    /**
     * Cartão de escopo como IRMÃO das mensagens — a casa dele na conversa vazia,
     * e a única casa fora do modo ancorado.
     *
     * No ancorado ele vai FLUTUANDO (ver a classe no template): aparecer/sumir
     * empurrava o herói e o composer 74px. Na rota cheia continua empilhado, que
     * é onde faz sentido ler o contexto antes da conversa.
     */
    escopoAcimaDasMensagens() {
      if (!this.temEscopoNaTela) return false
      return !this.ancorarEstadoVazio || !this.hasMessages
    },
    /**
     * Cartão de escopo como CABEÇALHO do fio, dentro da rolagem.
     *
     * Com a conversa em andamento ele deixa de ser flutuante: pregado na
     * viewport comia altura o tempo todo e a primeira mensagem passava por
     * baixo dele. Dentro da rolagem ele é lido na entrada e sai da tela junto
     * com o começo da conversa — e, por estar no fluxo do scroll, não desloca
     * nada ao aparecer.
     */
    escopoNaConversa() {
      return Boolean(
        this.temEscopoNaTela && this.ancorarEstadoVazio && this.hasMessages
      )
    },
    chatLoading() {
      return this.$store.getters[`${this.ns}/chatLoading`]
    },
    /**
     * [STRESS r2, N-1] O composer usa ISSO, não `chatLoading` cru, para
     * decidir se o botão de enviar vira "parar" (`send-message.vue::
     * aoClicarEnviar`/`canSend`). Medido ao vivo: `chatLoading` (a STORE,
     * fechada por `end`/`error`/queda de conexão) caía a `false` em ~9s
     * numa tool longa que ainda rodava — mas `enviando` (esta view, trava
     * LOCAL que só solta no `finally` de `enviarMensagem`, quando
     * `apiChat.sendMessage(...)` finalmente RESOLVE) continuava `true` a
     * viagem inteira. Nessa janela o botão lia "pronto para enviar" e todo
     * clique caía no `return` mudo do guard — texto intocado no campo,
     * nenhum aviso, por até um minuto (o resto da tool longa).
     *
     * A UNIÃO dos dois cobre a janela: com `enviando` ainda `true`, o botão
     * mostra "parar" (verdadeiro — o turno segue em voo) em vez de "pronto".
     * Clicar chama `onAbort` → `cancelarStream` → `apiChat.cancelRequest`,
     * que cancela o fetch em voo; `iaCrmRequest` captura o `AbortError` e
     * devolve o envelope 499 SEM lançar (`utils/api.js::foiCancelado`), então
     * a Promise de `sendMessage` RESOLVE — o `finally` de `enviarMensagem`
     * solta `enviando` normalmente, e o gestor pode digitar de novo na hora.
     */
    turnoEmVoo() {
      return this.chatLoading || this.enviando
    },
    // spec-016 T004 — voz da IA no Modo de Voz (US-1). Lida do MESMO
    // `storeState` que `despacharMensagem` já usa para `selectedModel`/
    // `thinkingEnabled` (namespace fixo — este módulo não é o `SendMessage`
    // genérico compartilhado com Fee-Based/ai-framework). `''` (nada
    // escolhido) é o AC2: o pedido de síntese não leva `voice_id`.
    vozSelecionadaAtual() {
      const storeState = this.$store.state[this.ns] || {}
      return storeState.vozSelecionada || ''
    },
    personaMode() {
      return this.$store.getters[`${this.ns}/personaMode`]
    },
    selectedConversation() {
      return this.$store.getters[`${this.ns}/selectedConversation`]
    },
    /**
     * ★ spec-008 [T030c] — a superfície que esta tela DECLARA à voz em tempo
     * real, e que a rota exige (`SUPERFICIES_CONHECIDAS`).
     *
     * Vazia em toda configuração que NÃO é a IA Operacional em tela cheia: o
     * popup (`widget`) e o painel embutido (`embedded`) montam ESTE MESMO
     * componente, e declarar superfície por eles abriria sessão PAGA de uma
     * tela que ninguém mandou abrir.
     *
     * ★ [T046] Com a D-O-4 o tempo real virou o PADRÃO e a D-9 foi revogada —
     * isto aqui **não é mais chave de rollout**. Continua valendo porque é
     * DECLARAÇÃO: superfície vazia ⇒ `abrir` recusaria com
     * `MOTIVO_SEM_SUPERFICIE`, então o Modo de Voz desses composers segue byte
     * a byte pelo caminho por turnos, sem gastar uma queda por clique no
     * microfone. Pôr uma tela nova no tempo real é declarar a superfície dela.
     */
    superficieDeVozTempoReal() {
      if (this.widget || this.embedded) return ''
      if (this.persona !== PERSONA_IA_OPERACIONAL) return ''
      return SUPERFICIE_IA_OPERACIONAL
    },
    // A conversa a que a sessão de voz pertence. Conversa nova ainda não tem
    // id — e o contrato trata `idConversa` como opcional justamente por isso
    // (`apiVoz.abrirSessaoTempoReal`: omitir ≠ mandar `null`).
    idConversaDeVoz() {
      const conv = this.selectedConversation
      return conv && conv.id ? String(conv.id) : ''
    },
    // `messagesLoading` entra aqui pelo mesmo motivo que entrou no `messages.vue`:
    // durante a carga de uma conversa a lista esta vazia, e sem esta condicao o
    // `composerNoHeroi` virava true e o composer saltava para o meio da tela
    // antes de voltar para o rodape.
    showEmptyState() {
      if (this.carregandoMensagens) return false
      return !this.hasMessages && !this.chatLoading
    },
    carregandoMensagens() {
      return this.$store.getters[`${this.ns}/messagesLoading`]
    },
    /**
     * A busca global tem as MESMAS condições da topbar do Nav 2026
     * (`!deveVerSoFeeFixo && !IS_CLIENTE`): sem elas o palette abre e fecha sem
     * mostrar nada, e o botão vira um clique morto.
     *
     * O gate mora aqui e desce por prop porque a `chat-sidebar` não lê
     * `$currentUser` nem `$access` de propósito — é o que a mantém montável sem
     * sessão no teste. Mesmo padrão de `insights`.
     */
    buscaGlobalDisponivel() {
      const user = this.$currentUser()
      return !deveVerSoFeeFixo(user) && !user.IS_CLIENTE
    },
    agentesVisiveisDoEscritorio() {
      return agentesVisiveis(this.$access)
    },
    // ★ Só o `widget` desliga o layout fundido — o `embedded` não mais.
    //
    // `embedded` significa "estou hospedado dentro de uma página, me dá altura
    // explícita e não trave o overflow do ancestral". Ele acabou significando
    // TAMBÉM "use o desenho pré-redesign", e o efeito era visível: a rota
    // `/solicitacoes/consultor` continuava com a sidebar num card de 320px com
    // borda enquanto a rota cheia já usava a sidebar fundida — a mesma tela, com
    // dois desenhos, dependendo de por onde se chegava.
    //
    // O `widget` continua fora: em 420-640px a sidebar fundida não cabe, e é por
    // isso que popup e painel lateral a escondem.
    usaLayoutFundido() {
      return !this.widget
    },
    // No estado vazio da rota cheia o composer sobe pro slot do herói, como no
    // protótipo. Nos demais casos ele fica no rodapé.
    // Fundido: sem borda de card, o contraste com a sidebar quente já separa.
    // Fora dele, mantém o az-card-bordered de hoje.
    classeAreaPrincipal() {
      if (this.usaLayoutFundido) return 'intelligence-v2-chat__main--fundido'
      return {
        'az-card-bordered': true,
        'intelligence-v2-chat__main--widget': this.widget,
      }
    },
    // O disclaimer mora no RODAPÉ da coluna, não sob o balão: no estado vazio o
    // composer fica no meio da tela, e o aviso colado nele flutuava no vácuo.
    // No layout fundido o texto vem do composer (vale para qualquer persona —
    // a IA Operacional tem `aviso: null`); fora dele, é o aviso da persona.
    mostraPersonaAviso() {
      return this.usaLayoutFundido || this.temAviso
    },
    textoPersonaAviso() {
      if (this.usaLayoutFundido) return COMPOSER_CHAT.disclaimer
      return this.personaAtual.aviso
    },
    // Ponte da constante para o template (a faixa do trilho quebrado usa duas
    // chaves dela) — constante de módulo não é alcançável do `<template>`.
    TEXTO_COMPOSER() {
      return COMPOSER_CHAT
    },
    /**
     * [feedback do usuário, 04/09] "ao clicar no iniciar modo de voz,
     * deveria iniciar a conversa... expandir mesmo como se eu tivesse
     * mandando mensagem" — sem o `&& !vozExpandeParaRodape`, começar a
     * falar no herói (tela vazia) só expandia quando o turno de voz
     * TERMINAVA e virava mensagem de verdade (`hasMessages`/`chatLoading`).
     * Aqui a troca acontece no CLIQUE, e não interrompe a gravação porque
     * ela vive em `motorDeVoz` (`utils/motor-de-voz.js`), fora de QUALQUER
     * instância deste composer — herói e rodapé são instâncias diferentes,
     * trocadas por `v-if` logo abaixo.
     */
    vozExpandeParaRodape() {
      return motorDeVoz.gravando && motorDeVoz.modoDeVoz
    },
    /**
     * ★ [spec-008 T061] Só para o watcher de rolagem — a sessão de voz é o
     * que faz o rodapé mudar de altura (o indicador entra e sai com ela).
     *
     * Lê o MESMO campo que governa o indicador no composer
     * (`motorDeVoz.sessaoDeVozAtiva`, `send-message.vue::estadoVisualDoOrb`),
     * nunca uma flag paralela desta view: duas fontes para o mesmo fato
     * divergiriam no primeiro caminho de saída que esquecesse uma delas.
     */
    sessaoDeVozAtiva() {
      return motorDeVoz.sessaoDeVozAtiva
    },
    composerNoHeroi() {
      return (
        this.usaLayoutFundido && this.showEmptyState && !this.vozExpandeParaRodape
      )
    },
    // Aviso e composer entram no MESMO trilho de 768px da conversa — fora dele
    // o composer estica de ponta a ponta e descola da coluna de mensagens. O
    // composer do herói não entra: o estado vazio é 672px de propósito.
    classeTrilhoRodape() {
      return this.usaLayoutFundido ? 'ia-chat-trilho' : ''
    },
    // Conversa com histórico: modelo e agente ficam fixos nela. O lock do
    // agente é do BACKEND — `usecase_ia_crm_chat.py` sobrescreve a persona
    // recebida ao retomar, então trocar aqui seria ignorado em silêncio.
    conversaTravada() {
      const conv = this.selectedConversation
      return !!(conv && conv.id && this.hasMessages)
    },
    isModelLocked() {
      return this.conversaTravada
    },
    agenteTravado() {
      return this.conversaTravada
    },
    // ⚠️ [spec-009 T007] Deixou de seguir `conversaTravada` (havia
    // mensagens). O cliente agora tem lock PRÓPRIO, por VÍNCULO real — não
    // por a conversa ter histórico: `id_cliente_app` "só vale na criação ou
    // na primeira resolução — nunca reescrito por tool" (docstring do
    // `usecase_ia_crm_chat`), e o front espelha essa régua por
    // `clienteFixadoManualmente` (a mesma peça do guard do T006), NÃO pela
    // mera presença de `clienteEscopo` no chip.
    //
    // Conversa que ainda NÃO EXISTE no banco (`selectedConversation` nulo, ou
    // sem `.id` — o primeiro turno) nunca trava aqui: o vínculo, se houver
    // escolha, entra no INSERT (`idClienteApp` no corpo do POST, como hoje) —
    // e até lá o consultor pode trocar de cliente à vontade, igual sempre foi
    // antes da 1ª mensagem.
    // Régua movida para o store — era
    // duplicada byte a byte aqui e em `ia-palette.vue::clienteTravadoPorVinculo`.
    // Ver `store/getters.js::escopoClienteTravado`.
    escopoTravado() {
      return this.$store.getters[`${this.ns}/escopoClienteTravado`]
    },
  },
  // Sincronia com um seletor de agente que vive FORA desta tela — hoje o do
  // historico do popup, que cobre o composer e por isso tem o seu proprio.
  // Nao da para derivar o agente da persona: `painel` e `consultor` COMPARTILHAM
  // `CONSULTOR_ESTRATEGICO` (ver `Agentes.js`), entao persona nao identifica o
  // agente e escolher "Consultor" cairia em "Multi-agente". Dai a prop com o id.
  // O guard de igualdade impede o laco com o `agent-change` que emitimos abaixo.
  watch: {
    /**
     * Trocar de conversa é trocar de MOTOR e de NAMESPACE.
     *
     * Os provedores (tela, execução, voz) fecham sobre esta view mas vivem
     * DENTRO do motor; ao mudar de motor, os do antigo têm de sair, senão o
     * `POST` da conversa velha sairia com o contexto da nova. É o mesmo par
     * `registrar`/`desregistrar` do `created`/`beforeDestroy`, só que no meio
     * do caminho.
     */
    idConversaViva() {
      this._trocarDeConversaViva()
    },
    // ★ Trocar o cliente em foco REESCREVE o histórico da lateral. Sem isto a
    // lista continuaria a do foco anterior — e "focar" pareceria não fazer
    // nada, que é exatamente a queixa que originou esta mudança.
    //
    // Só na superfície que tem seletor de cliente: o store é compartilhado, e
    // recarregar daqui mexeria na lista do popup e do painel do Hub.
    idClienteEmFoco() {
      if (!this.escopoDeCliente) return
      this.carregarConversas()
    },
    agenteId(novo) {
      if (!novo || novo === this.agenteAtivoId) return
      this.irParaAgente(novo)
    },
    // O guard de uma-vez-só (`perguntaInicialAplicada`) cobre a MONTAGEM. Numa
    // superfície que fica montada — o painel do Hub —, o gestor clica um
    // segundo chip com o chat já aberto e a pergunta chega por troca de prop.
    // Só vale no modo de envio automático: no modo prefill, sobrescrever o
    // composer apagaria o que ele já estivesse escrevendo.
    perguntaInicial(texto) {
      if (!this.enviarPerguntaInicial) return
      this.despacharPerguntaInicial(texto)
    },
    /**
     * ★ [spec-008 T061] A voz entra e sai ⇒ o rodapé muda de ALTURA, e o fim
     * da conversa precisa continuar no fim.
     *
     * O indicador de voz passou a ocupar espaço próprio em vez de pousar
     * sobre as mensagens (`composer-voz-orb.vue`), então o composer cresce
     * ~60px ao abrir a sessão e encolhe outro tanto ao encerrar. A área de
     * mensagens (irmã `flex-grow: 1`) acompanha sozinha — mas o
     * `ResizeObserver` de `messages.vue` observa o TRILHO (o conteúdo), não o
     * container: conteúdo que não mudou não dispara nada, e as últimas linhas
     * saíam da vista sem ninguém as trazer de volta.
     *
     * `scrollToBottom` do filho é o lugar certo porque ele já tem a guarda
     * que importa: `isPinnedToBottom`. Quem rolou para cima de propósito não
     * é puxado de volta — nem aqui nem em nenhum outro chamador.
     */
    sessaoDeVozAtiva() {
      this.$nextTick(() => {
        const mensagens = this.$refs.mensagens
        if (mensagens && typeof mensagens.scrollToBottom === 'function') {
          mensagens.scrollToBottom()
        }
      })
    },
    /**
     * ★ A URL da conversa sai DAQUI, e o gatilho é o STORE — não o clique.
     *
     * A conversa ganha id por três caminhos, e só um deles passa por método
     * desta view: o clique na lista (`selecionarConversa`), o `start` do SSE no
     * Modo Chat (`apiChat.js`, `setSelectedConversation`) e a resposta síncrona
     * do `POST /runs` no Modo Agente (`apiChatModoAgente.js`). Emitir de dentro
     * de `selecionarConversa` cobriria o primeiro e perderia os dois que
     * importam mais: é neles que nasce a conversa que o consultor acabou de
     * começar — justamente a que ele quer endereçar.
     *
     * `null` quando não há conversa (a tela em repouso, ou logo após
     * `novaConversa()`): quem ouve devolve a URL para a rota sem conversa.
     */
    selectedConversation(conversa, anterior) {
      const id = (conversa && conversa.id) || null
      // ★ [SHOULD do review do PR #2342] A dispensa da apresentação morre com
      // a conversa que a recebeu — e quem a zera é ESTE watcher, não só quem
      // troca de conversa DENTRO da view.
      //
      // ⚠️ O popup e o painel do Hub montam esta view mas abrem a conversa por
      // FORA dela: `mixins/historico-conversas.js::selecionarConversa` despacha
      // `setSelectedConversation` direto no store, sem passar por
      // `sairDaConversaAtual`. A dispensa atravessava a troca nessas duas
      // superfícies e destravava o composer no meio do roteiro da conversa
      // seguinte — o mesmo defeito que a correção de 19/09 fechou só na rota
      // imersiva.
      //
      // ⚠️ A guarda é `idAnterior && !==`, nunca "o id mudou": a conversa NOVA
      // ganha id no `start` do SSE (null → X), e resetar ali desfaria a
      // dispensa que a pessoa acabou de dar NESTA mesma conversa.
      const idAnterior = (anterior && anterior.id) || null
      if (idAnterior && idAnterior !== id) this.apresentacaoDispensada = false
      // ★ [20/09/2026] Esta aba já tem conversa no servidor: o id LOCAL dela
      // está gasto. A marca vive na VIVA, não aqui — a view não remonta na
      // troca de aba, e um latch de instância era rearmado por ela. Marcar
      // AQUI (e não em `novaConversa`) cobre também o caminho em que a
      // conversa é apagada: lá `selectedConversation` já voltou a `null`
      // antes de qualquer gesto de "nova conversa".
      if (id && this.vivaAtual) this.vivaAtual.idLocalGasto = true
      // ★ [19/09/2026] AMARRA a conversa viva ao id que o servidor deu. Este é
      // o instante exato em que o ACK chega: `apiChatModoAgente::aceitarRun`
      // seleciona a conversa com `value.id_conversa` da resposta SÍNCRONA do
      // `POST /runs`, antes de qualquer evento do SSE.
      //
      // Vem ANTES do `$emit`, e a ordem é o ponto inteiro: quem ouve o
      // `conversa-ativa` é a imersiva, que sincroniza a URL — e ela precisa
      // encontrar a viva JÁ amarrada, senão abre uma aba a mais para a mesma
      // conversa (medido na tela em 18/09: dois envios, quatro abas).
      if (this.vivaAtual && id) amarrarAoServidor(this.vivaAtual.idLocal, id)
      // Duas seleções seguidas da MESMA conversa são objetos diferentes com o
      // mesmo id (`selecionarConversa` recebe o item da lista recarregada) — o
      // watcher dispara, mas o endereço não mudou. Sem esta guarda, quem ouve
      // empilharia uma entrada de histórico por recarga de lista.
      if (id === this._idDaConversaAnunciado) return
      this._idDaConversaAnunciado = id
      this.$emit('conversa-ativa', id)
    },
    // Voltar/avançar no browser troca o PARÂMETRO da rota sem remontar o
    // componente (é a mesma rota nomeada). Sem isto a URL mudava e a tela
    // ficava na conversa anterior — a barra de endereço passaria a mentir.
    idDaConversaDaRota(id) {
      this.abrirConversaDaRota(id)
    },
  },
  created() {
      // ★ [conversas paralelas] PRIMEIRA coisa do ciclo de vida: `ns` e
      // `motor` dependem dela, e o registro dos provedores logo abaixo já
      // precisa do motor CERTO. Sem `idConversaViva` nada muda: `vivaAtual`
      // fica `null` e os dois caem no namespace/motor únicos.
      this._abrirConversaVivaSePedida()
    // Os quatro provedores do motor (tela, execução, voz) fecham sobre ESTA
    // view — guardados para o `beforeDestroy` desregistrar só o que é dela.
    this._provedoresDoApiChat = registrarProvedoresDoApiChat(
        this.motor, this, this.ns)
    // A prop VENCE a derivação por persona. `agenteIdPorPersona` devolve o
    // PRIMEIRO agente do catálogo com aquela persona, e `painel` e `consultor`
    // compartilham `CONSULTOR_ESTRATEGICO` — como `painel` vem antes, quem
    // pedia a persona do Consultor caía no Multi-agente, contradizendo o rótulo
    // da tela de onde veio. O watcher abaixo só cobre TROCA de agente, não a
    // montagem, então a correção tem que ser aqui.
    this.agenteAtivoId = this.agenteId || agenteIdPorPersona(this.persona)
    this.publicarAgenteAtivo()
    this.descartarConversaDeOutraPersona()
    // Publica a persona no store antes de qualquer carga: `messages` e `conversations`
    // são containers conectados e leem daí.
    this.$store.dispatch(`${this.ns}/setPersona`, this.personaEfetiva)
    this.abrirConversaInicial()
    this.carregarSugestoes()
    this.carregarAtalhos()
    // A lista alimenta o seletor de escopo. `carregar()` é idempotente (guarda
    // `this.loading`), então chamar aqui não duplica o request de quem já a
    // carregou — mesmo padrão de `cliente-sidebar.vue`.
    if (this.escopoDeCliente && !this.clientesDoEscritorio.length) {
      apiListaClientes.carregar()
    }
    this.aplicarPerguntaInicial()
  },
  mounted() {
    // Só na página cheia: widget (popup embutido) e embedded (dentro de outra
    // tela) não são donos do scroll da janela — travar ancestrais ali quebraria
    // o scroll da página hospedeira. Mesmo padrão de view-atendimento.vue /
    // view-crm-emails.vue: sem isso, qualquer ancestral sem min-height:0 no
    // caminho flexbox deixa a JANELA rolar em vez do card interno.
    if (!this.widget && !this.embedded) this.lockAncestorOverflow()
    this.assinarAtalhosDaBuscaGlobal()
    // ★ merge PR #2242 — [T043-4/US-5] reidrata o run da conversa já
    // selecionada (reload/remount): sem isto o chip e as mensagens do Modo
    // Agente congelam no instante do mount e só descongelam com mensagem nova.
    this.reidratarRunSeJaSelecionada()
  },
  beforeDestroy() {
    // ★ [T024], achado 2 do E2E. A tool de front AUTOMÁTICA navega, e a
    // navegação destrói esta view no meio do turno. Descartar aqui cancelava o
    // POST da continuação que o próprio turno pediu: o gestor via, sobre a
    // ficha recém-aberta, "a conversa não foi salva" — com as duas mensagens do
    // assistente já no banco.
    //
    // Quem consome o stream é o `APIChat` e quem guarda o resultado é a store;
    // nenhum dos dois depende desta view. Sair da tela no meio de uma
    // continuação é sair da tela, não cancelar o turno.
    //
    // ★ [A-147] E a espera por DECISÃO também não é turno em andamento. Em
    // `awaiting_approval` o relay fica aberto em heartbeat, então
    // `chatLoading` continua `true` — quem só olhasse para ele descartaria o
    // turno em QUALQUER desmontagem (troca de layout, rota, remount do shell)
    // e levaria junto as partes de tool, que é de onde o CARTÃO de confirmação
    // vive: o consultor voltava para a tela com o chip anunciando "1 proposta
    // aberta" e nada para decidir. Medido em produção em 19/09/2026 (run
    // `b0a72965`). A proposta sobrevive no servidor por 30 min; descartá-la
    // aqui é jogar fora o trabalho que ele mandou fazer.
    if (this.chatLoading && !this.motor.temContinuacaoDeToolDeFront() && !this.runAguardandoDecisao) {
      this.descartarTurnoEmAndamento()
    }
    desregistrarProvedoresDoApiChat(this.motor, this._provedoresDoApiChat)
    // O anexo pendente é desta view: não pode reaparecer na próxima.
    descartarFilasComPrefixo(PREFIXO_FILA_DE_ANEXOS + this._uid)
    this.unlockAncestorOverflow()
    this.desassinarAtalhosDaBuscaGlobal()
  },
  methods: {
    /**
     * A conversa QUEBROU no render (`messages.vue` → `errorCaptured`).
     *
     * A partir daqui a tela mostra o erro no lugar do trilho, a faixa
     * bloqueante aparece sobre o composer e `enviarMensagem` recusa —
     * porque o pior estado possível é o que o QA mediu: tela vazia que
     * ACEITA pergunta, manda ao backend e cobra sem renderizar.
     */
    onErroNoTrilho() {
      this.trilhoQuebrado = true
    },
    // Isolado para o teste poder espiar sem navegar o jsdom. Recarregar é o
    // único caminho honesto: o estado do componente e o do turno já são
    // indefinidos quando chegamos aqui.
    recarregarAPagina() {
      window.location.reload()
    },
    /**
     * O id da conversa viva desta instância: a prop própria ou, na imersiva,
     * o que a URL diz. Uma fonte só — senão as duas portas divergem e a tela
     * mostra uma conversa enquanto o motor fala por outra.
     */
    _idDaConversaViva() {
      return this.idConversaViva || ''
    },
    /** Abre a conversa viva pedida (ou nenhuma). Só o `created` chama. */
    _abrirConversaVivaSePedida() {
      const id = this._idDaConversaViva()
      this.vivaAtual = id
        ? abrirConversaViva({ idLocal: id, store: this.$store })
        : null
    },
    /**
     * O `conversation_id` que vai no turno — UMA fonte para os três envios.
     *
     * ★ [conversas paralelas, 18/09/2026] Com conversa selecionada, é o id
     * dela, como sempre foi. SEM conversa selecionada e COM conversa viva, vai
     * o **id local da viva** — e é esse detalhe que faz o modo paralelo
     * funcionar de verdade.
     *
     * O que acontecia mandando `null` (medido NA TELA em 18/09: dois envios
     * viraram QUATRO abas): o backend criava a conversa com id PRÓPRIO, a view
     * anunciava esse id em `conversa-ativa`, a rota passava a segui-lo, e a
     * imersiva — vendo na URL uma conversa que não estava viva — abria uma aba
     * a mais para ela. O id local ficava órfão, a aba original ficava vazia e a
     * resposta aparecia na aba errada.
     *
     * O backend ACEITA o id do cliente desde o PR #1834
     * (`usecase_ia_crm_chat.py`: `uuid.UUID(x)` + `str(UUID(x)) == x.lower()`,
     * e em colisão cai para um id de servidor) — e `novoIdDeConversa()` gera
     * exatamente o UUID canônico minúsculo que ele exige. Sem conversa viva
     * devolve `null`, byte a byte o comportamento de antes.
     */
    _idDaConversaParaOTurno() {
      const conv = this.selectedConversation
      if (conv && conv.id) return conv.id
      // Gasto o id local (ver `idLocalGasto` no registro), `null` faz o
      // servidor abrir conversa NOVA em vez de continuar — ou recusar — a
      // velha. O fato mora na viva justamente para sobreviver à troca de aba.
      if (!this.vivaAtual || this.vivaAtual.idLocalGasto) return null
      return this.vivaAtual.idLocal
    },
    /**
     * Troca de conversa viva: os provedores do motor ANTIGO saem, os do novo
     * entram.
     *
     * ★ A guarda de "não mudou" não é otimização: o watcher dispara em
     * qualquer escrita da prop, inclusive a que repete o valor, e sem ela o
     * segundo passo desregistraria os provedores que o primeiro acabou de
     * registrar — o `POST` seguinte sairia sem contexto de tela nenhum.
     */
    _trocarDeConversaViva() {
      const id = this._idDaConversaViva()
      const atual = (this.vivaAtual && this.vivaAtual.idLocal) || ''
      if (id === atual) return
      desregistrarProvedoresDoApiChat(this.motor, this._provedoresDoApiChat)
      this.vivaAtual = id
        ? abrirConversaViva({ idLocal: id, store: this.$store })
        : null
      this._provedoresDoApiChat = registrarProvedoresDoApiChat(
        this.motor, this, this.ns)
    },
    /**
     * A busca global (Ctrl/Cmd+K) troca de agente e reabre conversa na visão
     * imersiva, onde a lateral não tem mais campo de busca. Ela vive em outra
     * árvore (`global-modals.vue`), então fala por bus.
     *
     * ⚠️ SÓ na configuração imersiva. Duas instâncias do chat no mesmo namespace
     * disputam `chatLoading`, `responseTokens` e o `abortController` único do
     * `apiChat` — é por isso que o popup é desligado na `/ia`. Assinar em todas
     * faria a troca atingir uma instância que o usuário nem está vendo.
     */
    assinarAtalhosDaBuscaGlobal() {
      if (!this.sidebarComoNavegacao) return
      GlobalBus.$on(
        CHAT_IA_EVENTOS.ESCOLHER_AGENTE,
        this.onEscolherAgenteNaSidebar
      )
      GlobalBus.$on(CHAT_IA_EVENTOS.ABRIR_CONVERSA, this.abrirConversaPorId)
      GlobalBus.$on(CHAT_IA_EVENTOS.NOVA_CONVERSA, this.novaConversa)
      GlobalBus.$on(
        CHAT_IA_EVENTOS.ESCOLHER_CLIENTE,
        this.onEscolherClienteFora
      )
      GlobalBus.$on(CHAT_IA_EVENTOS.FOCAR_COMPOSER, this.focarComposer)
      GlobalBus.$on(CHAT_IA_EVENTOS.ANEXAR_ARQUIVOS, this.abrirAnexosNoComposer)
      // ★ [spec-005, US-6] A resposta de um cartão aberto no PAINEL DE
      // ARTEFATO. O painel é irmão desta view (`view-chat-imersivo.vue`), não
      // filho — ver o comentário de `RESPONDER_CARTAO` em `constants/Text.js`.
      // Mesma gate das assinaturas acima (`sidebarComoNavegacao`): a imersiva
      // é a única superfície com painel.
      GlobalBus.$on(CHAT_IA_EVENTOS.RESPONDER_CARTAO, this.responderCartao)
      // ★ [MUST-2 do review do PR #2319] O Ctrl/Cmd+Shift+O mora AQUI, depois
      // do gate acima, e não solto no `mounted`. Ele é atalho de `document`:
      // registrado em toda instância, uma tecla atingia também o popup/widget
      // montado fora da vista — `novaConversaEFocar()` descartaria a conversa
      // corrente dele e mexeria no `abortController` ÚNICO do `apiChat`, que é
      // exatamente o cenário que o comentário deste método declara proibido.
      document.addEventListener('keydown', this.aoTeclarAtalhoDeNovaConversa)
    },
    // Ctrl/Cmd+Shift+O — o atalho de "nova conversa" que os chats de IA usam.
    // Vale mesmo com o foco no composer (é o gesto de começar de novo), e por
    // isso o `preventDefault`: no Firefox o Ctrl+Shift+O abre os favoritos.
    ehAtalhoDeNovaConversa(event) {
      if (!event || event.isComposing || event.keyCode === KEYCODE_COMPOSICAO_IME) return false
      if (!event.ctrlKey && !event.metaKey) return false
      if (!event.shiftKey || event.altKey) return false
      return String(event.key).toLowerCase() === TECLA_NOVA_CONVERSA
    },
    aoTeclarAtalhoDeNovaConversa(event) {
      if (!this.ehAtalhoDeNovaConversa(event)) return
      event.preventDefault()
      this.novaConversaEFocar()
    },
    desassinarAtalhosDaBuscaGlobal() {
      GlobalBus.$off(
        CHAT_IA_EVENTOS.ESCOLHER_AGENTE,
        this.onEscolherAgenteNaSidebar
      )
      GlobalBus.$off(CHAT_IA_EVENTOS.ABRIR_CONVERSA, this.abrirConversaPorId)
      GlobalBus.$off(CHAT_IA_EVENTOS.NOVA_CONVERSA, this.novaConversa)
      GlobalBus.$off(
        CHAT_IA_EVENTOS.ESCOLHER_CLIENTE,
        this.onEscolherClienteFora
      )
      GlobalBus.$off(CHAT_IA_EVENTOS.FOCAR_COMPOSER, this.focarComposer)
      GlobalBus.$off(
        CHAT_IA_EVENTOS.ANEXAR_ARQUIVOS,
        this.abrirAnexosNoComposer
      )
      GlobalBus.$off(CHAT_IA_EVENTOS.RESPONDER_CARTAO, this.responderCartao)
      // Incondicional, como os `$off` acima: remover um listener que nunca foi
      // registrado (superfície sem `sidebarComoNavegacao`) é no-op.
      document.removeEventListener('keydown', this.aoTeclarAtalhoDeNovaConversa)
    },
    /**
     * Devolve o cursor ao campo do composer — preparado para escrever, é ali
     * que a pessoa vai digitar. O `focarCampo()` do `SendMessage` é o mesmo que
     * os menus do próprio composer já usam.
     *
     * ⚠️ O ref é resolvido DENTRO do `$nextTick`, não antes: são duas
     * instâncias mutuamente exclusivas (herói e rodapé, por `composerNoHeroi`) e
     * a ação que chega aqui costuma justamente TROCAR qual delas está montada —
     * abrir conversa monta a do rodapé, conversa nova monta a do herói. Lido
     * cedo demais, o ref aponta para a instância que está sendo destruída.
     */
    focarComposer() {
      this.$nextTick(() => {
        const composer = this.$refs.composerHeroi || this.$refs.composerRodape
        // ⚠️ Confere o MÉTODO, não só o ref: o foco roda dentro do `$nextTick`,
        // então um `composer.focarCampo is not a function` estoura ASSÍNCRONO
        // — fora de qualquer `try` de quem chamou, e o handler padrão do Vue o
        // transforma em `console.error` (que o `setup.js` converte em falha).
        // Foco é acabamento; ele nunca pode derrubar a ação que o pediu.
        if (composer && typeof composer.focarCampo === 'function') {
          composer.focarCampo()
        }
      })
    },
    /**
     * Abre o seletor de arquivos, pedido pelo palette (Ctrl+K).
     *
     * Mesma resolução de ref do `focarComposer`: os dois composers vivem em
     * ramos `v-if` exclusivos (herói no estado vazio, rodapé com mensagens),
     * então um dos dois resolve e o outro é `undefined`.
     *
     * Sem `$nextTick`: aqui não há troca de estado esperando render — o
     * composer já está montado quando o palette fecha. E `abrirAnexos` do lado
     * de lá já recusa sozinho quando o anexo está travado ou a fila cheia.
     */
    abrirAnexosNoComposer() {
      const composer = this.$refs.composerHeroi || this.$refs.composerRodape
      if (composer) composer.abrirAnexos()
    },
    /**
     * Seta para baixo no campo leva o foco às ações abaixo dele.
     *
     * O composer entra por SLOT no `empty-messages`, então ele e as ações são
     * irmãos que não se enxergam — quem os liga é esta view. A volta é o
     * `@focar-composer`, que reusa o `focarComposer` acima.
     *
     * ⚠️ Só existe no estado VAZIO: com mensagens na tela o `EmptyMessages` não
     * está montado, e o ref simplesmente não resolve. O `send-message` emite de
     * qualquer forma, e é aqui que o pedido morre sem efeito.
     */
    descerParaAcoes() {
      const estadoVazio = this.$refs.estadoVazio
      if (estadoVazio) estadoVazio.focarPrimeiraAcao()
    },
    // Os dois gestos da lateral que preparam alguém para escrever. Envolvem em
    // vez de focar dentro de `novaConversa`/`selecionarConversa`: aqueles dois
    // também rodam na montagem da tela e na troca de persona, e roubar o foco
    // ali moveria a página sem ninguém ter pedido.
    novaConversaEFocar() {
      if (this.pediuAbaNova()) return
      this.novaConversa()
      this.focarComposer()
    },
    /**
     * "Nova conversa" com as ABAS ligadas: abre uma ABA, não reseta esta.
     *
     * ⚠️ [owner, 20/09/2026] *"pq ao clicar no botão de + dentro da navbar, que
     * antes abria uma nova conversa, hoje até abre mas o nome da aba continua
     * sendo a anterior? não deveria abrir uma nova aba então?"*.
     *
     * Ele tem razão nas duas metades. O "+" da lateral chamava `novaConversa()`,
     * que ZERA o módulo da aba ATUAL — a conversa some da tela mas a aba
     * continua sendo a mesma, com o nome que já tinha. Com as abas na tela isso
     * é incoerente: existem dois gestos de "nova conversa" (o da lateral e o da
     * barra) e eles faziam coisas diferentes.
     *
     * Agora os dois passam pela MESMA porta — `abrirNovaConversaViva` na
     * superfície dona das abas, que já sabe reaproveitar uma aba em branco
     * (nunca duas "Nova conversa"). Fora dela ninguém escuta o evento e o
     * `novaConversa()` de sempre acontece, byte a byte: é o caminho do popup,
     * do painel do Hub e da `/home-ia` com o kill-switch desligado.
     *
     * @returns {Boolean} `true` quando a aba nova foi pedida e o reset daqui
     *   não deve acontecer.
     */
    pediuAbaNova() {
      // ⚠️ A pergunta é a PROP, não `$listeners`: o listener do template existe
      // sempre, inclusive com o kill-switch das abas desligado — e aí o gesto
      // tem de voltar a ser o `novaConversa()` de sempre.
      if (!this.conversasEmAbas) return false
      if (!this.vivaAtual) return false
      this.$emit('abrir-conversa-viva')
      this.focarComposer()
      return true
    },
    selecionarConversaEFocar(conversation) {
      this.selecionarConversa(conversation)
      this.focarComposer()
    },
    /**
     * Cliente escolhido no palette (o chip perdeu o dropdown na `/ia`).
     *
     * ⚠️ Passa pelo MESMO gate do chip: sem seletor de escopo nesta superfície,
     * ignora. A store é compartilhada com o popup e o painel do Hub, e escrever
     * `clienteEscopo` de fora vazaria para eles.
     *
     * [bug do owner, 07/09 23:47Z] Travava por `conversaTravada` (a conversa
     * TEM MENSAGENS?) — régua ANTERIOR à T007/G-2, que introduziram o travamento
     * por VÍNCULO real (`escopoTravado`). Uma conversa com histórico e SEM
     * vínculo tem `conversaTravada === true` e `escopoTravado === false`: o
     * palette (destravado pelo G-2) deixava escolher, mas este handler
     * silenciosamente descartava a escolha antes de chamar `onTrocarEscopo` —
     * chip continuava "Todo o escritório" e os anexos pendentes não subiam
     * (o upload depende de `idClienteEmFoco`, que só muda quando
     * `onTrocarEscopo` roda). `escopoTravado` é a MESMA régua que o chip da
     * barra usa (`:travado="escopoTravado"`) e que o próprio `onTrocarEscopo`
     * já confere para decidir se persiste no servidor — travar aqui com outro
     * critério reabria em silêncio o que aquele guard já resolve.
     */
    onEscolherClienteFora(cliente) {
      if (!this.escopoDeCliente || this.escopoTravado) return
      this.onTrocarEscopo(cliente || null)
    },
    // O palette manda o id; quem sabe o objeto inteiro é a store daqui.
    // Conversa que saiu da lista (apagada noutra aba) simplesmente não abre.
    abrirConversaPorId(id) {
      if (!id) return
      const lista =
        this.$store.getters[`${this.nsDoHistorico}/conversations`] || []
      const conversa = lista.find((c) => c && c.id === id)
      if (conversa) this.selecionarConversa(conversa)
    },

    /**
     * spec-009 [T007], US-3/AC-3.3 — escolher um cliente numa conversa
     * EXISTENTE e SEM vínculo grava pelo servidor antes de fixar o chip.
     * Duas condições para o PATCH: `cliente` não-nulo (limpar o escopo
     * continua só local — desvincular explícito é decisão fora desta ação,
     * ver `contracts/api.yaml`) e a conversa já EXISTE no banco
     * (`conv.id` — sem ele não há `id_conversa` para o PATCH; o vínculo de
     * uma conversa nova entra no INSERT, via `idClienteApp` do corpo do
     * POST, como sempre foi). Já vinculada (`escopoTravado`), o seletor nem
     * chega a chamar isto — a UI trava o clique antes.
     */
    onTrocarEscopo(cliente) {
      const conv = this.selectedConversation
      const podeFixarNoServidor = Boolean(cliente) && conv && conv.id && !this.escopoTravado
      if (podeFixarNoServidor) {
        return this.fixarClienteNoServidor(cliente).then(() =>
          this.vincularAnexosAoCliente(cliente)
        )
      }
      this.$store.dispatch(`${this.ns}/setClienteEscopo`, cliente)
      /**
       * [QA it.2 G-1] Conversa ainda NÃO existe no banco (`created()`/
       * `novaConversa` não gravaram nada) — a escolha manual precisa
       * SOBREVIVER até ela nascer. Sem isto, um `cliente-identificado` de
       * outro cliente no primeiro turno sobrescrevia o chip em silêncio: o
       * guard do AC-2.3 (`guardDeClienteFixado`) só bloqueia quando há um
       * registro de `clienteFixadoManualmente` para a conversa do evento, e
       * sem `conv.id` nada era gravado aqui.
       *
       * `conversation_id: null` é a marca de PENDENTE — promovida para o id
       * real assim que a conversa nascer, em `apiChat._onEventStart`
       * (`_promoverClienteFixadoPendente`), ANTES de qualquer
       * `cliente-identificado` do turno ser processado.
       */
      if (!conv || !conv.id) {
        this.$store.dispatch(
          `${this.ns}/setClienteFixadoManualmente`,
          cliente ? { conversation_id: null, id_cliente_app: cliente.id } : null
        )
      }
      return this.vincularAnexosAoCliente(cliente)
    },
    /**
     * ★ [spec-009 T013, US-3] Escolher o cliente DÁ DONO aos anexos que já
     * subiram sem um — sem reanexar nada.
     *
     * O fluxo: o consultor arrasta o extrato sem cliente em foco (o canal de
     * ANÁLISE aceita, T008), manda a pergunta, e a IA descobre que precisa de
     * um cadastro para concluir. O arquivo JÁ está no servidor, com
     * `upload_id` próprio — o que falta é o vínculo
     * (`POST /anexos-analise/{upload_id}/cliente`, contrato §2). Pedir para
     * anexar de novo gastaria a rede e criaria um segundo anexo do mesmo
     * conteúdo; é exatamente o "sem exigir reanexar o arquivo" da US-3.
     *
     * ⚠️ `cliente` vem por ARGUMENTO e é conferido contra o chip: no ramo do
     * servidor, `fixarClienteNoServidor` REVERTE o escopo quando o vínculo da
     * conversa é recusado — ler `clienteEscopo` aqui vincularia os arquivos
     * ao cliente ANTERIOR, que ninguém escolheu.
     */
    vincularAnexosAoCliente(cliente) {
      if (!cliente || !cliente.id) return Promise.resolve()
      const emFoco = this.clienteEscopo
      if (!emFoco || emFoco.id !== cliente.id) return Promise.resolve()
      // Guarda de concorrência: o gesto é um clique no chip, e cliques repetidos
      // (ou trocar de cliente e voltar) disparariam duas rodadas de N POSTs
      // sobre a MESMA fila. A rota é idempotente, mas o relato não: as duas
      // rodadas anunciariam o vínculo, e a segunda encontraria a fila já
      // esvaziada pela primeira.
      if (this._vinculandoAnexos) return Promise.resolve()
      const pendentes = anexosAguardandoCliente(this.chaveDaFilaDeAnexos)
      if (!pendentes.length) return Promise.resolve()
      this._vinculandoAnexos = true
      return Promise.all(
        pendentes.map((anexo) =>
          apiAnexosAnalise.vincularCliente({
            uploadId: anexo.uploadId,
            idClienteApp: cliente.id,
          })
        )
      )
        .then((desfechos) => {
          // ★ Descarte de resposta STALE. A conferência contra o chip lá em cima
          // acontece na ENTRADA; esta acontece na RESOLUÇÃO, e são coisas
          // diferentes: escolher o cliente A e logo o B faz a rodada de A
          // resolver depois, com o chip já em B — e o snack anunciaria
          // "vinculado ao A" sobre uma tela que diz B. O vínculo em si está
          // correto (os arquivos são de A mesmo); o que não pode é RELATAR
          // para uma tela que mudou de contexto.
          const aindaEmFoco = this.clienteEscopo
          if (!aindaEmFoco || aindaEmFoco.id !== cliente.id) return
          this.relatarVinculoDeAnexos(pendentes, desfechos, cliente)
        })
        .finally(() => {
          this._vinculandoAnexos = false
        })
    },
    /**
     * O que aconteceu com cada arquivo — na tela, nunca em silêncio.
     *
     * Vincular calado é o mesmo defeito do descarte calado, só do outro lado:
     * um arquivo passa a valer para um cadastro e ninguém vê. Por isso o
     * sucesso NOMEIA os arquivos e o cliente, e a recusa vai com a mensagem
     * do SERVIDOR — só ela sabe a qual cliente o anexo já pertence (§2).
     *
     * Sai da espera quem ganhou dono agora (200) e quem já tinha (409):
     * mantê-los na lista repetiria a mesma chamada a cada troca de cliente.
     * Falha de rede/servidor (o resto) CONTINUA esperando — ali o dono ainda
     * não foi decidido, e a próxima escolha tenta de novo.
     */
    relatarVinculoDeAnexos(pendentes, desfechos, cliente) {
      const vinculados = []
      const semVolta = []
      const recusas = []
      pendentes.forEach((anexo, indice) => {
        const r = desfechos[indice] || {}
        if (r.status === 200) return vinculados.push(anexo)
        if (STATUS_SEM_VOLTA_DO_VINCULO.indexOf(r.status) !== -1) semVolta.push(anexo)
        recusas.push(r)
      })
      // ⚠️ Um snack por ANEXO recusado empilhava a tela: com 3 pendentes e 2
      // recusas, eram 3 snacks para UM clique (mais o de sucesso). O canal é
      // por AÇÃO, não por item — o consultor clicou uma vez. A primeira recusa
      // é a que vai: as mensagens do backend para o mesmo lote são do mesmo
      // motivo (anexo expirado, sem permissão), e repetir não informa mais.
      if (recusas.length) this.$showSnack(recusas[0])
      removerAnexosAguardandoCliente(
        this.chaveDaFilaDeAnexos,
        vinculados.concat(semVolta).map((anexo) => anexo.uploadId)
      )
      if (!vinculados.length) return
      this.$showSnack({
        status: 200,
        message: ESCOPO_CLIENTE_TEXT.anexosVinculados(
          vinculados.map((anexo) => anexo.nome),
          cliente.name || ''
        ),
      })
    },
    /**
     * O PATCH de vínculo (US-3/AC-3.3/AC-3.4). Otimista: o chip muda na
     * hora, e reverte para o valor anterior se o corpo devolver recusa
     * (cliente fora da carteira, conversa alheia) — com `$showSnack(r)`
     * mostrando o motivo que o servidor mandou.
     */
    async fixarClienteNoServidor(cliente) {
      const conv = this.selectedConversation
      const clienteAnterior = this.clienteEscopo
      this.$store.dispatch(`${this.ns}/setClienteEscopo`, cliente)
      const r = await apiConversations.vincularCliente({
        id: conv.id,
        id_cliente_app: cliente.id,
      })
      if (r && r.status === 200) {
        this.$store.dispatch(`${this.ns}/setClienteFixadoManualmente`, {
          conversation_id: conv.id,
          id_cliente_app: cliente.id,
        })
        return
      }
      this.$store.dispatch(
        `${this.ns}/setClienteEscopo`,
        clienteAnterior || null
      )
      this.$showSnack(r)
    },
    /**
     * spec-009 [T006/US-2, AC-2.3] — ação do aviso "Esta conversa fala de X":
     * troca EXPLÍCITA pedida pelo usuário (AC-3.5: "aceita pela MESMA porta,
     * e SÓ por ela", mesmo com a conversa JÁ vinculada). Chama
     * `trocarClienteExplicitamente` DIRETO, nunca `onTrocarEscopo` — aquele
     * respeita `escopoTravado` porque o SELETOR genérico já trava
     * visualmente o clique antes de chegar lá; o aviso só aparece quando HÁ
     * vínculo (por isso `escopoTravado` é quase sempre `true` aqui), e
     * delegar a `onTrocarEscopo` fazia o clique mudar o chip só EM MEMÓRIA,
     * sem persistir (MUST G-2 da review). Confere o id contra o que a view
     * calculou (`idClienteDoAvisoAtual`) — o cartão é burro e só repassa o
     * que recebeu por prop.
     */
    onTrocarParaClienteDoAviso({ id_cliente_app } = {}) {
      const identificado = this.clienteDaConversaAtualValidado
      if (!identificado || Number(identificado.id_cliente_app) !== Number(id_cliente_app)) {
        return Promise.resolve()
      }
      return this.trocarClienteExplicitamente({
        id: identificado.id_cliente_app,
        name: identificado.nome,
        codigo_corretora: identificado.codigo,
      })
    },
    /**
     * spec-009, MUST G-2 da review — a troca EXPLÍCITA (aviso "Esta conversa
     * fala de X", e qualquer futura ação equivalente) grava no servidor
     * SEMPRE, mesmo com `escopoTravado` — diferente de `onTrocarEscopo`, que
     * só chama o PATCH quando a conversa AINDA não tem vínculo. Sem
     * `conv.id` (conversa nunca criada), não há como fazer PATCH: cai no
     * dispatch local de sempre, e o vínculo entra no INSERT.
     */
    trocarClienteExplicitamente(cliente) {
      const conv = this.selectedConversation
      // ★ [T013] Os anexos sem dono seguem a escolha do cliente aqui também:
      // pelo aviso da conversa ou pelo chip, o gesto é o mesmo ("é deste
      // cliente que eu falo"), e seguir só por um dos dois caminhos deixaria
      // o arquivo órfão dependendo de ONDE o consultor clicou.
      if (!cliente || !conv || !conv.id) {
        // ⚠️ Merge para a release: o namespace por conversa (`this.ns`) veio da
        // frente de conversas paralelas; o `vincularAnexosAoCliente` é a US-3 da
        // spec-009. Ficar com um lado só apagaria o outro em silêncio — e o
        // `Promise.resolve()` da release é justamente o lugar onde o vínculo
        // entra, não um substituto dele.
        this.$store.dispatch(`${this.ns}/setClienteEscopo`, cliente || null)
        return this.vincularAnexosAoCliente(cliente)
      }
      return this.fixarClienteNoServidor(cliente).then(() =>
        this.vincularAnexosAoCliente(cliente)
      )
    },

    descartarTurnoEmAndamento() {
      // `turnoEmVoo`, não `chatLoading` cru: na tool longa (N-1) o loading
      // da store cai antes de o stream terminar e `enviando` é o que ainda
      // sabe que há um fetch aberto — é ele que precisa ser abortado.
      if (this.turnoEmVoo) this.cancelarStream()
      this.$store.dispatch(`${this.ns}/setChatLoading`, false)
      this.$store.dispatch(`${this.ns}/resetResponseTokens`)
      this.$store.dispatch(`${this.ns}/resetThinkingSteps`)
      this.$store.dispatch(`${this.ns}/resetToolCalls`)
      this.$store.dispatch(`${this.ns}/resetPendingConfirmation`)
      this.$store.dispatch(`${this.ns}/resetServicosCitadosStreaming`)
      // Sem este reset o painel do turno ANTERIOR vazava para o proximo: o
      // bloco da deliberacao ja nascia montado com a mesa velha, e como o
      // raciocinio recolhe quando ha painel, ele nunca abria a partir da
      // segunda mensagem. A action existia e nunca era despachada.
      this.$store.dispatch(`${this.ns}/resetPainelStreaming`)
      // [15/09/2026] O formulário de perguntas ao gestor, os eventos da sala
      // e as partes de tool do turno também são DESTE turno: sem zerá-los,
      // trocar de conversa no meio da resposta levava as perguntas (e os
      // cartões reservados) para a conversa seguinte.
      this.$store.dispatch(`${this.ns}/resetPerguntasAoGestorStreaming`)
      this.$store.dispatch(`${this.ns}/resetPainelEventosStreaming`)
      this.$store.dispatch(`${this.ns}/clearToolParts`)
      this.$store.dispatch(`${this.ns}/setAgentesDoTurnoAoVivo`, [])
    },
    /**
     * [15/09/2026] Trocar de conversa (ou começar outra) no meio de um turno
     * DESCARTA o turno — a mesma regra do `beforeDestroy`. Bug medido: o
     * stream de A continuava escrevendo em `responseTokens` (store única) e
     * o `end` fazia `addMessage` na conversa selecionada, que já era B; as
     * perguntas ao gestor de A apareciam em B e a resposta do formulário
     * saía com o id de B. A continuação de uma tool de front fica ([T024]:
     * cancelar o POST que o próprio turno pediu deixava "não foi salva" com
     * as mensagens já no banco) — para ela vale a guarda por conversa do
     * `apiChat._onEventEnd`, que não grava o `end` numa conversa que não é
     * a do turno.
     */
    /**
     * O que a conversa que está SAINDO deixa para trás ao selecionar outra:
     * o turno em voo (só ao TROCAR — reabrir a mesma pela lateral/palette não
     * pode abortar a resposta que o gestor está lendo), o artefato aberto e
     * o índice dela (a action é no-op seguro quando já está fechado, e esta
     * view está sempre no namespace `aawz-intelligence-v2`) e o anexo
     * pendente (um `sem_cliente` da A subiria para o cliente da B assim que
     * o escopo dela resolvesse).
     */
    sairDaConversaAtual(proxima) {
      if (this.saiDaConversaCorrente(proxima)) {
        this.descartarTurnoAoSairDaConversa()
        this.desarmarTrilhoQuebrado()
        // Os canais do turno (plano, entregas, busca, código) são do turno que
        // ficou para trás. Sem isto o painel da conversa recém-aberta exibia a
        // entrega da anterior — "Entregas 1" de um arquivo que não é dela
        // (medido em 17/09/2026). Só quando a conversa MUDA: reabrir a mesma
        // não pode apagar o painel do turno que ainda está rodando nela.
        this.$store.dispatch(`${this.ns}/resetCanaisDoAgente`)
      }
      this.$store.dispatch(`${this.ns}/fecharArtefato`)
      this.$store.dispatch(`${this.ns}/limparArtefatosDaConversa`)
      // ★ [E-72] O slice `artefatos-do-workspace.js` — o ARQUIVO entregue pelo
      // agente, nao confundir com o indice de cartoes de dado dos dois acima.
      // Guardar a lista de outra conversa na memoria do store e' estado pronto
      // para vazar no proximo leitor que esquecer de comparar `idConversa`.
      this.$store.dispatch(`${this.ns}/limparArtefatosDoWorkspace`)
      resetarFilaDeAnexos(this.chaveDaFilaDeAnexos)
    },
    descartarTurnoAoSairDaConversa() {
      if (!this.turnoEmVoo) return
      if (this.motor.temContinuacaoDeToolDeFront()) return
      // ★ D3 (owner, 21/09/2026): "ao digitar e trocar de aba trouxe 'resposta
      // interrompida pelo usuario'; deveria processar normalmente como no claude".
      //
      // MEDIDO em 21/09: 5 mensagens `Resposta interrompida pelo usuario.` em 5
      // conversas, 3 delas em 22 segundos -- ninguem interrompeu nada, o usuario so'
      // trocou de conversa. `descartarTurnoEmAndamento` faz DUAS coisas e so' uma
      // delas e' necessaria aqui:
      //   (a) `cancelarStream()` -- aborta o fetch, o backend grava
      //       CONTEUDO_TURNO_CANCELADO, e a bolha aparece. E' o que o owner nao quer.
      //   (b) zerar os canais do turno -- NECESSARIO: sem isso o plano, as entregas e
      //       as perguntas ao gestor do turno antigo vazam para a conversa seguinte
      //       (medido em 15/09 e 17/09, e os dois casos estao nos comentarios de
      //       `descartarTurnoEmAndamento`).
      //
      // Com motor POR CONVERSA (`vivaAtual.apiChat`) o stream que continua escreve no
      // namespace DELA, entao (a) deixa de ser necessario: o turno termina no
      // servidor e a resposta esta' la' quando o consultor voltar. Sem conversa viva
      // (motor unico compartilhado) o stream escreveria na conversa ERRADA -- ali o
      // cancelamento continua sendo o comportamento correto, e por isso a guarda
      // abaixo e' pelo motor, nao uma troca global.
      if (this.vivaAtual) {
        this.limparCanaisDoTurnoSemCancelar()
        return
      }
      this.descartarTurnoEmAndamento()
    },
    /**
     * [D3] O (b) de `descartarTurnoEmAndamento` sem o (a): zera os canais do turno
     * que ficou para tras, SEM abortar o stream. Um metodo proprio -- e nao um
     * parametro booleano -- porque quem le a chamada precisa ver, no nome, que o
     * turno CONTINUA rodando.
     */
    limparCanaisDoTurnoSemCancelar() {
      this.$store.dispatch(`${this.ns}/resetResponseTokens`)
      this.$store.dispatch(`${this.ns}/resetThinkingSteps`)
      this.$store.dispatch(`${this.ns}/resetToolCalls`)
      this.$store.dispatch(`${this.ns}/resetPendingConfirmation`)
      this.$store.dispatch(`${this.ns}/resetServicosCitadosStreaming`)
      this.$store.dispatch(`${this.ns}/resetPainelStreaming`)
      this.$store.dispatch(`${this.ns}/resetPerguntasAoGestorStreaming`)
      this.$store.dispatch(`${this.ns}/resetPainelEventosStreaming`)
      this.$store.dispatch(`${this.ns}/clearToolParts`)
      this.$store.dispatch(`${this.ns}/setAgentesDoTurnoAoVivo`, [])
    },
    /**
     * ★ [19/09/2026 · F-2] A faixa de erro é da CONVERSA, não da view.
     *
     * `trilhoQuebrado` tinha uma única atribuição no arquivo (`= true`, em
     * `onErroNoTrilho`) e nenhum reset — e esta view não remonta ao trocar
     * de conversa. Medido: um cartão quebra o render de A, o consultor abre
     * B (que renderiza inteira) e o composer continua bloqueado com a faixa
     * vermelha dizendo que “esta conversa não pôde ser exibida” — frase
     * falsa, sobre uma conversa que ele já deixou, sem saída que não seja F5.
     * O remédio da rodada D virou doença: impedia o trabalho no lugar de
     * impedir a cobrança.
     *
     * ⚠️ A fronteira é SAIR da conversa (trocar de id ou começar outra) —
     * a mesma de `descartarTurnoAoSairDaConversa`, e por isso os dois
     * chamadores são os mesmos. NÃO desarme em re-render: voltar para a
     * conversa ainda quebrada tem de mostrar a faixa de novo, e mostra,
     * porque o render estoura outra vez e o `messages.vue` reemite
     * `erro-no-trilho`.
     *
     * ⚠️ Não cabe DENTRO de `descartarTurnoAoSairDaConversa`: os dois
     * `return` dele são sobre o TURNO (`turnoEmVoo`, continuação de tool de
     * front), e a conversa quebra justamente quando não há turno em voo —
     * o reset nunca rodaria.
     */
    desarmarTrilhoQuebrado() {
      this.trilhoQuebrado = false
    },
    descartarConversaDeOutraPersona() {
      const personaNoStore = this.$store.getters[`${this.ns}/persona`]
      if (personaNoStore === this.personaEfetiva) return
      this.descartarTurnoEmAndamento()
      this.novaConversa()
    },
    aplicarPerguntaInicial() {
      if (this.perguntaInicialAplicada) return
      const texto = (this.perguntaInicial || '').trim()
      if (!texto) return
      this.perguntaInicialAplicada = true
      this.despacharPerguntaInicial(texto)
    },
    despacharPerguntaInicial(texto) {
      const limpo = (texto || '').trim()
      if (!limpo) return
      if (this.enviarPerguntaInicial) {
        this.enviarMensagem(limpo)
        return
      }
      this.messageInput = limpo
    },
    // Uma listagem que LANÇA (rede caída, exception no cliente) acende o erro
    // e apaga o loading como a que responde 500 — senão o esqueleto da
    // lateral fica preso e o retry nunca aparece.
    async carregarConversas() {
      const carga = ++this.cargaDeConversas
      this.$store.dispatch(`${this.nsDoHistorico}/setConversationsLoading`, true)
      try {
        await this.listarConversas(carga)
      } catch (erro) {
        if (carga !== this.cargaDeConversas) return
        this.$store.dispatch(`${this.nsDoHistorico}/setConversationsError`, true)
      } finally {
        // O loading pertence à carga mais nova — uma stale não o desliga.
        if (carga === this.cargaDeConversas) {
          this.$store.dispatch(
            `${this.nsDoHistorico}/setConversationsLoading`,
            false
          )
        }
      }
    },
    async listarConversas(carga) {
      // `filtroDeConversas` é o ÚNICO eixo que viaja (`context` OU `persona`
      // — o backend dá precedência ao `context`): na home é `ALL`, porque o
      // default `CRM` escondia conversas das outras personas (182 × 299 no
      // escritório 83). Escritório e recorte por profissional ficam com a
      // sessão, no servidor — nada aqui pode alargá-los.
      const r = await apiConversations.getConversations({
        limit: CONVERSAS_LIMITE_CARGA,
        offset: 0,
        ...this.filtroDeConversas,
      })
      // Chegou tarde: já há carga mais nova em voo. Sair ANTES de escrever
      // no store — inclusive antes de desligar o loading, que pertence a ela.
      if (carga !== this.cargaDeConversas) return

      // A listagem devolve 404 com `value: []` para lista VAZIA — só o `value`
      // separa "não tem conversa" de "a rede caiu" (500/`value` nulo/sem
      // resposta), e o `else` existe para a falha não virar "Nenhuma conversa
      // ainda". O discriminante mora em `apiConversations` (`respostaTemLista`)
      // porque a coluna também recarrega por conta própria — duas leituras do
      // mesmo contrato divergiriam em silêncio.
      if (respostaTemLista(r)) {
        const lista = r.value || []
        // ⚠️ O endpoint NÃO devolve contagem total (gap G8): o único sinal de
        // "tem mais" é a página ter vindo cheia. Página curta = fim da lista.
        this.temMaisConversas = lista.length >= CONVERSAS_LIMITE_CARGA
        this.$store.dispatch(`${this.nsDoHistorico}/setConversations`, lista)
        this.$store.dispatch(
          `${this.nsDoHistorico}/setConversationsError`,
          false
        )
      } else {
        this.$store.dispatch(`${this.nsDoHistorico}/setConversationsError`, true)
      }
    },
    /**
     * Próxima página do histórico — o scroll infinito da lateral imersiva.
     *
     * Acrescenta ao fim em vez de trocar a lista (`appendConversations`, que
     * deduplica por id). ⚠️ NÃO usa `conversationsLoading`: aquele estado
     * desenha o esqueleto no lugar da lista, e trocar o que a pessoa está lendo
     * por três barras cinzas ao rolar seria pior que não carregar nada.
     */
    async carregarMaisConversas() {
      if (this.carregandoMaisConversas || !this.temMaisConversas) return
      const carga = this.cargaDeConversas
      // UM piso, armado antes da rede e esperado nos dois pontos abaixo — o
      // relógio é o mesmo para a página e para o rodapé.
      const piso = aguardarPisoDeCarga(Date.now())
      this.carregandoMaisConversas = true
      try {
        const lista = await this.buscarProximaPaginaDeConversas()
        // ★ A página espera o piso JUNTO com o rodapé (14/09/2026, print do
        // usuário). Anexada assim que chegava (cache: dezenas de ms), eram
        // dois eventos: 30 linhas de uma vez e, ~400ms depois, o rodapé
        // sumindo lá embaixo — com o `scrollTop` clampando se a pessoa já
        // tinha rolado até ele. Retida até aqui, ela entra no MESMO tick em
        // que `carregandoMaisConversas` cai (o `finally` resolve na hora,
        // piso já cumprido): um render só, e as primeiras linhas novas
        // ocupam a caixa que as linhas-fantasma deixam.
        await piso
        // Trocou de agente no meio do caminho (na rede ou no piso): a lista
        // já é outra, e anexar aqui misturaria as duas.
        if (carga !== this.cargaDeConversas) return
        if (lista) this.anexarPaginaDeConversas(lista)
      } finally {
        // O piso vale também para as saídas antecipadas (eixo trocado, rede
        // caída): sem ele o rodapé piscava dentro do mesmo quadro. Já
        // cumprido, resolve na hora.
        await piso
        this.carregandoMaisConversas = false
      }
    },
    // A página seguinte, a partir do que a store JÁ tem — ou `null` quando a
    // resposta não é lista (rede caída, 500). 404 é lista vazia neste endpoint,
    // como na primeira carga — aqui significa simplesmente que acabou. Mesmo
    // discriminante da primeira página (`respostaTemLista`), e pelo mesmo
    // motivo: duas leituras do contrato de rede divergem em silêncio quando
    // uma delas muda.
    async buscarProximaPaginaDeConversas() {
      const r = await apiConversations.getConversations({
        limit: CONVERSAS_LIMITE_CARGA,
        offset: (this.$store.getters[`${this.nsDoHistorico}/conversations`] || []).length,
        ...this.filtroDeConversas,
      })
      if (!respostaTemLista(r)) return null
      return r.value || []
    },
    // ⚠️ O endpoint NÃO devolve contagem total (gap G8): o único sinal de "tem
    // mais" é a página ter vindo cheia. Página curta = fim da lista.
    anexarPaginaDeConversas(lista) {
      this.temMaisConversas = lista.length >= CONVERSAS_LIMITE_CARGA
      if (!lista.length) return
      this.$store.dispatch(`${this.nsDoHistorico}/appendConversations`, lista)
    },
    async carregarSugestoes() {
      this.$store.dispatch(
        `${this.ns}/setPromptSuggestionsLoading`,
        true
      )
      const r = await apiPromptSuggestions.getSuggestions({
        persona: this.personaEfetiva,
        papel: this.personaMode,
      })
      if (r && r.status === 200) {
        this.$store.dispatch(
          `${this.ns}/setPromptSuggestions`,
          r.value || []
        )
      }
      this.$store.dispatch(
        `${this.ns}/setPromptSuggestionsLoading`,
        false
      )
    },
    /**
     * [spec-013 T014] Fecha a pendência declarada pela T003 (ver o
     * comentário de `atalhosDisponiveis`, acima): a fiação (`:atalhos`,
     * `@executar-atalho`, `executarAtalho()`) já existia e estava testada
     * — faltava só buscar o catálogo (`GET /v2/api/ia-crm/atalhos`, T013).
     *
     * [spec-013 T016] Até aqui este método TRADUZIA o contrato real do
     * servidor (`{id, label, description, pedeArgumento,
     * placeholderArgumento}`, `contracts/api.yaml`, `core/atalhos/
     * catalogo.py::Atalho.para_payload()`) para a forma especulativa que
     * `send-message-atalhos-mixin.js` esperava (`{slug, rotulo, descricao,
     * icone, aliases}`, escrita na T003 ANTES de o endpoint existir) — e a
     * tradução perdia `pedeArgumento`/`placeholderArgumento` no caminho
     * (não havia onde eles pousarem na forma antiga). A T016 fechou os dois
     * lados no MESMO vocabulário (o do produtor): o mixin passou a consumir
     * `{id, label, description, pedeArgumento, placeholderArgumento}`
     * direto, e a tradução aqui desapareceu — o catálogo do servidor segue
     * para `atalhosDisponiveis` sem transformação nenhuma.
     *
     * Falha (rede, status ≠ 200) nunca aparece ao usuário:
     * `apiAtalhos.buscarCatalogo()` (fechado na T003) já devolve `[]` em
     * toda falha de rede/status — contrato do próprio arquivo. O `catch`
     * aqui é a segunda camada: cobre a rejeição chegar a este `await`
     * mesmo assim (bug na própria `apiAtalhos`, por exemplo). Sem ele, a
     * exceção subiria não tratada dentro do `created()` — o
     * `console.error` do handler padrão do Vue derrubaria a montagem via
     * `tests/unit/setup.js`, e em produção um catálogo malformado quebraria
     * a tela inteira por causa de um menu opcional.
     */
    async carregarAtalhos() {
      try {
        const catalogo = await apiAtalhos.buscarCatalogo()
        this.atalhosDisponiveis = catalogo || []
      } catch {
        this.atalhosDisponiveis = []
      }
    },
    /**
     * [spec-013 T003] Handler ÚNICO dos dois composers deste componente
     * (`composerHeroi`, `composerRodape`) para o evento `executar-atalho`
     * do menu do `/` — NUNCA passa por `enviarMensagem`/`despacharMensagem`:
     * o transporte é `apiChatAtalhos.sendAtalho()`, que fala com `/chat`
     * DIRETO. É o que garante **zero POST `/runs`**: a bifurcação do Modo
     * Agente (`despacharMensagem`, acima, `:1666-1672`) só existe no
     * caminho de `enviarMensagem` — este método nunca o alcança.
     */
    async executarAtalho({ slug, label, argumento } = {}) {
      if (!slug) return
      this.tocarConversaSelecionada()
      await apiChatAtalhos.sendAtalho({
        slug: slug,
        // [spec-013 T024] O rótulo do CATÁLOGO atravessa intacto: é ele que
        // vira a bolha do usuário no fio, e tem de bater byte a byte com o
        // que `core/atalhos/turno.py::_fala_do_comando` grava na conversa.
        label: label,
        argumento: argumento || null,
        conversationId: this._idDaConversaParaOTurno(),
        // ★ [D4, 21/09/2026] O MESMO motor que o resto da tela usa. Sem isto o
        // transporte do atalho falava com o singleton (namespace estático) enquanto a
        // tela lia o da conversa viva — medido na tela: `{estatico: 2, vivos: 0}`, com
        // "Olá / Como posso te ajudar hoje?" de pé e a conversa só em "Recentes".
        motor: this.motor,
      })
      this.carregarConversas()
    },
    /**
     * Restaura o que é DA CONVERSA: agente, modelo e cliente.
     *
     * Num método próprio porque os três dispatches empurravam o
     * `selecionarConversa` além do teto de statements do repo — extrair é a
     * regra daqui, não desabilitar a regra. E porque os três respondem à mesma
     * pergunta: o que muda ao abrir OUTRA conversa.
     */
    restaurarEstadoDaConversa(conversation) {
      // Só na navegação (`/home-ia`) o agente ativo dobra como item de
      // navegação da própria sidebar — ver o comentário de
      // `adotarAgenteDaConversa`.
      this.adotarAgenteDaConversa(conversation)
      if (conversation.model) {
        this.$store.dispatch(
          `${this.ns}/setSelectedModel`,
          conversation.model
        )
      }
      // ★ O cliente é DA CONVERSA, como o modelo logo acima — e por isso é
      // restaurado no mesmo lugar. Sem isto o `clienteEscopo` (um valor só no
      // store) grudava: escolher um cliente uma vez o fazia atravessar toda
      // troca de conversa, e o cartão "Cliente em foco" aparecia sobre uma
      // conversa que no banco não tem cliente nenhum.
      //
      // Sempre despacha, inclusive `null`: abrir uma conversa GERAL tem de
      // apagar o cliente da anterior — é justamente o caso do vazamento.
      //
      // ⚠️ Gateado por `escopoDeCliente`: o store é COMPARTILHADO entre as
      // superfícies (popup, painel do Hub, Fee-Based), e escrever daqui mudaria
      // o escopo delas. Quem não tem seletor de cliente não mexe no escopo.
      if (this.escopoDeCliente) {
        this.$store.dispatch(
          `${this.ns}/setClienteEscopo`,
          clienteDaConversa(conversation, this.clientesDoEscritorio)
        )
      }
      // ★ [spec-016 T035] Diferente do bloco acima: este dispatch é
      // INCONDICIONAL — é exatamente a superfície SEM `escopoDeCliente` (o
      // `/ia` imersivo) quem precisa dele (ver `idClienteEmFoco`). Por
      // conversa: reabrir outra limpa o anterior, e conversa GERAL despacha
      // `null` (mesma razão do `setClienteEscopo` acima — não pode grudar).
      this.$store.dispatch(
        `${this.ns}/setClienteDaConversa`,
        this.payloadClienteDaConversa(conversation)
      )
      // ★ [spec-009 T007] Fecha o guard do T006 (US-2/AC-2.3): sem isto, uma
      // conversa que JÁ NASCEU vinculada (ou foi vinculada em sessão
      // anterior) não tinha `clienteFixadoManualmente` populado NESTA sessão
      // do browser, e um `cliente-identificado` de outro cliente (UC-2
      // exemplo 2/3 — o servidor NÃO grava, mas AINDA EMITE o evento)
      // sobrescreveria o chip por cima de um vínculo real. Também é a fonte
      // de `escopoTravado` acima — incondicional, como `setClienteDaConversa`:
      // reabrir uma conversa GERAL tem de destravar o seletor da anterior.
      this.$store.dispatch(
        `${this.ns}/setClienteFixadoManualmente`,
        conversation.id_cliente_app
          ? { conversation_id: conversation.id, id_cliente_app: conversation.id_cliente_app }
          : null
      )
    },
    /** `{id_cliente_app, codigo, nome, conversation_id}` | `null` — payload de `setClienteDaConversa`. */
    payloadClienteDaConversa(conversation) {
      const cliente = clienteDaConversa(conversation, this.clientesDoEscritorio)
      if (!cliente) return null
      return {
        id_cliente_app: cliente.id,
        codigo:
          cliente.codigo_corretora ||
          cliente.codigo_cliente ||
          cliente.codigo ||
          null,
        nome: cliente.nome_cliente || cliente.name || cliente.nome || null,
        conversation_id: conversation.id,
      }
    },
    /**
     * ★ merge PR #2242 — Modo Agente (spec-002): o passivo da conversa
     * ANTERIOR não pode atravessar a troca. O mapa `propostasAbertas` nunca
     * perde entrada sozinho ([VERIFY-1/M-6]); o card LEGADO reaparecia na
     * conversa nova e o clique mandava "Confirmo" na conversa errada
     * ([VERIFY-3/C-88C]); e o chip/botão Cancelar do run anterior sobrevivia
     * na tela desta ([VERIFY-3/F-1]).
     *
     * ⚠️ SÍNCRONO, e o `pararAcompanhamentoDoRun` vai SEM `await`: os dois
     * chamadores despacham no store logo em seguida, e `await` de função
     * `async` cede um microtask mesmo quando o corpo não espera nada — o tick
     * a mais quebrou 9 testes de `desenvolvimento` que leem o store na linha
     * seguinte a `novaConversa()`. O abort e o `resetRunAtual` acontecem do
     * mesmo jeito, um microtask depois; nada espera por eles.
     */
    /**
     * Está SAINDO da conversa? Ou seja: a `proxima` NÃO é a que está aberta.
     *
     * ★ [T317] Fonte ÚNICA da pergunta que `sairDaConversaAtual` já fazia
     * inline e que `descartarRunAoSairDaConversa` não fazia — a assimetria
     * entre as duas ERA o defeito: re-clicar na conversa corrente preservava
     * o turno em voo (a guarda de lá) e mesmo assim zerava
     * `propostasAbertas`, levando junto o relatório do lote (US-8 AC3, que a
     * T313 acabara de fazer sobreviver ao F5). E nada repunha: quem reidrata
     * o mapa é o `watch: selectedConversation` do
     * `view-chat-modo-agente.mixin.js`, que sai cedo quando o id não mudou —
     * guarda que existe porque `updateConversationTopic` recria o objeto da
     * conversa selecionada sem trocar de conversa de verdade.
     *
     * ⚠️ Sem conversa aberta, SIM: `novaConversa()` precisa descartar o
     * passivo do estado vazio.
     */
    saiDaConversaCorrente(proxima) {
      const atual = this.selectedConversation
      return !atual || !proxima || atual.id !== proxima.id
    },
    descartarRunAoSairDaConversa() {
      this.$store.dispatch(`${this.ns}/resetPropostasAbertas`)
      this.$store.dispatch(`${this.ns}/resetPendingConfirmation`)
      if (this.runAtual) this.motor.pararAcompanhamentoDoRun()
    },

    async selecionarConversa(conversation) {
      if (!conversation || !conversation.id) return
      if (this.focouAAbaQueJaTemAConversa(conversation.id)) return
      this.prepararTelaParaAConversa(conversation)
      const r = await apiMessages.getMessages({
        conversationId: conversation.id,
      })
      // ⚠️ A guarda de corrida cobre o desfecho INTEIRO, não só o ramo de erro.
      // Dois cliques seguidos (A, depois B) com o 200 de A chegando por último
      // escreviam as mensagens de A no thread de B — e o `messagesLoading` de
      // A derrubava o esqueleto que B ainda estava esperando. É o mesmo defeito
      // que o ramo de erro já tratava, no caminho FELIZ, onde ele é pior:
      // a tela mostra a conversa errada sem nada indicar que algo falhou.
      if (!this.conversaAindaAberta(conversation)) return
      if (r && r.status === 200) {
        const msgs = (r.value && r.value.messages) || []
        this.$store.dispatch(`${this.ns}/setMessages`, msgs)
      } else {
        this.descartarConversaQueNaoAbriu(conversation, r)
      }
      this.$store.dispatch(`${this.ns}/setMessagesLoading`, false)
    },
    /**
     * Deixa a tela pronta para a conversa que vai carregar: abandona a atual,
     * fixa a nova e zera o trilho com o esqueleto ligado.
     *
     * Método próprio pelo teto de `max-statements` do repo — o `selecionarConversa`
     * cruzou o limite quando ganhou a guarda de foco de aba.
     */
    prepararTelaParaAConversa(conversation) {
      this.sairDaConversaAtual(conversation)
      // ★ [T317] Só ao TROCAR de conversa — ver `saiDaConversaCorrente`.
      if (this.saiDaConversaCorrente(conversation)) this.descartarRunAoSairDaConversa()
      this.$store.dispatch(`${this.ns}/setSelectedConversation`, conversation)
      this.restaurarEstadoDaConversa(conversation)
      this.$store.dispatch(`${this.ns}/setMessagesLoading`, true)
      this.$store.dispatch(`${this.ns}/setMessages`, [])
    },
    /**
     * Esta conversa JÁ está aberta noutra aba? Então foque a aba, não carregue
     * por cima da atual.
     *
     * ★ [owner, 20/09/2026] *"recentes e as abas são a mesma coisa então? pq
     * ter 2?"*. Eram — e o clique em Recentes reforçava a confusão: ele
     * carregava a conversa DENTRO da aba corrente, então a mesma conversa
     * podia acabar aberta em duas abas, cada uma com seu módulo e seu stream.
     *
     * Focar é o que ensina o modelo sem uma linha de texto na tela: clicar no
     * histórico leva à aba que já tem aquilo. É comportamento puro — nenhum
     * pixel novo.
     *
     * ⚠️ `vivaPorIdServidor` é o registro, não o store: ele é quem sabe QUAL
     * aba está amarrada a qual id de servidor (`amarrarAoServidor`). A aba
     * ATUAL não conta — reabrir a conversa que já está na tela continua sendo
     * o recarregar de sempre.
     *
     * Quem troca o foco é a superfície que DONA das abas (a imersiva); esta
     * view só avisa. Fora dela ninguém escuta, e o clique segue como sempre.
     *
     * @returns {Boolean} `true` quando o foco foi pedido e o carregamento
     *   daqui não deve acontecer.
     */
    focouAAbaQueJaTemAConversa(idConversa) {
      const viva = vivaPorIdServidor(idConversa)
      if (!viva) return false
      const atual = this.vivaAtual && this.vivaAtual.idLocal
      if (!atual || viva.idLocal === atual) return false
      this.$emit('focar-conversa-viva', viva.idLocal)
      return true
    },
    /**
     * Esta conversa ainda é a que está na tela?
     *
     * A resposta de um `GET /messages` lento chega quando a pessoa já abriu
     * outra — e daí em diante nada do lote velho pode escrever no store.
     *
     * @param {Object} conversation A conversa cuja resposta acabou de chegar.
     * @returns {Boolean}
     */
    conversaAindaAberta(conversation) {
      const atual = this.selectedConversation
      return Boolean(atual && conversation && atual.id === conversation.id)
    },
    /**
     * ★ [#3 do review do PR #2342] A conversa que o servidor RECUSOU.
     *
     * O `GET /messages` respondia 404 (apagada noutra aba, id de outro
     * escritório) e o `if (status === 200)` simplesmente não entrava: o thread
     * ficava VAZIO, `messagesLoading` caía, e a tela seguia marcando aquela
     * conversa como selecionada — sem uma linha dizendo o que houve. Quem lia
     * via uma conversa que "perdeu as mensagens".
     *
     * Duas coisas, e a segunda conserta a tela: o motivo em snack (o texto do
     * SERVIDOR quando ele manda um; o nosso só quando não há resposta), e a
     * seleção desfeita — é o watcher de `selectedConversation` que anuncia
     * `null` e devolve a URL para a rota sem conversa. ⚠️ A navegação NÃO é
     * feita aqui: quem decide navegar é a superfície (`view-chat-imersivo.vue`
     * ouve `conversa-ativa`), e o popup/painel do Hub não têm rota nenhuma
     * para onde ir.
     *
     * ⚠️ A guarda de corrida NÃO está aqui: quem a aplica é
     * `selecionarConversa`, antes de qualquer ramo (`conversaAindaAberta`) —
     * era uma guarda só do erro, e o caminho feliz corria sem nenhuma.
     * Reconferir aqui seria um segundo dono para o mesmo fato.
     */
    descartarConversaQueNaoAbriu(conversation, r) {
      // ⚠️ A frase do SERVIDOR só vai à tela quando é frase — numa queda de
      // rede `r.message` é a string técnica de `connection.js`
      // (`Network Error(500)`), e o consultor lia isso no meio do chat.
      this.$showSnack({
        status: (r && r.status) || 500,
        message: mensagemAmigavelDoErro(r, ERRO_AO_ABRIR_CONVERSA),
      })
      // ⚠️ `this.ns`, nunca `STORE`: com uma conversa viva (#2349) o slice é o
      // DELA, e escrever no módulo único apagaria a conversa que está na tela.
      this.$store.dispatch(`${this.ns}/setSelectedConversation`, null)
      this.$store.dispatch(`${this.ns}/setMessages`, [])
    },
    /**
     * O que abre quando a tela monta: a conversa da URL, se houver; senão o
     * comportamento de sempre (`iniciarConversaNova`). Método próprio porque o
     * `created()` já estava no teto de statements do ESLint.
     */
    abrirConversaInicial() {
      // ★ O id que a URL já carrega NÃO pode ser reanunciado: quem ouve
      // (`view-chat-imersivo.vue`) navegaria para o endereço em que já está.
      this._idDaConversaAnunciado = this.idDaConversaDaRota || null
      // A URL vence: quem colou o endereço de uma conversa quer ELA, não uma
      // conversa nova por cima dela.
      if (this.iniciarConversaNova && !this.idDaConversaDaRota) {
        this.novaConversa()
      }
      const cargaInicialDeConversas = this.carregarConversas()
      if (!this.idDaConversaDaRota) return
      // DEPOIS da lista, de propósito: é dela que vêm `id_cliente_app`, `topic`
      // e `model` da conversa. Abrir só com `{ id }` restauraria a tela como se
      // ela não tivesse cliente nenhum — apagando o chip de quem tem.
      cargaInicialDeConversas.then(() =>
        this.abrirConversaDaRota(this.idDaConversaDaRota)
      )
    },
    /**
     * Abre a conversa que veio na URL (`/home-ia/c/<uuid>`) — montagem e
     * voltar/avançar no browser passam os dois por aqui.
     *
     * Prefere o item da LISTA ao `{ id }` cru: é ele que carrega
     * `id_cliente_app`, `topic` e `model`, e `restaurarEstadoDaConversa` os lê
     * para devolver a tela ao estado daquela conversa. Sem o item, abre pelo id
     * mesmo assim — o histórico vem do `GET /messages` e a tela fica correta,
     * só sem o chip do cliente. Nunca 404: conversa de outro escritório já é
     * barrada pelo backend, e id inexistente abre vazia.
     */
    async abrirConversaDaRota(idConversa) {
      if (!idConversa) return
      const atual = this.selectedConversation
      if (atual && atual.id === idConversa) return
      const daLista = (
        this.$store.getters[`${this.nsDoHistorico}/conversations`] || []
      ).find((c) => c && c.id === idConversa)
      await this.selecionarConversa(daLista || { id: idConversa })
    },
    /**
     * Os três painéis que pertenciam à conversa ANTERIOR.
     *
     * ★ [merge release/ia-claude-code, 20/09/2026] Método, e não três
     * dispatches soltos: a união das duas branches levou `novaConversa` a 15
     * statements (teto do repo é 14), e a regra daqui é extrair — nunca
     * desabilitar a regra. Os três sempre andaram juntos.
     *
     * - `resetCanaisDoAgente` — plano, entregas, busca e código são do turno
     *   que ficou para trás; sem isto o painel da conversa recém-aberta exibia
     *   a entrega da anterior (medido em 17/09/2026).
     * - `fecharArtefato`/`limparArtefatosDaConversa` — o artefato aberto pela
     *   conversa anterior, mesmo racional/guarda do `selecionarConversa`.
     * - `limparArtefatosDoWorkspace` (★ [E-72], merge de 21/09/2026) — o
     *   ARQUIVO entregue pelo agente, slice `artefatos-do-workspace.js`. Nao
     *   confundir com o indice de cartoes de dado dos dois anteriores.
     */
    limparPaineisDaConversaAnterior() {
      this.$store.dispatch(`${this.ns}/resetCanaisDoAgente`)
      this.$store.dispatch(`${this.ns}/fecharArtefato`)
      this.$store.dispatch(`${this.ns}/limparArtefatosDaConversa`)
      this.$store.dispatch(`${this.ns}/limparArtefatosDoWorkspace`)
    },
    novaConversa() {
      // Começar outra conversa abandona o turno em voo — inclusive o de uma
      // conversa que ainda não recebeu o `start` (sem `selectedConversation`).
      this.descartarTurnoAoSairDaConversa()
      this.desarmarTrilhoQuebrado()
      this.descartarRunAoSairDaConversa()
      this.limparPaineisDaConversaAnterior()
      // ★ Default de toda `novaConversa()`: sem escolha nova declarada, o
      // próximo envio não carrega `agenteSolicitado`. `irParaAgente` (a ÚNICA
      // escolha real) chama este método e religa a marca logo em seguida.
      this.escolhaExplicitaDeAgente = false
      // ⚠️ FICA, e não é redundante com o watcher de `selectedConversation`:
      // numa conversa que ainda NÃO tem id, `novaConversa()` leva o store de
      // `null` para `null` e o watcher não dispara. Sem esta linha, a dispensa
      // dada antes da primeira mensagem atravessaria para a conversa seguinte.
      this.apresentacaoDispensada = false
      // Saindo de uma conversa aberta, o anexo pendente fica nela (mesma
      // razão de `selecionarConversa`). Já no estado vazio (trocar de agente
      // antes da 1ª mensagem) o anexo é do que ainda vai ser escrito — fica.
      if (this.selectedConversation) {
        resetarFilaDeAnexos(this.chaveDaFilaDeAnexos)
      }
      this.$store.dispatch(`${this.ns}/setSelectedConversation`, null)
      this.$store.dispatch(`${this.ns}/setMessages`, [])
      this.esquecerClienteDaConversaAnterior()
    },
    /**
     * Conversa nova nasce GERAL — o cliente não atravessa.
     *
     * Herdar o cliente da anterior é a outra metade do vazamento: quem
     * terminava de falar de um cliente e clicava em "nova conversa" continuava
     * escopado nele sem ter pedido.
     *
     * Método próprio só para caber no `max-statements` do ESLint (14) — a
     * régua do repo é extrair, nunca desabilitar a regra.
     */
    esquecerClienteDaConversaAnterior() {
      if (this.escopoDeCliente) {
        this.$store.dispatch(`${this.ns}/setClienteEscopo`, null)
      }
      // ★ [spec-016 T035] Mesma razão do `setClienteEscopo` acima, mas
      // incondicional (ver `restaurarEstadoDaConversa`).
      this.$store.dispatch(`${this.ns}/setClienteDaConversa`, null)
      // ★ [spec-009 T007] Idem — conversa nova nasce sem vínculo nenhum.
      this.$store.dispatch(`${this.ns}/setClienteFixadoManualmente`, null)
    },
    // Trocar de agente é começar outra conversa: a atual já está travada na
    // persona dela no banco, e a lista e as sugestões são por persona.
    onTrocarAgente(agenteId) {
      if (this.agenteTravado) return
      if (!agenteId || agenteId === this.agenteAtivoId) return
      this.irParaAgente(agenteId)
    },
    // Da sidebar o gesto significa "abrir uma conversa com este agente", então
    // NÃO passa pelo guard de `agenteTravado`: esse guard existe para impedir a
    // troca DENTRO de uma conversa já gravada, e aqui sair dela é o efeito
    // desejado. Sem isto o item da sidebar ficava inerte sempre que houvesse
    // uma conversa aberta — que é o caso comum.
    onEscolherAgenteNaSidebar(agenteId) {
      if (!agenteId) return
      this.irParaAgente(agenteId)
    },
    irParaAgente(agenteId) {
      this.agenteAtivoId = agenteId
      this.publicarAgenteAtivo()
      // Deixa quem controla de fora acompanhar a troca feita pelo composer.
      this.$emit('agent-change', agenteId)
      // ★ A persona do AGENTE, não `personaEfetiva`: na home aquele computed lê
      // o STORE, e publicar a partir dele republicaria a persona VELHA — a
      // troca de agente não sairia do lugar. Aqui o dono do fato é o agente
      // recém-escolhido, e é ele que passa a valer no store.
      this.$store.dispatch(
        `${this.ns}/setPersona`,
        getAgente(agenteId).persona
      )
      this.novaConversa()
      // Depois de `novaConversa()`, que acabou de zerar a marca: É o gesto de
      // ESCOLHER (sidebar, palette, composer) que torna real a próxima
      // escolha — `despacharMensagem` lê esta marca para decidir se manda
      // `agenteSolicitado` no primeiro turno da conversa nova.
      this.escolhaExplicitaDeAgente = true
      // Na navegação (`/ia`) "Recentes" já não filtra por agente
      // (`filtroDeConversas`) — recarregar aqui repetiria a mesma lista sem
      // necessidade. Na página cheia o agente CONTINUA sendo o filtro da
      // lista, então ela precisa vir de novo.
      if (!this.sidebarComoNavegacao) this.carregarConversas()
      this.carregarSugestoes()
    },
    // Ao abrir (na lista "Recentes" ou no palette) uma conversa de um agente
    // diferente do ativo, adota o agente dono ANTES de carregar as mensagens
    // — senão o indicador de agente ativo (ícone da sidebar, chip do
    // composer) ficava divergente da conversa que acabou de abrir. Só faz
    // sentido na navegação: na página cheia toda conversa listada já é do
    // agente ativo, porque a lista ainda filtra por ele.
    //
    // ⚠️ NÃO é `irParaAgente`: aquele começa uma conversa NOVA (chama
    // `novaConversa()`), o que apagaria a própria conversa sendo aberta.
    adotarAgenteDaConversa(conversation) {
      if (!this.sidebarComoNavegacao) return
      if (!conversation || !conversation.context) return
      const agenteId = agenteIdPorPersona(conversation.context)
      if (!agenteId || agenteId === this.agenteAtivoId) return
      this.agenteAtivoId = agenteId
      this.publicarAgenteAtivo()
      this.$emit('agent-change', agenteId)
      this.$store.dispatch(
        `${this.ns}/setPersona`,
        this.personaEfetiva
      )
    },
    /**
     * Publica o agente em uso para quem está FORA desta árvore — hoje o palette
     * da IA, que precisa marcar qual está ativo.
     *
     * ⚠️ Só a superfície de NAVEGAÇÃO publica, mesmo gate do bus da busca
     * global. O popup e o painel do Hub dividem este namespace e recebem agente
     * por prop; se escrevessem aqui, uma instância que o usuário nem vê mudaria
     * a marcação do palette.
     *
     * ⚠️ E é `agenteAtivoId`, não a persona: `painel` e `consultor` apontam para
     * a MESMA, e derivar de volta erraria em silêncio num dos dois.
     */
    publicarAgenteAtivo() {
      if (!this.sidebarComoNavegacao) return
      this.$store.dispatch(
        `${this.ns}/setAgenteAtivo`,
        this.agenteAtivoId
      )
    },
    // As respostas do formulário voltam como o PRÓXIMO turno do gestor: não há
    // endpoint próprio para elas, e o contrato do prompt é só que cheguem
    // emparelhadas com a pergunta (o pareamento é montado em
    // `utils/perguntas-ao-gestor.js`). Reusar `enviarMensagem` mantém um único
    // caminho de envio — mesma trava de `chatLoading`, mesma persistência.
    //
    // ★ **[spec-017 T003] Sobrevive ao Modo de Voz.** O formulário responde a
    // um artefato que o PRÓPRIO turno de voz produziu (a tool
    // `perguntar_ao_gestor`) — mesma régua de `responderCartao` (ADR-017-01):
    // `motorDeVoz.sessaoDeVozAtiva` lida agora, reusando o par
    // `iniciarFalaProgressivaMotor`/`finalizarFalaProgressivaMotor` (ADR-
    // 017-02). Sem sessão ativa, byte a byte o de hoje (`modoVoz: false`).
    //
    // [Hotfix P1, 09/09] `try/finally`: mesmo defeito de `onEnviarVoz` —
    // `enviarMensagem` propaga exceção, e sem o `finally` um turno que falha
    // deixaria `finalizarFalaProgressivaMotor` sem rodar, travando
    // `_aceitandoDeltas` em `true` (mic nunca reabre).
    async responderPerguntas(texto) {
      if (!texto) return
      const vozAtiva = motorDeVoz.sessaoDeVozAtiva
      const geracao = vozAtiva
        ? iniciarFalaProgressivaMotor(this.vozSelecionadaAtual)
        : null
      try {
        await this.enviarMensagem(texto, null, null, { modoVoz: vozAtiva })
      } finally {
        if (vozAtiva) finalizarFalaProgressivaMotor(geracao)
      }
    },
    /**
     * ★ spec-008 [T030c] — o `delegar` do `ContextoDeSessao`.
     *
     * O laço de `function_call` do transporte em tempo real ([T032]) chama
     * ISTO quando o provedor pede uma consulta: o turno TRANSCRITO vira uma
     * mensagem do chat de sempre, com o mesmo SSE, o mesmo RBAC e os mesmos
     * cartões. **Nada de novo no fio** — é o ponto inteiro da D-4.
     *
     * ⚠️ `modoVoz: true` é OBRIGATÓRIO, e não é sobre falar: `modo_voz` é a
     * marca de ORIGEM FALADA no corpo (`apiChat.js::_campoModoVoz`), e é ela
     * que faz o servidor recusar confirmação por palavra dita (US-5 AC1 /
     * D-5). Mandar `false` aqui faria um "sim, pode confirmar" DITO valer
     * como consentimento — exatamente o que a spec proíbe. O efeito colateral
     * (o backend também gera a versão FALADA curta, evento SSE `fala`) é
     * inerte neste caminho: `processarEventoFala` é no-op fora de uma fala
     * progressiva, e quem fala aqui é o provedor, não o nosso TTS.
     *
     * ⚠️ O que volta é `{texto, preview_id}`, não string — a divergência do
     * contrato (`delegar: (texto) => AsyncIterable<string>`) segue reportada
     * desde a [T032]: string não carrega proposta. `_drenar` do lado de lá
     * aceita as duas formas.
     *
     * ⚠️ Declarado: `enviarMensagem` limpa `messageInput`. Quem falou e
     * digitou ao mesmo tempo perde o rascunho — o mesmo comportamento que o
     * Modo de Voz por turnos já tem hoje.
     *
     * ★ **O desfecho é AMARRADO A ESTE TURNO** (spec-008) — as duas metades:
     *
     * 1. **Não houve envio.** `enviarMensagem` recusa em silêncio quando já há
     *    turno em voo (`chatLoading || enviando`). O consultor que faz a
     *    SEGUNDA pergunta enquanto a primeira corre caía aí: a delegação era
     *    descartada e a voz lia o store assim mesmo.
     * 2. **Houve envio e não entrou resposta nova.** `lerDesfechoDoTurnoFalado`
     *    devolve a ÚLTIMA resposta do assistente da CONVERSA — sem nenhuma
     *    amarra com a pergunta recém-feita. Turno que morre sem responder
     *    (cancelamento, queda, fecho sem desfecho) deixa a anterior no topo da
     *    pilha, e ela seria lida como se fosse a resposta.
     *
     * Sem envio, o desfecho é `DESFECHO_SEM_RESPOSTA` inteiro — não houve
     * turno, logo não há artefato nenhum dele. Com envio e sem resposta nova,
     * o que cai é só o TEXTO: a proposta e o valor são de `toolParts`, que já
     * nasce do turno (ver o comentário na chamada abaixo). Nos dois casos, se
     * não sobrar nada, a voz diz que não conseguiu agora e pede para repetir
     * (via `SAIDA_DE_FALHA` — ver `DESFECHO_SEM_RESPOSTA`). É a pior classe de
     * defeito desta spec que isto fecha: a IA afirmando, com confiança, um
     * número que não responde à pergunta que acabou de ser feita.
     */
    async delegarVozTempoReal(pedido) {
      const texto = String((pedido && pedido.texto) || '').trim()
      if (!texto) return DESFECHO_SEM_RESPOSTA
      // Lido ANTES do envio: é a fotografia contra a qual o DEPOIS é comparado.
      const respostasAntes = contarRespostasDoAssistente(
        this.$store.getters[`${this.ns}/messages`]
      )
      const enviado = await this.enviarMensagem(texto, null, null, {
        modoVoz: true,
      })
      if (!enviado) return DESFECHO_SEM_RESPOSTA
      // ★ [T076] ESPERA o turno assentar — ver `esperarRespostaDoTurno`.
      const houveRespostaNova = await this.esperarRespostaDoTurno(
        respostasAntes,
        pedido && pedido.sinal
      )
      // ★ [conversas paralelas] `this.ns`, nunca o `STORE` fixo: numa conversa
      // viva as mensagens estão no módulo dela. Pelo namespace fixo, a leitura
      // cai num store vazio e o turno falado conclui "sem resposta" sempre.
      const mensagens = this.$store.getters[`${this.ns}/messages`]
      // O discriminante continua o mesmo — `contarRespostasDoAssistente` cresceu
      // ou não —, só que agora ele é ESPERADO em vez de conferido uma vez.
      return lerDesfechoDoTurnoFalado({
        // ★ **Só o TEXTO é sujeito a ficar velho**, e por isso só ele é
        // cortado aqui: ele vem de `messages`, que ACUMULA a conversa
        // inteira. A proposta e o valor vêm de `toolParts`, que
        // `apiChat.resetChatState` esvazia (`clearToolParts`) na abertura de
        // TODO turno — já são deste turno por construção, e descartá-los
        // junto apagaria a decisão que o turno de ESCRITA deixou esperando na
        // tela. Sem resposta nova, `[]` faz `_ultimaResposta` devolver `''`,
        // que é exatamente `DESFECHO_SEM_RESPOSTA` quando não há mais nada.
        mensagens: houveRespostaNova ? mensagens : [],
        // ⚠️ O slice `toolParts` é COMPOSTO no namespace raiz (`store/index.js`
        // faz `{...getters, ...toolPartsGetters}`), NÃO registrado como
        // sub-módulo: `${STORE}/toolParts/toolPartsOrdenadas` devolve
        // `undefined` em silêncio, e o turno de escrita nunca remeteria ao
        // cartão. É o mesmo caminho que `chat-message.vue` já lê.
        partesDeTool: this.$store.getters[`${this.ns}/toolPartsOrdenadas`],
      })
    },
    /**
     * ★ [spec-008 T076] ESPERA a resposta do turno — e existe por um defeito
     * medido no fio, não por precaução.
     *
     * **O que acontecia.** `enviarMensagem` devolve quando o turno foi
     * DESPACHADO, e a voz lia o desfecho no instante seguinte. No Modo Chat
     * isso funciona por acidente: lá o envio aguarda o stream SSE inteiro, e
     * quando ele retorna a resposta já está no store. No **Modo Agente** o
     * `POST /runs` devolve assim que a run é ACEITA — em ~400 ms — e a
     * resposta chega depois, pelo relay.
     *
     * Medido em 19/09/2026 (`promessa-exec300`, com o worker real executando):
     *
     * | instante | o que aconteceu |
     * |---|---|
     * | 15.384 ms | a IA fala "Já vejo isso pra você" |
     * | 15.771 ms | sai o ack dos dois tempos (`em_andamento`) |
     * | **16.132 ms** | a voz desiste: *"Não consegui concluir a consulta agora."* |
     * | **262.000 ms** | a resposta chega à tela: **"Você tem 849 tarefas"** |
     *
     * A voz abandonava em 16 s uma consulta de 4 minutos, e dizia ao consultor
     * que não tinha conseguido — enquanto o número aparecia na tela dele.
     *
     * ★ **A condição esperada é a MESMA que já se conferia**
     * (`contarRespostasDoAssistente` crescer). O que muda é olhar de novo em
     * vez de decidir na primeira olhada. No Modo Chat a primeira olhada já
     * acha, então nada fica mais lento ali — a espera custa zero onde não é
     * necessária.
     *
     * ⚠️ **O sinal de aborto é honrado.** É por ele que o encerramento da
     * sessão e a D-11 (resultado de correlação velha) continuam podendo
     * cortar a espera; sem isso, fechar o modo de voz deixaria uma promessa
     * pendurada até o teto.
     *
     * @param {number} respostasAntes A contagem de antes do envio.
     * @param {AbortSignal=} sinal O sinal da delegação em voo.
     * @returns {Promise<boolean>} `true` se entrou resposta nova.
     */
    async esperarRespostaDoTurno(respostasAntes, sinal) {
      // ⚠️ O teto vem do `data`, não da constante direto, e por um motivo
      // concreto: o caso "turno que morre calado" existe na suíte desde a
      // T065, e com o teto de 300 s ele passaria a levar 300 s. O default É a
      // constante — quem não mexe não muda nada.
      const tetos = this.tetosDaEsperaDoTurno()
      const desistirDaRun = this.criarVigiaDaRunEmVoo(tetos.semProgresso)
      const limite = Date.now() + tetos.absoluto
      // ★ [spec-008 T098] A espera passou a dizer POR QUE terminou.
      //
      // ⚠️ Medido em 19/09: o dado chegou à tela, e o desfecho **nunca foi
      // entregue ao fio** — nem falado, nem por `function_call_output`. Isso
      // só acontece se `delegar` não resolver, e `delegar` espera AQUI. Sem
      // este registro, esta função era a única caixa não iluminada do
      // caminho, e o G6 ficava atribuído ao provedor por eliminação —
      // eliminação que dependia justamente do que não estava medido.
      const _fim = (motivo, valor) => {
        const banca = globalThis.__voz
        if (banca && Array.isArray(banca.microfone)) {
          banca.microfone.push({
            evento: 'espera_terminou',
            motivo: motivo,
            respostasAntes: respostasAntes,
            ms: Date.now(),
          })
        }
        return valor
      }
      for (;;) {
        if (sinal && sinal.aborted) return _fim('abortada', false)
        const agora = contarRespostasDoAssistente(
          this.$store.getters[`${this.ns}/messages`]
        )
        if (agora > respostasAntes) return _fim('resposta_nova', true)
        if (desistirDaRun()) return _fim('run_desistiu', false)
        if (Date.now() >= limite) return _fim('teto_absoluto', false)
        await new Promise((resolve) => {
          setTimeout(resolve, MS_ENTRE_OLHADAS_NO_TURNO)
        })
      }
    },
    /**
     * Os dois tetos da espera, com os defaults das constantes. Vivem em `data`
     * para a suíte poder encurtá-los — ver `esperarRespostaDoTurno`.
     */
    tetosDaEsperaDoTurno() {
      return {
        absoluto:
          typeof this.tetoDaRespostaDoTurnoMs === 'number'
            ? this.tetoDaRespostaDoTurnoMs
            : MS_TETO_DA_RESPOSTA_DO_TURNO,
        semProgresso:
          typeof this.tetoSemProgressoDaRunMs === 'number'
            ? this.tetoSemProgressoDaRunMs
            : MS_SEM_PROGRESSO_DA_RUN,
      }
    },
    /**
     * ★ [spec-008 T077/T078] O vigia da run em voo: devolve uma função que
     * responde *"parar de esperar por ela?"* e guarda o próprio marco.
     *
     * **Dois motivos para parar, e eles são opostos:**
     *
     * 1. **[T078] Ela está esperando um HUMANO** (`awaiting_approval`). O run
     *    está vivo e vai continuar vivo — por ~34 min, até a proposta expirar.
     *    Esperar aqui é queimar sessão paga e, pior, calar sobre uma decisão
     *    que está na tela. Ver `ESTADO_DA_RUN_AGUARDANDO_DECISAO`.
     * 2. **[T077] Ela EMUDECEU** — nenhum frame novo por `tetoSemProgresso`.
     *
     * O estado (último cursor visto, instante do último avanço) fica FECHADO
     * aqui em vez de solto no laço da espera — assim o laço não pode esquecer
     * de atualizá-lo, que é o modo de falha silencioso deste desenho.
     *
     * ⚠️ **`marco` nulo nunca emudece**, e isso não é zelo: no Modo Chat não
     * existe run publicando cursor (`runAtual` é `null`), e sem ele não há
     * como distinguir "pensando" de "morto". Sem esta guarda, todo turno de
     * chat mais lento que o teto seria cortado no meio.
     *
     * ★ [review #2364] O run é lido por `this.runAtual` (o mixin do Modo
     * Agente, recortado para ESTA conversa por `runDaConversa`), nunca por
     * `${ns}/runAtual`: o run mora no store FIXO, e na Home IA `ns` é o
     * namespace da conversa — ali o getter devolvia `null`, o marco ficava
     * nulo e a espera da voz não parava nem por silêncio nem por
     * `awaiting_approval`. `view-chat.vigia-da-run-por-conversa.unit.js`.
     *
     * @param {number} tetoSemProgresso ms de silêncio que encerram a espera.
     * @returns {function(): boolean}
     */
    criarVigiaDaRunEmVoo(tetoSemProgresso) {
      let marco = this.marcoDaRunEmVoo()
      let desdeQuando = Date.now()
      return () => {
        const run = this.runAtual
        if (run && run.estado === ESTADO_DA_RUN_AGUARDANDO_DECISAO) return true
        const agora = this.marcoDaRunEmVoo()
        if (houveAvancoDaRun(marco, agora)) {
          marco = agora
          desdeQuando = Date.now()
        }
        return Boolean(marco) && Date.now() - desdeQuando >= tetoSemProgresso
      }
    },
    /**
     * ★ [spec-008 T077] A fotografia do cursor da run em voo — `null` quando
     * não há run publicando (Modo Chat).
     *
     * O `seq` vem de `_avancarCursorSeNecessario` (`apiChatModoAgente.js`), que
     * só avança com frame REALMENTE aplicado. É por isso que ele serve de prova
     * de vida: número maior = o relay entregou coisa nova.
     *
     * @returns {?{idRun: ?string, seq: number}}
     */
    marcoDaRunEmVoo() {
      // O MESMO recorte do chip (`this.runAtual`) — ver `criarVigiaDaRunEmVoo`.
      const run = this.runAtual
      if (!run || typeof run.seq !== 'number') return null
      return { idRun: run.id_run || null, seq: run.seq }
    },
    /**
     * ★ spec-008 [T065] — o `lerValorParcialDoTurno` do `ContextoDeSessao`
     * (D-O-5): *"pode até adiantar número se já tiver isso (ou seja, se a
     * resposta já estiver nas mãos do agente)"*.
     *
     * É o MESMO store do `delegarVozTempoReal`, lido num instante diferente:
     * lá, quando o turno acabou; aqui, **enquanto ele corre**. O cartão entra
     * no store quando a TOOL dele fecha, e o turno segue depois — essa é a
     * janela em que o número já está na tela e a voz ainda diz "estou
     * consultando".
     *
     * ⚠️ Método, não computed, e pelo mesmo motivo de `nomeDoConsultor`: o
     * transporte o chama a cada acompanhamento da espera (a cada 8/13 s), e
     * um computed entregaria o valor de quando a sessão abriu — que é sempre
     * `null`, porque a consulta nem tinha começado.
     *
     * ⚠️ `${STORE}/toolPartsOrdenadas` no namespace RAIZ, não
     * `${STORE}/toolParts/…`: o slice é COMPOSTO em `store/index.js`
     * (`{...getters, ...toolPartsGetters}`), e o caminho com sub-módulo
     * devolve `undefined` **em silêncio** — a voz voltaria a nunca adiantar
     * número, sem nada vermelho em lugar nenhum.
     */
    lerValorParcialDoTurnoVoz() {
      return lerValorParcialDoTurnoFalado({
        partesDeTool: this.$store.getters[`${this.ns}/toolPartsOrdenadas`],
      })
    },
    /**
     * Os dois motivos de RECUSAR um envio — e nenhum deles pode ser mudo,
     * porque silêncio aqui custa dinheiro do escritório.
     *
     * 1. **Trilho quebrado** (19/09/2026): a conversa morreu no render e a
     *    tela está em branco. Deixar passar manda a pergunta ao backend, gasta
     *    modelo e não mostra nada — foi o que o QA da spec-006 mediu: 13
     *    turnos, créditos 4.986,80 → 4.974,44. Vem PRIMEIRO porque é o estado
     *    mais grave e o único do qual não se sai sem recarregar.
     * 2. **Turno em voo** ([STRESS r2, N-1]): antes era `return` mudo, e o
     *    clique sumia sem sinal — 11 envios engolidos na medição.
     *    `:loading="turnoEmVoo"` já cobre o caso comum; este é o backstop do
     *    Enter apertado antes de o render reagir à prop.
     *
     * Extraído de `enviarMensagem` para caber no `max-statements` do ESLint,
     * e porque "quando o envio é recusado" merece um nome.
     */
    envioRecusado() {
      if (this.trilhoQuebrado) {
        this.$showSnack({
          text: COMPOSER_CHAT.trilhoQuebradoAviso,
          color: 'danger',
          button: true,
        })
        return true
      }
      if (this.chatLoading || this.enviando) {
        this.$showSnack({
          text: COMPOSER_CHAT.turnoEmVooAviso,
          color: 'warning',
          button: true,
        })
        return true
      }
      return false
    },
    /**
     * ★ **O retorno é ADITIVO** (spec-008): `true` quando o turno FOI
     * despachado, `false` quando este método recusou ANTES de enviar (campo
     * vazio, ou turno em voo). Os oito outros chamadores —
     * `despacharPerguntaInicial`, `responderPerguntas`, `usarSugestao`,
     * `onSendMessage`, `onEnviarVoz` e, no mixin do Modo Agente,
     * `onPedirNovaProposta`/`confirmarAcao`/`cancelarAcao` — ignoram o
     * retorno e seguem byte a byte como hoje (antes ele era `undefined`, que
     * é falsy pelo mesmo critério).
     *
     * Quem PRECISA dele é `delegarVozTempoReal`: sem distinguir *enviado* de
     * *recusado*, a recusa muda deste guard fazia a voz ler o store e afirmar
     * o desfecho da pergunta ANTERIOR — um número que não responde ao que o
     * consultor acabou de perguntar.
     *
     * ⚠️ NÃO cobre o turno que sai e FALHA: aí este método propaga a exceção
     * (`despacharMensagem` não tem try/catch) ou devolve `true` com o erro já
     * na tela. Quem amarra esse caso ao turno é a contagem de respostas, em
     * `delegarVozTempoReal`.
     *
     * @returns {Promise<boolean>} `true` = despachado; `false` = recusado aqui.
     */
    async enviarMensagem(query, anexos, anexosProntos, { modoVoz = false, comando = null } = {}) {
      const text = (query || this.messageInput).trim()
      // `comando` [T018] chega SEMPRE com `label`/`slug` não vazio
      // (`usarComando` já garante), então `text` nunca é vazio aqui — não é
      // preciso relaxar este guard.
      //
      // ★ [merge release/ia-claude-code, 20/09/2026] `return false`, e não o
      // `return` mudo: `delegarVozTempoReal` distingue *recusado aqui* de
      // *despachado* pelo retorno — sem o booleano, a voz leria o store e
      // afirmaria o desfecho da pergunta ANTERIOR.
      if (!text) return false
      if (this.envioRecusado()) return false
      // Síncrono, antes de qualquer await: é isso que fecha a janela entre o
      // guard e o `setChatLoading(true)` de dentro do apiChat.
      this.enviando = true
      this.messageInput = ''
      this.tocarConversaSelecionada()

      try {
        await this.despacharMensagem(text, anexos, anexosProntos, modoVoz, comando)
      } finally {
        // `finally`: se o envio lançar, a trava PRECISA cair — senão o chat
        // fica mudo para sempre e só um F5 devolve o envio ao gestor.
        this.enviando = false
      }

      // DEPOIS do turno: só com a entrega na mão dá para saber de quem ela é.
      await this.reancorarNoClienteDaEntrega(comando)

      this.carregarConversas()
      return true
    },
    /**
     * O turno nomeou OUTRO cliente — a conversa reancora nele (G-R2-9).
     *
     * Régua: **explícito vence implícito**. O chip é âncora implícita (o
     * consultor escolheu antes, para outra coisa); o nome digitado no comando
     * é escolha explícita e mais recente. Manter os dois é a violação de "uma
     * fonte de verdade" que o QA mediu: entrega do Ilo, contexto do Murilo, e
     * o turno seguinte respondendo pelo cliente errado sem avisar.
     *
     * Três travas, e cada uma existe por um motivo diferente:
     *
     * 1. **Só comando COM argumento.** Sem o nome digitado não houve escolha
     *    explícita nenhuma — o atalho clicado já leva `comando.id_cliente` do
     *    chip (G-1), e reancorar ali seria mexer no que o consultor não pediu.
     * 2. **Só quando a entrega declara cliente DIFERENTE** do que está em
     *    foco (`precisaReancorar`) — senão todo turno de atalho faria um PATCH
     *    para gravar o que já está gravado.
     * 3. **Grava no SERVIDOR** (`trocarClienteExplicitamente` → PATCH
     *    `vincularCliente`), nunca só no chip: conversa reancorada em memória
     *    e não no banco é o mesmo defeito, do outro lado — o F5 (que restaura
     *    o cliente do `localStorage`/servidor, não da URL) desfaria a troca.
     *
     * ⚠️ O conserto de RAIZ é do backend: a tool do atalho deve declarar o
     * cliente pelo evento `cliente-identificado`, que `apiChat` já sabe
     * consumir (`_onClienteIdentificado`, que reancora E grava). Medido no fio
     * em 19/09/2026: o turno do atalho NÃO emite esse evento. Enquanto não
     * emitir, o cartão é a única declaração disponível — ver
     * `utils/cliente-da-entrega.js`.
     */
    async reancorarNoClienteDaEntrega(comando) {
      if (!comando || !comando.argumento) return
      // ⚠️ O thread NÃO é `this.messages` — esta view não tem essa propriedade.
      // Quem guarda o turno é o store (mesma fonte de `hasMessages`); ler do
      // componente devolvia `undefined` e a guarda saía calada (medido 19/09).
      const idDaEntrega = clienteDaEntregaDoTurno(this.mensagensDoTurno())
      const emFoco = this.clienteEscopo
      if (!precisaReancorar(idDaEntrega, emFoco && emFoco.id)) return

      const cliente = this.clienteDaCarteiraPorId(idDaEntrega)
      await this.trocarClienteExplicitamente(cliente)
      // A troca é ANUNCIADA: o consultor não pode descobrir depois que o foco
      // mudou. Snack (e não faixa) porque é um fato do turno que acabou, não
      // um estado permanente da tela — o cabeçalho já passa a nomear o novo.
      this.$showSnack({
        text: CLIENTE_REANCORADO(cliente.name),
        color: 'info',
        button: true,
      })
    },
    /**
     * As mensagens do thread, pelo store. Não existe `this.messages` aqui: o
     * componente só encaminha para `messages.vue`, que lê o mesmo getter.
     */
    mensagensDoTurno() {
      return this.$store.getters[`${STORE}/messages`] || []
    },
    /**
     * O objeto do cliente para o chip. O nome vem da carteira já carregada
     * (`user/allClients`, a mesma fonte do seletor); sem ele, o id sozinho
     * ainda reancora — âncora certa sem rótulo é melhor que âncora errada com
     * rótulo, e o cabeçalho se completa no próximo carregamento.
     */
    clienteDaCarteiraPorId(id) {
      const lista = this.$store.getters['user/allClients']
      const achado = Array.isArray(lista)
        ? lista.find((c) => c && String(c.id) === String(id))
        : null
      if (achado) return achado
      return { id: id, name: '', codigo_corretora: null }
    },
    // A conversa que acabou de receber mensagem sobe em "Recentes" na hora:
    // o servidor só carimba `updated_at` no fim do turno, e a lista é
    // ordenada por ele (getter `conversations`). O `carregarConversas()` do
    // fim de `enviarMensagem` confirma com o valor do servidor. Conversa
    // nova (sem `selectedConversation`) ainda não está na lista — só o
    // recarregar a traz.
    tocarConversaSelecionada() {
      const conv = this.selectedConversation
      if (!conv || !conv.id) return
      this.$store.dispatch(`${this.ns}/tocarConversa`, { id: conv.id })
    },
    // Monta o payload e trata a falha de envio. Separado de `enviarMensagem`
    // porque lá o que importa é a trava; aqui, o contrato com a API.
    //
    // `modoVoz` NUNCA é lido de `motorDeVoz.modoDeVoz`/`sessaoDeVozAtiva`
    // aqui — é passado explicitamente por quem chama. [voz v3, 08/09] O
    // motor RESETA `modoDeVoz` (via `resetarEstado()`, dentro do próprio
    // `parar()` que dispara o envio) antes deste método rodar de fato;
    // depender do estado reativo criaria uma corrida de timing implícita e
    // frágil entre `transcreverEDistribuir` → `aoEnviarVoz` → `enviarMensagem`
    // e o `finally` de `parar()`. `onEnviarVoz` abaixo é o único chamador
    // que passa `{modoVoz: true}` — a digitação (`onSendMessage`) nunca passa.
    /**
     * Este turno é da APRESENTAÇÃO — e por isso NÃO pode sair pelo Modo Agente.
     *
     * ⚠️⚠️ **O onboarding vive numa porta só, e ela é `/chat`.** As etapas são
     * resolvidas em `usecase_ia_crm_chat.atender` (`_versao_do_primeiro_contato`
     * e `_etapa_do_onboarding`), e `atender` só é chamado por
     * `resource_chat.py`. O `POST /runs` enfileira o turno para o
     * `aawz-agent-worker` — outro serviço, que nunca passa por `atender`:
     * conferido por `grep`, o pipeline de run não tem uma ocorrência sequer de
     * "onboarding".
     *
     * Medido no navegador em 19/09/2026, com o Modo Agente ligado (é o padrão
     * desde 18/09): o "Pular esta etapa" saía por `POST /runs`, o run ficava
     * `queued` para sempre e a tela em "Pensando…" — a etapa seguinte nunca
     * vinha. Com o worker de pé o desfecho seria outro e igualmente errado: um
     * modelo respondendo "Pular esta etapa" como se fosse uma pergunta, em vez
     * do cartão determinístico da etapa 2.
     *
     * Duas entradas, e qualquer uma basta:
     * - a apresentação está CONDUZINDO (a última do assistente é uma etapa) —
     *   cobre "Continuar", "Pular", o formulário e a etapa "Dia a dia";
     * - o texto É o comando — cobre a degradação da primeira pergunta, que sai
     *   como TEXTO quando o chip não pôde ser posto.
     *
     * ★ Quem dispensou a apresentação ("Continuar sem a apresentação") saiu do
     * trilho de propósito: a mensagem dela é uma mensagem comum, e segue a
     * bifurcação de sempre.
     */
    turnoEhDoOnboarding(text) {
      if (String(text || '').trim() === PRIMEIRA_PERGUNTA_DO_PRIMEIRO_CONTATO) {
        return true
      }
      if (!this.onboardingConduzindo) return false
      // ★ [21/09/2026] A fala do CARTÃO vai por `/chat` mesmo depois da
      // dispensa: "Continuar sem a apresentação" destrava o composer para a
      // fala LIVRE (que o servidor manda ao modelo desde o mesmo dia), mas os
      // botões do cartão continuam na conversa — e o `POST /runs` não conhece
      // o onboarding. Sem isto, o "Continuar" clicado depois da dispensa saía
      // como texto livre para o worker com `IA - Agente` ligada.
      if (ehFalaDoCartaoDeOnboarding(text)) return true
      return !this.apresentacaoDispensada
    },
    async despacharMensagem(text, anexos, anexosProntos, modoVoz = false, comando = null) {
      const conv = this.selectedConversation
      // ★ merge PR #2242 — US-9 (spec-002): com a feature `IA - Agente` ligada
      // o turno sai por `POST /runs` (Modo Agente); desligada, segue pelo Modo
      // Chat exatamente como hoje, sem nenhum evento novo no fio. É a única
      // bifurcação do envio, e ela vem ANTES de montar o corpo do POST.
      //
      // ★ [17/09/2026] A bifurcação ganhou uma SAÍDA DE VOLTA: quando o
      // backend recusa o aceite por FUNCIONALIDADE não contratada, o turno
      // não morre — desce para o Modo Chat com o mesmo texto, os mesmos
      // anexos e a mesma marca de origem falada. O motivo e o que exatamente
      // conta como "recusa por funcionalidade" estão em
      // `view-chat-modo-agente.mixin.js::despacharMensagemModoAgente` e em
      // `utils/recusa-de-funcionalidade.js`. Toda outra recusa continua
      // fechando o desfecho lá dentro, e este método retorna sem despachar
      // nada — como sempre.
      if (this.modoAgenteLigado && !this.turnoEhDoOnboarding(text)) {
        const redespacharPeloModoChat = await this.despacharMensagemModoAgente(
          text, conv, { anexos, anexosProntos, modoVoz }
        )
        if (!redespacharPeloModoChat) return
      }
      // ★ [merge release/ia-claude-code, 20/09/2026] `comando` viaja junto: a
      // release extraiu este corpo para `despacharMensagemModoChat` e a nossa
      // branch acrescentou o campo do ATALHO ao `sendMessage` lá dentro — sem
      // este parâmetro o atalho digitado/clicado saía do corpo do turno.
      await this.despacharMensagemModoChat(text, anexos, anexosProntos, modoVoz, comando)
    },
    /**
     * O envio pelo Modo Chat (`POST /chat`) — o corpo do turno de sempre.
     *
     * Extraído de `despacharMensagem` sem nenhuma mudança de lógica: agora ele
     * tem DOIS chamadores (o envio normal com o Modo Agente desligado, e a
     * queda por recusa de funcionalidade), e o que era um `if/return` com o
     * corpo solto abaixo viraria dois caminhos difíceis de ler.
     *
     * `selectedConversation` é relido aqui de propósito: na queda, o aceite
     * recusado não mexe na conversa selecionada (`aceitarRun` só a troca no
     * caminho 200), então é o MESMO objeto que `despacharMensagem` leu — e no
     * envio normal era daqui que ele já vinha.
     */
    async despacharMensagemModoChat(text, anexos, anexosProntos, modoVoz = false, comando = null) {
      const conversationId = this._idDaConversaParaOTurno()

      const storeState = this.$store.state[this.ns] || {}
      const model = storeState.selectedModel || null
      const thinkingEnabled = storeState.thinkingEnabled !== false
      // Só a PRIMEIRA mensagem da conversa nascida de uma escolha explícita
      // (`irParaAgente`) leva `agenteSolicitado` — nunca o agente ativo por
      // default, e nunca no 2º turno em diante (a conversa já existe e já
      // nasceu com esse agente; `_buildChatBody` também guarda por
      // `conversationId`, cinto e suspensório com `reenviarUltimoTurno`).
      //
      // ★ `agentSlugRequisitavel`, NUNCA `agenteAtivoId` cru: manda só quando
      // o item escolhido É um agente do catálogo (`constants/Agentes.js`
      // documenta item a item por que painel/consultor/operacional não têm
      // `agentSlug` — hoje só `fee-fixo` manda).
      const agenteSolicitado =
        this.escolhaExplicitaDeAgente && !conversationId
          ? agentSlugRequisitavel(this.agenteAtivoId)
          : null
      const r = await this.motor.sendMessage({
        message: text,
        conversationId: conversationId,
        answerStyle: 'direto',
        model: model,
        thinkingEnabled: thinkingEnabled,
        origemModulo: this.origemModulo,
        idClienteApp: this.idClienteEmFoco,
        agenteSolicitado: agenteSolicitado,
        // ⚠️ EXIBIÇÃO, não envio. Este `File[]` alimenta só a bolha do
        // usuário — nunca o corpo do POST (`File` não serializa em JSON).
        anexosParaExibir: anexos,
        // ★ [spec-016 T023] O campo de REDE de verdade — uploads que JÁ
        // terminaram com sucesso (`send-message-anexos-upload-mixin.js`).
        // Só entra quando não vazio (`_buildChatBody` descarta `[]`).
        anexos: anexosProntos,
        modoVoz: modoVoz,
        comando: comando,
      })
      if (agenteSolicitado) {
        this.reconciliarAgenteRequisitado(agenteSolicitado, r)
      }
      if (this.deveAvisarFalhaDeEnvio(r)) {
        this.$showSnack({
          text: this.textoDaFalhaDeEnvio(r),
          color: 'error',
          button: true,
        })
      }
    },
    /**
     * O backend pode RECUSAR o `agenteSolicitado` pedido (guard de
     * elegibilidade — RBAC, funcionalidade do escritório, ou o slug não
     * existir/não estar publicado). A recusa NUNCA é erro HTTP: o turno cai
     * no roteador normal, em silêncio (`nos.py::montar_no_route_domains`,
     * loga e segue). Sem esta reconciliação, a sidebar continuaria marcando
     * o agente PEDIDO mesmo respondendo outro — a mesma mentira que esta
     * feature existe para corrigir, só que ao contrário.
     *
     * A fonte do agente REAL é `agent-selected` (sempre emitido logo após
     * `route_domains`, pedido honrado ou não — `apiChat.js::_onAgentSelected`),
     * comitado no `end` em `agentePorMensagem[idDaMensagem]`
     * (`store/hub-e-agente.js`) — por isso só dá para conferir DEPOIS que
     * `sendMessage` resolve (o turno já terminou).
     */
    reconciliarAgenteRequisitado(agenteSolicitadoPedido, resposta) {
      const idDaMensagem = resposta && resposta.id
      if (!idDaMensagem) return
      const mapa =
        this.$store.getters[`${this.ns}/agentePorMensagem`] || {}
      const entrada = mapa[idDaMensagem]
      // `entrada.agentSlug` é o eixo RF-G2 (o agente que RESPONDEU o turno,
      // vindo de `agent-selected`) — nome de campo diferente do
      // `agenteSolicitado` que mandamos, mas é exatamente o que compara aqui.
      const agenteReal = entrada && entrada.agentSlug
      if (!agenteReal || agenteReal === agenteSolicitadoPedido) return
      const agenteResolvido = agenteIdPorAgentSlug(agenteReal)
      if (agenteResolvido === this.agenteAtivoId) return
      this.agenteAtivoId = agenteResolvido
      this.publicarAgenteAtivo()
      this.$emit('agent-change', agenteResolvido)
      this.$store.dispatch(
        `${this.ns}/setPersona`,
        getAgente(agenteResolvido).persona
      )
    },
    /**
     * Vale avisar que o envio falhou? ([T024], achado 2 do E2E)
     *
     * Cancelamento NÃO é falha: quando o próprio cliente aborta o POST — porque
     * o usuário saiu da tela, ou porque a tool de front navegou —, o servidor
     * recebeu a mensagem e seguiu com o turno. A copy "a conversa não foi
     * salva" só é verdadeira quando ele não recebeu.
     */
    deveAvisarFalhaDeEnvio(r) {
      if (!r || !(r.status >= 400)) return false
      return !foiCancelado(r)
    },
    /**
     * O que o gestor lê quando o envio falha ([T024], achado 4 do E2E).
     *
     * A `message` do servidor vem primeiro porque é a única frase que diz O QUE
     * aconteceu — o envelope do contrato da casa (HTTP 200 com `status` no
     * corpo) a carrega tanto na recusa (403) quanto na falha (500), e o
     * `apiChat` agora também a devolve quando o turno morre pelo evento SSE
     * `error`. A copy fixa fica para quando não há explicação nenhuma.
     */
    textoDaFalhaDeEnvio(r) {
      const doServidor = String((r && r.message) || '').trim()
      return doServidor || COPY_FALHA_DE_ENVIO
    },
    onOpenService(payload) {
      this.$emit('open-service', payload)
    },
    escolherFerramenta(modulo) {
      this.ferramentaSelecionada = modulo || null
      // O comando some do campo assim que vira chip: deixar `/crm` escrito
      // faria a pessoa apagar à mão antes de digitar a pergunta — e o texto
      // ainda seria enviado junto se ela não percebesse.
      if (this.messageInput.indexOf('/') === 0) this.messageInput = ''
    },
    limparFerramenta() {
      this.ferramentaSelecionada = null
    },
    usarSugestao(text) {
      // A sugestão já é a fala completa: o módulo só escolheu os cards e sai
      // aqui. O prefixo `/crm` vai na fala apenas quando o envio sai do
      // composer com o chip (`send-message-atalhos-mixin::comComandoDoModulo`).
      this.ferramentaSelecionada = null
      this.enviarMensagem(text)
    },
    /**
     * Um atalho de negócio da home-ia foi escolhido — spec-001
     * `project-home-ia-skills/preparacao-reuniao`, [T018], US-1.
     *
     * `comando: {slug, argumento, label}` — o campo estruturado, NUNCA texto
     * livre (`core/atalhos/preflight.py`: "não há parsing de texto
     * digitado"). O texto que aparece na bolha do usuário é o `label` do
     * atalho ("/pré-reunião") — é ele que vira `query` no corpo do `/chat`
     * (`contracts/api.md` §2: "a fala do comando"); o backend descarta o
     * `query` quando `comando` está presente
     * (`resource_chat.py`: `query=None if comando is not None else query`).
     */
    usarComando(comando) {
      if (!comando || !comando.slug) return
      this.ferramentaSelecionada = null
      this.enviarMensagem(comando.label || comando.slug, null, null, {
        comando: this.comandoDeAtalhoParaOCorpo(comando),
      })
    },
    /**
     * O `comando` do CORPO, montado chave a chave.
     *
     * ⚠️ Montado, nunca espalhado: o objeto que chega aqui é a AÇÃO da tela
     * (`acoes-por-modulo.vue` emite `{...acao.comando, label}`, com
     * `pedeArgumento` junto), e `ComandoDeAtalho` é `extra='forbid'` no
     * servidor — qualquer chave a mais levanta `ValidationError` e o turno
     * nem abre. Só `slug`, `argumento` e `id_cliente` existem lá.
     *
     * `id_cliente` só entra quando HÁ escolha (ver
     * `idClienteFixadoParaOAtalho`): sem ela a chave fica fora e o corpo
     * segue byte a byte o de antes desta correção.
     *
     * ⚠️ **[G-R2] `argumento` e `id_cliente` são MUTUAMENTE EXCLUSIVOS.**
     * No servidor, `id_cliente_app` sempre vence o nome
     * (`core/visoes/entidades.py`) — mandar os dois juntos fazia o nome
     * digitado ser descartado em silêncio: o consultor escrevia
     * `/pré-reunião Ilo Santos` com Murilo no chip "Cliente em foco" e
     * recebia a pauta do Murilo. Com os dois na carteira dele, NENHUMA
     * recusa avisava. Quem digita um nome está escolhendo outra pessoa —
     * o nome ganha, e o chip fica fora do corpo.
     */
    comandoDeAtalhoParaOCorpo(comando) {
      const campo = {
        slug: comando.slug,
        argumento: comando.argumento != null ? comando.argumento : null,
      }
      const idCliente = this.idClienteFixadoParaOAtalho
      if (idCliente != null && campo.argumento == null) campo.id_cliente = idCliente
      return campo
    },
    /**
     * Renomear pelo menu de Recentes.
     *
     * ⚠️ [owner, 20/09/2026] *"o renomeio de conversa no recentes não tá
     * funcionando"* — e era regressão da mudança que levou a LISTA para o
     * módulo fixo: o dispatch ia só para `this.ns`, o módulo DA CONVERSA, cuja
     * lista é vazia. `UPDATE_CONVERSATION_TOPIC` reescrevia um array sem o
     * item e Recentes não mudava.
     *
     * São DOIS namespaces porque a mutation faz duas coisas, e cada uma mora
     * num lugar: a LISTA (Recentes) no fixo, e `selectedConversation` — que é
     * de onde o nome da ABA sai primeiro — na conversa. Fora da Home IA os
     * dois são o mesmo e o segundo dispatch é inofensivo (idempotente).
     *
     * ★ E a ABA acompanha de graça: `tituloDaAba` lê `selectedConversation`
     * (a aba dona) e, para as outras, a lista do fixo.
     */
    async renomearConversa({ id, topic }) {
      if (!id || !topic) return
      const renomeio = { id, topic }
      this.$store.dispatch(`${this.nsDoHistorico}/updateConversationTopic`, renomeio)
      if (this.ns !== this.nsDoHistorico) {
        this.$store.dispatch(`${this.ns}/updateConversationTopic`, renomeio)
      }
      await apiConversations.renameConversation({ id, topic })
    },
    async deletarConversa(conversation) {
      if (!conversation || !conversation.id) return
      const r = await apiConversations.deleteConversation({
        id: conversation.id,
      })
      if (r && r.status === 200) {
        const sel = this.selectedConversation
        if (sel && sel.id === conversation.id) {
          this.novaConversa()
        }
        this.carregarConversas()
      }
      this.$showSnack(r)
    },
    // Seleção em lote (ctrl+click) das "Recentes" na imersiva. O backend só
    // tem exclusão unitária (`PATCH /conversations/<id>`) — sem endpoint de
    // lote, o loop sequencial é o mesmo padrão de
    // `views/curadoria/view-curadoria.vue::descartarEmLote`.
    async deletarConversasEmLote(ids) {
      if (!ids || !ids.length) return
      let falhas = 0
      for (const id of ids) {
        const r = await apiConversations.deleteConversation({ id })
        if (!r || r.status !== 200) falhas += 1
      }
      const sel = this.selectedConversation
      if (sel && ids.includes(sel.id)) this.novaConversa()
      this.carregarConversas()
      this.$showSnack(
        falhas
          ? {
              text: `${falhas} de ${ids.length} conversa(s) não puderam ser removidas.`,
              color: 'error',
              button: true,
            }
          : { text: 'Conversas removidas.', color: 'success', button: true }
      )
    },
    // `comentario` (spec-011 T003, AC2.1/AC2.2): opcional, sobe junto do
    // {messageId, feedback} que `feedback-buttons.vue` emite. Repassado ao
    // backend (que grava em `_mensagens.feedback_comentario`) e ao store
    // (pra reaparecer sem reload, igual `feedback` já fazia).
    async darFeedback({ messageId, feedback, comentario }) {
      const conv = this.selectedConversation
      if (!conv || !conv.id || !messageId) return
      if (this.feedbackEmAndamento[messageId]) return
      this.$set(this.feedbackEmAndamento, messageId, true)
      try {
        const r = await apiMessages.saveFeedback({
          conversationId: conv.id,
          messageId: messageId,
          feedback: feedback,
          comentario: comentario,
        })
        if (r && r.status === 200) {
          this.$store.dispatch(`${this.ns}/updateMessageFeedback`, {
            id: messageId,
            feedback: feedback,
            comentario: comentario,
          })
        }
        this.$showSnack(r)
      } finally {
        this.$set(this.feedbackEmAndamento, messageId, false)
      }
    },
    cancelarStream() {
      const conv = this.selectedConversation
      const id = conv && conv.id
      this.motor.cancelRequest({ id: id })
    },
    /**
     * O envio do composer — digitado ou ditado (o ditado já chega como TEXTO).
     *
     * ★ [18/09/2026, D-009-5] Com a conversa do avatar em curso, o MESMO envio
     * passa pelo caminho FALADO (`enviarComAvatar`: fila de fala armada +
     * `modo_voz: true` no corpo), que é o que faz o avatar consolidar a
     * resposta em voz. *"Só a entrada é diferente — o fluxo e o racional
     * permanecem"*: o turno é o de sempre, o texto continua indo para a tela
     * pelo caminho de sempre e é ele a fonte auditável.
     *
     * ★ [G-2 do QA, 19/09/2026] Fora da conversa com o avatar,
     * `/pré-reunião Ilo Santos` DIGITADO é o mesmo turno do clique no atalho.
     * Quando `/pré-reunião` sai sem cliente, o servidor responde *"Mande
     * /pré-reunião com o nome do cliente"* — e até aqui a tela não deixava
     * cumprir: o texto virava pergunta livre, que o motor de atalhos não lê
     * (`core/atalhos/preflight.py`: o servidor NÃO parseia `query`). Quem
     * traduz é o front, para o MESMO campo estruturado do clique.
     *
     * ⚠️ Com anexo na fila, nada é interceptado: o turno de atalho não
     * carrega arquivo, e converter aqui descartaria em silêncio o que a
     * pessoa acabou de anexar.
     *
     * ★ [merge release/ia-claude-code, 20/09/2026] O avatar vem PRIMEIRO: ele
     * é um modo de conversa inteiro, e desviar o envio dele para o turno de
     * atalho deixaria a resposta muda no primeiro contato. Fora dele, o
     * atalho digitado continua valendo byte a byte.
     */
    onSendMessage(value, anexos, anexosProntos) {
      if (this.conversaComAvatarAtiva) {
        this.enviarComAvatar(value, anexos, anexosProntos)
        return
      }
      const temAnexos =
        (anexos && anexos.length > 0) || (anexosProntos && anexosProntos.length > 0)
      const atalho = temAnexos
        ? null
        : atalhoDigitado(value, this.atalhosDeNegocioDoCatalogo)
      if (atalho) {
        this.usarComando(atalho)
        return
      }
      this.enviarMensagem(value, anexos, anexosProntos)
    },
    /**
     * Modo de Voz do composer: a transcrição já chegou como TEXTO —
     * `enviarMensagem` é a MESMA usada pela digitação, sem nenhuma mudança
     * nela. [feedback do usuário, 04/09] "para ela falar enquanto escreve" —
     * a síntese é PROGRESSIVA: `iniciarFalaProgressivaMotor()` arma o motor
     * ANTES do envio, cada delta do turno (o `onTextoDelta` registrado no
     * `created()`, ver `utils/provedores-do-api-chat.js`) já vai sintetizando
     * frase a frase por dentro do motor, e
     * `finalizarFalaProgressivaMotor(geracao)` fecha o que sobrou no fim.
     * Nenhum áudio é tocado por AQUI — o motor toca sozinho, direto (não
     * precisa mais do bridge `composer.reproduzirRespostaFalada`).
     */
    async onEnviarVoz(texto) {
      // spec-016 T004 (US-1) — a voz escolhida NESTA conversa viaja para o
      // motor, que a repassa a cada `apiVoz.sintetizar` da fala progressiva.
      // Sem escolha (`''`), o motor não manda `voice_id` — byte a byte o de
      // hoje (US-1 AC2).
      const geracao = iniciarFalaProgressivaMotor(this.vozSelecionadaAtual)
      // [Hotfix P1, 09/09] `try/finally`: `enviarMensagem` PROPAGA exceção
      // (`despacharMensagem` faz `await apiChat.sendMessage(...)` sem
      // try/catch) — sem o `finally`, um turno de voz que falha (queda de
      // rede, stream derrubado) nunca chama `finalizarFalaProgressivaMotor`,
      // e `_aceitandoDeltas` fica travado em `true` PARA SEMPRE
      // (`fala-da-ia.js`): o mic nunca reabre e a sessão de voz continua
      // "ativa" enquanto a IA parou de falar — o relato do owner ("o modo
      // voz ainda está parando no meio do processo"). Mesmo padrão já usado
      // em `apiChat.js::sendToolOutput`/`reenviarUltimoTurno` (spec-017 T003).
      try {
        // [voz v3, 08/09] `{modoVoz: true}` explícito — é o que faz o corpo
        // do POST levar `modo_voz: true` (`apiChat._buildChatBody`), ligando
        // a versão FALADA (evento SSE `fala`) e o mínimo de fala do STT do
        // lado do servidor.
        await this.enviarMensagem(texto, null, null, { modoVoz: true })
      } finally {
        finalizarFalaProgressivaMotor(geracao)
      }
    },
    onMessageInput(value) {
      this.messageInput = value
    },
    /**
     * A resposta a um cartão do thread ([spec-010 T018] / US-4).
     *
     * Um canal só para todos os cartões (`contracts/ui-components.md` §2). Só
     * a confirmação de escrita precisa da superfície: o cartão de ação de front
     * executa sozinho pelo índice de executores, e `abrir` chega aqui apenas
     * como aviso de que houve resposta.
     *
     * O protocolo com o modelo é o de sempre — a mensagem "Confirmo"/"Cancelar"
     * que o faz re-chamar a write-tool com `confirmar=true`. O que mudou é o
     * dono do botão: era o `IaConfirmAction` que o `messages.vue` montava a
     * partir de `pendingConfirmation`; agora é o cartão do registry, na parte
     * do turno — e por isso ele sobrevive ao fim do turno e ao reload.
     *
     * ★ **A guarda de `chatLoading` FICA — e o beco virou visível** (P1 da
     * corrida real do [T023]; martelo do time-lead, 26/08).
     *
     * O preview aparece DURANTE o turno: `core/sse.py` emite o
     * `tool-approval-request` como evento ADICIONAL a um `tool_result` de
     * meio-de-turno, e o modelo segue escrevendo — `chatLoading` só cai no
     * `end`. Quem clicava nessa janela caía num `return` MUDO: sem snack, sem
     * transição, sem mensagem ao modelo, e a parte presa em
     * `approval-requested`. Medido idêntico em 4 corridas.
     *
     * O defeito não era a guarda: era o SILÊNCIO dela. Hoje o cartão desabilita
     * os botões enquanto o turno corre, com o motivo escrito na tela, e volta a
     * aceitar sozinho no `end` (reatividade do `chatLoading`, não polling).
     * Este `return` continua aqui porque guarda de tela protege o clique;
     * guarda de MÉTODO protege a ação — e é por aqui que a escrita é
     * autorizada.
     *
     * ★ **Precedente que decidiu:** [G-12] do fee-fixo (21/08), no CLAUDE.md
     * daquele módulo — *"botão desabilitado é o beco visível em vez do clique
     * que não faz nada"*. Duas superfícies com decisões opostas para o mesmo
     * dilema seriam duas vozes na mesma referência.
     *
     * ⚠️ **Responder NO MEIO do turno (a alternativa) está registrada como
     * evolução de produto, não como dívida.** Ela exigiria abortar o stream em
     * voo antes de enviar: `responderConfirmacao` termina em `sendMessage`, e o
     * `_abrirAbortController` de lá TROCA a referência sem abortar a anterior
     * (`apiChat.js`) — sem o aborto, dois streams escrevem no mesmo namespace,
     * e abortar só do lado do cliente deixa o turno órfão no servidor. Decisão
     * do owner, não de review.
     *
     * O duplo clique é problema do CARTÃO: ele desabilita os próprios botões no
     * primeiro clique aceito (`crm-confirmacao-card.vue`).
     *
     * ★ **[spec-017 T001] Sobrevive ao Modo de Voz.** A régua é
     * `motorDeVoz.sessaoDeVozAtiva` lida AQUI, no momento do clique
     * (ADR-017-01) — nunca "veio de um cartão": confirmar DIGITANDO não pode
     * ganhar áudio. Com a sessão ativa, o cartão segue o MESMO caminho de
     * fala que `onEnviarVoz` usa (ADR-017-02: reusa o par
     * `iniciarFalaProgressivaMotor`/`finalizarFalaProgressivaMotor`, nunca
     * reimplementa o re-arme do mic) e `modoVoz: true` atravessa até
     * `_buildChatBody` via `...envio` (`apiChat.responderConfirmacao`, sem
     * mudança nela). Vale para confirmar E cancelar (US-1 AC4). Com a sessão
     * inativa, o corpo e as chamadas seguem byte a byte como hoje (AC3).
     */
    async responderCartao(evento) {
      const acao = (evento && evento.acao) || ''
      // ★ [task #169] A rota de DECISÃO da US-8 é roteada ANTES do guard de
      // `chatLoading`, e isso não é ordem acidental: em `awaiting_approval` o
      // relay fica aberto em heartbeat até a decisão chegar (US-5/E-22), então
      // `chatLoading` é `true` a espera INTEIRA — depois do guard, qualquer
      // clique em Confirmar/Rejeitar morreria em silêncio, que é exatamente o
      // defeito que o [P1] da corrida do T023 fechou do outro lado.
      //
      // ⚠️ Mover este bloco para baixo do `return` reabre esse defeito sem
      // nada ficar vermelho no lint — há teste que aprova COM
      // `chatLoading = true` (`view-chat-decisao.unit.js`).
      if (!this.deveResponderCartao(acao, evento)) return
      // [#2183, John] O cartão pode ter um passo LOCAL antes da frase (a
      // simulação do Fee Fixo deposita os `resultados` sob o `preview_id`) —
      // `passoLocalDoCartao` consulta o índice de confirmadores do módulo. Sem
      // confirmador, `{tratado: false}` e o caminho genérico segue como sempre.
      const local = await this.passoLocalDoCartao(evento, acao)
      if (local.erro) {
        this.$showSnack(local.erro)
        return
      }
      // ★ [#214] No MODO AGENTE a frase não fecha o ciclo — a DECISÃO fecha.
      //
      // O confirmador do módulo devolve uma frase de protocolo ("Chame
      // `criar_simulacao_fee_fixo` com `confirmar=true`…") porque no Modo Chat
      // é o servidor quem a intercepta antes do modelo. No Modo Agente quem
      // executa o turno é o WORKER, e ali essa frase chega ao modelo como
      // qualquer outra: ele rechama a tool, o hook `PreToolUse`
      // (`agent_sdk/hooks_two_step.py`) a intercepta e abre OUTRA proposta.
      //
      // Medido em produção (18/09/2026, escritório 83): quatro propostas
      // `aberta` para o mesmo cenário, ZERO linhas em
      // `partners_fee_fixo_analise`, e as únicas `decisao` no log eram
      // `expirada_por_validade` da varredura. Na tela o cartão reaparecia a
      // cada clique, indistinguível de "salvou".
      //
      // Aqui o depósito JÁ aconteceu (é o `local` acima, e o commit o exige),
      // então o que falta é decidir a proposta que o gateway abriu.
      //
      // ★ [#216] A guarda deixou de ser `local.enviar` — o MOTIVO MEDIDO que
      // faltava quando ela foi escrita.
      //
      // A régua certa não é "o cartão tem confirmador", é "o servidor está
      // ESPERANDO uma decisão". Uma entrada em `propostasAbertas` significa
      // exatamente isso, e nesse estado a frase não fecha o ciclo — seja qual
      // for o cartão.
      //
      // O que a guarda antiga escondia: `confirmarSimulacaoDoChat` declina
      // (`return null`) quando o evento não traz `resultados` — e o cartão
      // emite SÓ `previewId`, dizendo no próprio comentário que "nenhum
      // consumidor lê `resultados` do evento". Os dois lados se contradizem,
      // então o confirmador devolvia `{tratado: false}` SEMPRE, `local.enviar`
      // era falsy, o `&&` curto-circuitava e o clique caía em
      // `responderConfirmacao`, que manda "Confirmo". Medido em produção
      // (19/09/2026): 11 propostas expiradas + 6 abertas em 24h e a tabela
      // `aawz_intelligence_v2_run_decisoes` VAZIA — nenhuma decisão jamais
      // registrada.
      //
      // Cartão sem proposta aberta não é afetado: `decidirPropostaDoCartao`
      // devolve `false` e o caminho antigo segue igual.
      if (this.decidirPropostaDoCartao(acao, evento)) return
      const vozAtiva = motorDeVoz.sessaoDeVozAtiva
      const geracao = vozAtiva
        ? iniciarFalaProgressivaMotor(this.vozSelecionadaAtual)
        : null
      // [Hotfix P1, 09/09] `try/finally`: os dois caminhos terminam em
      // `apiChat.sendMessage` (mesma maquinaria de stream de `onEnviarVoz`) —
      // sem o `finally`, um turno que falha nunca chamaria
      // `finalizarFalaProgressivaMotor`, travando `_aceitandoDeltas` em
      // `true` para sempre (mic nunca reabre).
      let r
      try {
        r = local.enviar
          ? await this.motor.sendMessage(this._payloadFraseDoCartao(local.enviar, vozAtiva))
          : await this.motor.responderConfirmacao(
              this._payloadResponderCartao(evento, acao, vozAtiva)
            )
      } finally {
        if (vozAtiva) finalizarFalaProgressivaMotor(geracao)
      }
      if (this.respostaFalhou(r)) this.$showSnack(r)
    },
    /**
     * Este `respond` segue para o fluxo de confirmação por TEXTO?
     *
     * Extraído só para caber no `max-statements` do ESLint (14) — a ordem
     * interna é que importa, e está comentada no chamador.
     */
    deveResponderCartao(acao, evento) {
      if (this.rotearAvancoDoOnboarding(acao, evento)) return false
      if (this.rotearRespostasDoOnboarding(acao, evento)) return false
      if (this.rotearConexaoDoCartao(acao, evento)) return false
      if (this.rotearAtalhoDoCartao(acao, evento)) return false
      if (this.rotearDecisaoDaProposta(acao, evento)) return false
      if (acao !== 'confirmar' && acao !== 'cancelar') return false
      // ★ [#214] Proposta ABERTA do Modo Agente passa pelo guard de
      // `chatLoading`, e isto é o MESMO defeito que o roteamento de `decidir`
      // acima existe para evitar — só pela outra porta.
      //
      // Em `awaiting_approval` o relay fica aberto em heartbeat até a decisão
      // chegar (US-5/E-22), então `chatLoading` é `true` a espera INTEIRA. O
      // cartão do CRM escapa porque emite `decidir`, tratado antes daqui; o do
      // Fee Fixo emite `confirmar` e morria em silêncio: medido em produção
      // (19/09/2026) instrumentando a instância viva — o clique não chamava
      // nem o passo local, e a proposta ficava `aberta` até a varredura
      // expirá-la, com a tela mostrando o cartão de volta como se nada tivesse
      // acontecido.
      //
      // Quem tem proposta aberta ESTÁ no gesto que o servidor espera para
      // fechar o turno — travá-lo é travar justamente o que destrava.
      if (this.idDaPropostaDoCartao(evento)) return true
      return !this.chatLoading
    },
    /**
     * O cartão pediu para RODAR um atalho (hoje: a etapa 4 do onboarding,
     * `plataforma/onboarding` → `/panorama`).
     *
     * ★ **Reuso, não um segundo caminho.** Isto termina em `executarAtalho()`,
     * o MESMO handler do `@executar-atalho` dos dois composers — logo, o mesmo
     * `apiChatAtalhos.sendAtalho`, o mesmo `tocarConversaSelecionada` e o mesmo
     * `carregarConversas` em volta. Um `sendAtalho` chamado de dentro do cartão
     * seria a segunda porta, e ela nasceria sem esses dois.
     *
     * ★ **O `label` é resolvido AQUI porque o catálogo é da view.** Ele é o
     * texto que vira a bolha do usuário e tem de bater byte a byte com o que
     * `core/atalhos/turno.py::_fala_do_comando` grava — o cartão manda só o
     * slug, que é o que ele sabe. Slug fora do catálogo segue mesmo assim, com
     * `label` nulo: `apiChatAtalhos` já cai em `'/' + slug` nesse caso, e o
     * pior desfecho é o acento voltar no F5 (o comentário dele diz isso com
     * todas as letras) — melhor que um clique que não faz nada.
     *
     * ⚠️ Roteado ANTES do guard de `chatLoading`, pela mesma razão da rota de
     * decisão logo abaixo: quem despacha o turno é o transporte de atalho, que
     * abre o próprio stream; o guard de `chatLoading` existe para a resposta
     * por TEXTO do two-step, não para cá.
     *
     * @returns {boolean} `true` quando tratou (o chamador retorna).
     */
    /**
     * O cartão pediu para AVANÇAR a apresentação (etapa 2: "Continuar" e
     * "Pular").
     *
     * ★ Vira uma mensagem comum — o servidor entrega a etapa seguinte a cada
     * mensagem da pessoa (`usecase_ia_crm_chat._etapa_do_onboarding`). Não há
     * transporte novo: é o MESMO `enviarMensagem` do composer, e é por isso
     * que a bolha, o `tocarConversaSelecionada` e o recarregar de conversas
     * acontecem como sempre.
     *
     * ⚠️ Roteado ANTES do guard de `chatLoading` pela mesma razão das outras
     * duas rotas acima — e `enviarMensagem` tem o guard dele próprio, que é o
     * que impede o clique duplo.
     *
     * @returns {boolean} `true` quando tratou (o chamador retorna).
     */
    rotearAvancoDoOnboarding(acao, evento) {
      if (acao !== ACAO_AVANCAR_ETAPA) return false
      const payload = (evento && evento.payload) || {}
      const texto = (payload.texto || '').trim()
      // Sem texto não há o que dizer — e já tratamos: cair no fluxo de
      // confirmação por texto mandaria uma frase que ninguém escreveu.
      if (!texto) return true
      this.enviarMensagem(texto)
      return true
    },
    /**
     * O formulário da etapa 1 do onboarding → a MESMA mensagem que o
     * `manager-questions` manda.
     *
     * ★ **O FORMATO é contrato e vem do util; o PREFIXO é nosso.**
     * `montarRespostasPareadas` escreve os blocos numerados
     * (`N. pergunta\nResposta: …`) — reusar isso é o certo, porque duas
     * grafias do mesmo formato divergiriam na primeira revisão.
     *
     * ⚠️ O que NÃO se herda é a etiqueta. O default do util é o prefixo do
     * PARECER, e `core/entrega/material.py::_respostas_do_gestor` colhe por ele
     * com `startswith`, sem olhar de que turno veio — o onboarding acabava
     * dizendo "perguntas em aberto do parecer" na bolha do primeiro contato e
     * tendo os dados do escritório colhidos como respostas ao parecer. Daí
     * `PREFIXO_RESPOSTAS_DO_ONBOARDING`.
     *
     * O cartão entrega pares `{pergunta, resposta}` já filtrados (campo em
     * branco não vai); o util pede `perguntas` + mapa `indice -> texto`, então
     * a conversão acontece aqui — nenhum dos dois lados muda de contrato.
     *
     * @returns {boolean} `true` quando tratou (o chamador retorna).
     */
    rotearRespostasDoOnboarding(acao, evento) {
      if (acao !== ACAO_RESPONDER_PERGUNTAS) return false
      const payload = (evento && evento.payload) || {}
      const pares = payload.respostas || []
      const porIndice = {}
      pares.forEach(function (par, indice) {
        porIndice[indice] = par && par.resposta
      })
      const texto = montarRespostasPareadas(
        pares,
        porIndice,
        PREFIXO_RESPOSTAS_DO_ONBOARDING
      )
      // Sem nada preenchido não há o que dizer — e já tratamos: cair no fluxo
      // de confirmação por texto mandaria uma frase que ninguém escreveu.
      if (!texto) return true
      this.responderPerguntas(texto)
      return true
    },
    /**
     * "Continuar sem a apresentação" — a saída incondicional do beco.
     *
     * ⚠️ Não cancela a apresentação nem some com os cartões: só destrava o
     * composer. Os cartões de etapa continuam na conversa e continuam
     * respondendo aos próprios botões — quem dispensou pode voltar a usá-los.
     */
    /**
     * O "Continuar" da boas-vindas — e por que ele precisava de dono.
     *
     * ⚠️ O botão emite `avancar` (`boas-vindas-falada.vue::avancar`), e este
     * slot escutava só `@entregue` e `@fim`: o clique marcava `avancou` (o
     * botão sumia) e **não acontecia mais nada**. Achado na tela, 19/09/2026.
     *
     * ★ Ele tem de MANDAR UMA MENSAGEM, e não revelar nada localmente: depois
     * do turno de boas-vindas o servidor avança UMA etapa por mensagem da
     * pessoa (`usecase_ia_crm_chat::_etapa_do_onboarding`). Sem mensagem, a
     * etapa 1 nunca é pedida — a conversa fica parada na apresentação.
     *
     * A fala é a MESMA que o "Continuar" das etapas manda
     * (`onboarding/copy.js::falaDoContinuar`), porque é o mesmo gesto e ela
     * vira a bolha da pessoa na conversa.
     */
    avancarDaBoasVindas() {
      this.enviarMensagem(COPY_DO_ONBOARDING.falaDoContinuar)
    },
    dispensarApresentacao() {
      this.apresentacaoDispensada = true
      // O foco é acabamento; `focarComposer` já é resiliente a composer
      // ausente (ver a guarda lá). Esta é a única saída de um composer
      // travado — ela não pode falhar por causa do foco.
      this.focarComposer()
    },
    /**
     * O cartão pediu para CONECTAR uma ferramenta sem sair do chat (etapa 3 do
     * onboarding, 19/09/2026).
     *
     * ★ **A view é quem conhece o transporte.** O cartão diz o conector; o
     * canal do `GlobalBus` sai de `constants/Conectores.js::modalDoConector`,
     * a MESMA consulta que o cartão usou para decidir emitir em vez de navegar
     * — uma fonte só, de modo que um conector no mapa e fora dele nunca
     * discordem entre os dois lados.
     *
     * ⚠️ Roteado ANTES do guard de `chatLoading`, pela mesma razão das outras
     * rotas deste bloco: abrir um modal não é responder um two-step por texto,
     * e um turno em voo não pode engolir o clique.
     *
     * ⚠️ Id sem modal devolve `true` mesmo assim: o cartão só emite esta ação
     * quando HÁ modal, então chegar aqui sem ele é estado impossível — e cair
     * no fluxo de confirmação por texto mandaria uma frase que ninguém
     * escreveu.
     *
     * @returns {boolean} `true` quando tratou (o chamador retorna).
     */
    rotearConexaoDoCartao(acao, evento) {
      if (acao !== ACAO_CONECTAR_FERRAMENTA) return false
      const payload = (evento && evento.payload) || {}
      const canal = modalDoConector(payload.id)
      if (canal) GlobalBus.$emit(canal)
      return true
    },
    rotearAtalhoDoCartao(acao, evento) {
      if (acao !== ACAO_EXECUTAR_ATALHO) return false
      const payload = (evento && evento.payload) || {}
      const slug = payload.slug
      // Sem slug não há atalho a executar — e já tratamos: deixar cair no
      // fluxo de confirmação por texto mandaria uma frase que ninguém escreveu.
      if (!slug) return true
      const catalogo = this.atalhosDisponiveis || []
      const doCatalogo = catalogo.find((item) => item && item.id === slug)
      this.executarAtalho({
        slug: slug,
        label: doCatalogo ? doCatalogo.label : null,
        argumento: null,
      })
      return true
    },
    /**
     * O id da proposta que este cartão responde, ou `null`.
     *
     * ⚠️ DUAS grafias, e a diferença é real: a parte CRUA do store guarda
     * `id_proposta` (é o campo do evento `confirmacao`, copiado por
     * `copiarPresentes`), mas o que chega aqui é a parte RESOLVIDA, montada
     * por `renderiza-partes.js::montarCartao`, que a reescreve como
     * `idProposta`. Ler só uma delas devolve `null` sempre.
     *
     * Só conta a proposta que ainda está ABERTA no mapa: uma já decidida ou
     * expirada não deve furar o guard de `chatLoading` nem ser decidida de
     * novo (409 sobre um cartão que a pessoa acabou de clicar).
     */
    idDaPropostaDoCartao(evento) {
      // ★ [#215] A régua inteira mora no util — inclusive o fallback por
      // `tool`, que é o ÚNICO elo quando a parte vem da cópia PERSISTIDA
      // (medido em produção: ela nunca traz `id_proposta`).
      return idDaPropostaParaOCartao({
        parte: (evento && evento.parte) || null,
        propostasAbertas: this.propostasAbertas,
      })
    },
    /**
     * As quatro ações da rota de decisão (US-8, task #169) → os handlers do
     * `view-chat-modo-agente.mixin.js`.
     *
     * Elas sobem pelo canal `respond` do cartão (`crm-confirmacao-card`), o
     * mesmo de `confirmar`/`cancelar` — não por eventos próprios atravessando
     * cartão → embrulho → bolha → thread → view.
     *
     * @returns {boolean} `true` quando tratou (o chamador retorna).
     */
    rotearDecisaoDaProposta(acao, evento) {
      const payload = (evento && evento.payload) || {}
      if (acao === 'decidir') {
        this.onDecidirProposta(payload)
        return true
      }
      if (acao === 'pedir-nova-proposta') {
        this.onPedirNovaProposta(payload)
        return true
      }
      if (acao === 'tentar-novamente') {
        this.onTentarNovamente(payload)
        return true
      }
      if (acao === 'expirou-por-relogio') {
        this.onExpirouPorRelogio(payload)
        return true
      }
      return false
    },
    /**
     * O cartão está respondendo a uma PROPOSTA aberta do Modo Agente?
     *
     * `true` ⇒ a decisão foi despachada e o chamador PARA — não há frase a
     * mandar. `false` ⇒ não é caso de decisão (Modo Chat, ou proposta já
     * fechada) e o caminho da frase segue valendo, byte a byte como antes.
     *
     * Reusa `onDecidirProposta` em vez de chamar `decidirProposta` direto: é
     * ele quem guarda `ultimaDecisao` para o "Tentar novamente" e quem ignora
     * proposta ausente do mapa. Uma segunda porta divergiria justamente no
     * retry, que só aparece quando algo já deu errado.
     *
     * @param {string} acao   `confirmar` | `cancelar`, como o cartão emitiu.
     * @param {Object} evento O `respond` do cartão (traz `parte`).
     */
    decidirPropostaDoCartao(acao, evento) {
      // A régua das duas grafias e do "ainda aberta" mora em UM lugar
      // (`idDaPropostaDoCartao`): o guard de `chatLoading` e esta rota
      // precisam concordar sobre o que é uma proposta decidível, e duas
      // cópias divergiriam no primeiro ajuste.
      const idProposta = this.idDaPropostaDoCartao(evento)
      if (!idProposta) return false
      this.onDecidirProposta({
        id_proposta: idProposta,
        decisao: acao === 'cancelar' ? DECISAO_REJEITAR_DO_CARTAO : DECISAO_APROVAR_DO_CARTAO,
      })
      return true
    },
    /**
     * O envelope do turno de resposta — o mesmo para os dois caminhos
     * (frase do confirmador do módulo e `responderConfirmacao`). Extraído
     * porque uma cópia divergiria em silêncio: a resposta iria com outro
     * modelo, ou fora da conversa aberta, sem nada estourar.
     */
    _envelopeDaResposta(vozAtiva) {
      const storeState = this.$store.state[this.ns] || {}
      return {
        conversationId: this._idDaConversaParaOTurno(),
        answerStyle: 'direto',
        model: storeState.selectedModel || null,
        thinkingEnabled: storeState.thinkingEnabled !== false,
        origemModulo: this.origemModulo,
        ...(vozAtiva ? { modoVoz: true } : {}),
      }
    },
    // A frase que o confirmador do módulo manda no lugar do "Confirmo"
    // genérico (nomeia o `preview_id`); `exibir` é o que a bolha mostra.
    _payloadFraseDoCartao(enviar, vozAtiva) {
      return {
        ...this._envelopeDaResposta(vozAtiva),
        message: enviar.message,
        displayMessage: enviar.exibir,
      }
    },
    // Extraído de `responderCartao` (complexidade ciclomática do ESLint) —
    // só monta o payload, sem side-effect algum.
    _payloadResponderCartao(evento, acao, vozAtiva) {
      return {
        toolCallId: (evento && evento.toolCallId) || '',
        acao: acao,
        ...this._envelopeDaResposta(vozAtiva),
        // ★ [spec-021, T004] Os campos que o cartão deixou o consultor editar
        // (hoje: destinatário/assunto/mensagem do e-mail). Chegam em
        // `payload.dados`, que é o objeto que o `.vue` emitiu — o `respond` do
        // `cartaoDoChat` embrulha o emit do cartão nessa chave. Só entram
        // quando há algo MUDADO: o corpo de toda confirmação que não edita
        // nada segue byte a byte o de hoje.
        ...this._camposEditadosDoCartao(evento),
      }
    },
    /**
     * Os campos editados no cartão, no shape que `apiChat` espera — ou `{}`.
     *
     * Extraído de `_payloadResponderCartao` porque o caminho até eles tem duas
     * indireções (`payload.dados`, do embrulho do `cartaoDoChat`) e um teste
     * precisa alcançá-lo sem montar a view inteira.
     */
    _camposEditadosDoCartao(evento) {
      const dados = (evento && evento.payload && evento.payload.dados) || null
      const campos = (dados && dados.camposConfirmados) || null
      if (!campos || !Object.keys(campos).length) return {}
      return { camposConfirmados: campos }
    },
    /**
     * O cartão tem um passo que se resolve AQUI, antes da frase?
     *
     * A maioria não tem: o two-step das write-tools do CRM é inteiro do
     * servidor, e "Confirmo" basta. A simulação do Fee Fixo tem — os
     * `resultados` do cenário são calculados no navegador e o commit os exige,
     * então existe um depósito que precisa acontecer ANTES, e a frase que vale
     * é outra (ela nomeia o `preview_id`).
     *
     * ★ Quem sabe disso é o MÓDULO, não esta view: o índice
     * (`ui-registry/confirmadores`) é consultado pela CHAVE do cartão, que já
     * viaja na `parte` que o `chat-message` emite junto do evento. Importar o
     * fee-fixo aqui poria o chat do CRM a depender dele para responder a um
     * cartão — o acoplamento que o registry existe para desfazer.
     *
     * ⚠️ Medido em 04/09/2026, na Home IA: sem esta consulta o "Salvar cenário"
     * mandava o "Confirmo" genérico e o modelo respondia que *"a confirmação
     * acontece pelo clique no cartão, na tela do Fee Lab"*. Nada era gravado, o
     * cartão saía da tela, e a conversa seguia como se o cenário estivesse
     * salvo.
     */
    passoLocalDoCartao(evento, acao) {
      const parte = (evento && evento.parte) || null
      const chave = (parte && parte.chave) || ''
      if (!chave) return Promise.resolve({ tratado: false })
      const payload = (evento && evento.payload) || {}
      return resolverConfirmacao(chave, {
        acao: acao,
        dados: payload.dados === undefined ? null : payload.dados,
        parte: parte,
      })
    },
    /**
     * A resposta ao cartão falhou e o consultor precisa saber?
     *
     * Sem isto o retorno era descartado e não sobrava sinal nenhum de que a
     * confirmação não saiu. **Cancelamento deliberado não é falha** — o
     * `cancelado: true` vem do `_encerrarTurnoCancelado`, e ele é consequência
     * do aborto que ESTE método pede antes de responder.
     */
    respostaFalhou(r) {
      if (!r || r.cancelado) return false
      if (typeof r.status !== 'number') return false
      return r.status !== 200
    },
  },
}
</script>

<template>
  <div
    class="intelligence-v2-chat d-flex flex-column overflow-hidden"
    :style="containerStyle"
  >
    <!-- Header do MÓDULO. Some quando `semHeaderDeRota` (a visão imersiva,
         `/home-ia`, tem cabeçalho próprio) — com a nav 2026 desligada este
         bloco renderiza o header inline (título/subtítulo resolvidos das
         abas do módulo), que é justamente o chrome que a imersiva não tem. -->
    <ConditionalTeleport
      v-if="!widget && !semHeaderDeRota"
      to="page-header-actions"
      :routes="moduleRoutes"
    />

    <!-- min-height:0 é o que permite essa linha ENCOLHER até o espaço
         disponível em vez de crescer pelo conteúdo (título + sugestões) —
         sem isso, no popup (altura fixa e pequena) o conteúdo empurra o
         SendMessage pra fora da área visível, sem scroll algum. Com isso, o
         overflow sobra pro scroll interno do .messages (flex-grow-1 +
         overflow-y:auto), que já existe. -->
    <div class="d-flex flex-grow-1" style="min-height: 0">
      <!-- Sidebar de conversas: a nova encosta no conteúdo, sem gap e sem card
           próprio — a separação vem da cor quente. Oculta só no modo widget,
           onde os 420-640px não a comportam.
           O ramo antigo (`Conversations` num card de 320px com borda, do #1939)
           saiu: ele só era alcançado por `embedded`, e a tela hospedeira passou
           a usar o layout fundido junto com a rota cheia. -->
      <ChatSidebar
        v-if="usaLayoutFundido"
        class="flex-shrink-0"
        :store-module="ns"
        :store-module-historico="nsDoHistorico"
        :como-navegacao="sidebarComoNavegacao"
        :busca-global-disponivel="buscaGlobalDisponivel"
        :insights="sidebarInsights"
        :insights-estado="sidebarInsightsEstado"
        :atalhos="sidebarAtalhos"
        :cliente-em-foco="clienteDaLateral"
        :dados-do-cliente="sidebarDadosDoCliente"
        :personalizacao-disponivel="sidebarPersonalizacaoDisponivel"
        :modo-personalizacao="sidebarModoPersonalizacao"
        :salvando-personalizacao="sidebarSalvandoPersonalizacao"
        :itens-personalizaveis-visiveis="sidebarItensPersonalizaveisVisiveis"
        :itens-personalizaveis-catalogo="sidebarItensPersonalizaveisCatalogo"
        :agentes="agentesVisiveisDoEscritorio"
        :agente-ativo-id="agenteAtivoId"
        :contexto-listagem="contextoListagem"
        :carregando-mais="carregandoMaisConversas"
        :tem-mais-conversas="temMaisConversas"
        @personalizar-painel="$emit('personalizar-painel')"
        @salvar-personalizacao="$emit('salvar-personalizacao', $event)"
        @abrir-perfil-cliente="$emit('abrir-perfil-cliente', $event)"
        @abrir-tarefas-cliente="$emit('abrir-tarefas-cliente', $event)"
        @abrir-contatos-cliente="$emit('abrir-contatos-cliente', $event)"
        @abrir-carteira-cliente="$emit('abrir-carteira-cliente', $event)"
        @abrir-contratos-cliente="$emit('abrir-contratos-cliente', $event)"
        @abrir-transcricoes-cliente="
          $emit('abrir-transcricoes-cliente', $event)
        "
        @carregar-mais="carregarMaisConversas"
        @select-agent="onEscolherAgenteNaSidebar"
        @abrir-insight="$emit('abrir-insight', $event)"
        @recarregar-insights="$emit('recarregar-insights')"
        @select="selecionarConversaEFocar"
        @delete="deletarConversa"
        @delete-lote="deletarConversasEmLote"
        @rename="renomearConversa"
        @new-conversation="novaConversaEFocar"
        @retry="carregarConversas"
      />
      <!-- Area principal do chat -->
      <div
        class="no-padding flex-grow-1 d-flex flex-column overflow-hidden intelligence-v2-chat__area"
        :class="classeAreaPrincipal"
      >
        <!-- Cartão do cliente em foco, ANTES das mensagens: é o contexto da
             conversa e precisa ser lido antes dela.
             ⚠️ Ele tem DUAS casas, e a conversa vazia é o que as separa.
             Vazia: irmão das mensagens e, no modo ancorado, FORA do fluxo —
             aparecer/sumir empurrava o herói e o composer 74px (reclamação de
             27/08), e flutuando ele ocupa o vazio que já existe no topo.
             Em andamento: vai para DENTRO da rolagem, como cabeçalho do fio (o
             slot do `Messages`). Preso ali ele rola junto e sai da tela, em vez
             de ficar pregado na viewport comendo altura o tempo todo — e a
             primeira mensagem deixa de passar por baixo dele.
             ★ Bug ao vivo (10/09/2026): `estreito="!hasMessages"` na cópia
             ANTES das mensagens — sem ela o cartão ficava sempre no trilho
             CHEIO, mesmo com o chat ainda fechado (nenhuma mensagem), esticado
             como se a conversa já estivesse em andamento. A cópia de DENTRO da
             rolagem (`escopoNaConversa`) só existe quando `hasMessages` já é
             true, então não precisa da prop — nasce sempre no trilho cheio. -->
        <div
          v-if="escopoAcimaDasMensagens"
          class="intelligence-v2-chat__escopo"
          :class="{
            'intelligence-v2-chat__escopo--flutuante': ancorarEstadoVazio,
          }"
        >
          <ChatClienteEscopo
            :cliente="clienteEscopo"
            :travado="escopoTravado"
            :agente="agenteAtualDaConversa"
            :aviso-de-conversa="avisoDeConversaTexto"
            :id-cliente-do-aviso="idClienteDoAvisoAtual"
            :estreito="!hasMessages"
            @limpar="onTrocarEscopo(null)"
            @abrir-perfil="$emit('abrir-perfil-cliente', $event)"
            @trocar-para-cliente="onTrocarParaClienteDoAviso"
          />
        </div>
        <!-- ★ merge PR #2242 — Modo Agente (spec-002). O `ChatHeader` que
             acompanhava estes dois na branch NÃO volta: o componente saiu do
             repo em 11/09 (a pílula de fase virou a linha de raciocínio da
             bolha). O chip e o banner leem só o store, pelos computeds do
             `view-chat-modo-agente.mixin.js` — sem eles, o run corre sem
             nenhum sinal na tela: nada de estado, de cancelar, de "tentar de
             novo" nem do aviso de reconexão por cursor. -->
        <RunStatusChip
          v-if="mostrarChipRun"
          class="intelligence-v2-chat__run-chip px-6 pt-2"
          :estado="runAtual.estado"
          :motivo="runAtual.motivo"
          :pode-cancelar="podeCancelarRun"
          :propostas-abertas="quantidadePropostasAbertas"
          :custo-creditos="custoCreditosDoRun"
          :pode-tentar-novamente="podeTentarNovamente"
          :carregando-tentativa="tentandoNovamente"
          :efeitos-conhecidos="runAtual.efeitos_conhecidos || []"
          :mostrar-aprovar-todas="mostrarAprovarTodas"
          :quantidade-para-aprovar="propostasAbertasParaLote.length"
          :aprovando-todas="aprovandoEmLote"
          @cancelar="onCancelarRun"
          @aprovar-todas="onAprovarTodas"
          @tentar-de-novo="onTentarDeNovo"
        />

        <!-- [spec-003 T302 / US-8] O que foi e o que NÃO foi feito no lote.
             Fica ABAIXO do chip e ACIMA do trilho: é desfecho do RUN, como o
             chip — e o gestor precisa vê-lo sem rolar até o fim da conversa.
             Some sozinho quando o mapa de propostas esvazia (troca de conversa
             ou run novo). -->
        <RelatorioDoLote
          v-if="mostrarRelatorioDoLote"
          class="px-4 pt-2"
          :linhas="linhasDoRelatorioDoLote"
        />

        <!-- Banner discreto da reconexão por cursor ([adv C-30], wireframe W3) -->
        <div
          v-if="reconectando"
          class="az-text-secondary az-size-12 az-muted px-4 pt-2"
        >
          Reconectando… (cursor {{ runAtual && runAtual.seq }})
        </div>

        <!-- `ref` para UMA coisa: devolver o fim da conversa ao fim quando o
             rodapé muda de altura ao entrar/sair da voz ([T061], watcher de
             `sessaoDeVozAtiva`). -->
        <Messages
          ref="mensagens"
          :store-module="ns"
          class="flex-grow-1"
          :largura-limitada="usaLayoutFundido"
          :com-indice-de-mensagens="comIndiceDeMensagens"
          :com-indice-de-artefatos="comIndiceDeArtefatos"
          :atalhos="atalhosDisponiveis"
          :modulos="ferramentasDoComposer"
          @erro-no-trilho="onErroNoTrilho"
          @feedback="darFeedback"
          @respond="responderCartao"
          @open-service="onOpenService"
          @responder-perguntas="responderPerguntas"
        >
          <template v-slot:antes-das-mensagens>
            <!-- [spec-009 US-2] A boas-vindas do primeiro contato, ACIMA da
                 conversa: a resposta à primeira mensagem acontece abaixo, no
                 mesmo turno e sem esperar por ela (AC-2.5). O nome vem da
                 SESSÃO (AC-2.3); quem decide se ela deve aparecer é o
                 servidor — ver `view-chat-boas-vindas.mixin.js`.

                 ★ [18/09/2026] Entregue, ela NÃO sai da tela: `:concluida`
                 colapsa as ações e o bloco fica no alto da conversa, que é
                 onde a apresentação da casa aconteceu (*"a mensagem de boas
                 vindas saiu, quero que fique"*, owner). Quem impede a
                 repetição na sessão seguinte continua sendo o servidor. -->
            <BoasVindasFalada
              v-if="mostrarBoasVindas"
              class="mb-4"
              :primeiro-nome="primeiroNomeDaSessao"
              :concluida="boasVindasEncerrada"
              :sem-audio="!falaDoPrimeiroContatoLigada"
              :provedor-de-clipe="provedorDoClipeDaApresentacao"
              :falante="falanteDoAvatar"
              :faixa-de-video="faixaDeVideoDoAvatar"
              :faixa-de-audio="faixaDeAudioDoAvatar"
              @entregue="aoEntregarBoasVindas"
              @avancar="avancarDaBoasVindas"
              @fim="encerrarBoasVindas"
            />
            <div v-if="escopoNaConversa" class="intelligence-v2-chat__escopo">
              <ChatClienteEscopo
                :cliente="clienteEscopo"
                :travado="escopoTravado"
                :agente="agenteAtualDaConversa"
                :aviso-de-conversa="avisoDeConversaTexto"
                :id-cliente-do-aviso="idClienteDoAvisoAtual"
                @limpar="onTrocarEscopo(null)"
                @abrir-perfil="$emit('abrir-perfil-cliente', $event)"
                @trocar-para-cliente="onTrocarParaClienteDoAviso"
              />
            </div>
          </template>

          <template v-slot:empty>
            <!-- Ícone e subline saíram com a grid 2x3 (F18): o herói serif
                 é só duas linhas. O composer sobe pro slot no estado vazio da
                 rota cheia — é a composição do protótipo (herói → composer →
                 chips). No popup/embedded ele continua no rodapé (AC-8.3).

                 ⚠️ [bug corrigido, 04/09] "o Olá Como posso te ajudar hoje
                 ainda ficou mostrando... ao entrar no chat" — `composerNoHeroi`
                 só decide ONDE o composer renderiza; sem este `v-if`, o título
                 e as pílulas do herói continuavam desenhados aqui (`Messages`
                 decide "vazio" pela CONTAGEM real de mensagens, que continua
                 zero — é só uma gravação, ainda sem mensagem nenhuma), com o
                 composer já deslocado pro rodapé lá embaixo: um meio-termo
                 quebrado, título solto em cima e composer solto embaixo. -->
            <EmptyMessages
              v-if="!vozExpandeParaRodape"
              ref="estadoVazio"
              :ancorar-no-topo="ancorarEstadoVazio"
              :modulo-em-foco="ferramentaSelecionada"
              :ocultar-sugestoes="ocultarSugestoesNaTela"
              :headline="personaAtual.headline"
              :acoes="acoesPorModuloFiltradas"
              :layout-das-acoes="layoutDasAcoes"
              :densidade-das-acoes="densidadeDaGrade"
              :aviso-das-acoes="avisoDasAcoes"
              :aviso-das-acoes-acao="avisoDasAcoesAcao"
              :layout-do-modulo-em-foco="layoutDoModuloEmFoco"
              :modo-de-sugestao="modoDeSugestao"
              :sugestoes="sugestoesFixas"
              @focar-composer="focarComposer"
              @limpar-ferramenta="limparFerramenta"
              @use-suggestion="usarSugestao"
              @usar-comando="usarComando"
              @aviso-das-acoes-acao="$emit('aviso-das-acoes-acao')"
            >
              <!-- Rodapé da coluna do estado vazio: o cartão de suporte entra
                   DEPOIS do composer e das sugestões, encostado no fim da
                   coluna (`margin-top: auto` em `empty-messages.vue`), logo
                   acima do aviso regulatório. -->
              <template v-if="comCartaoDeSuporte" v-slot:rodape>
                <SuporteWhatsappCard />
              </template>

              <template v-if="composerNoHeroi" v-slot:composer>
                <!-- D6 (spec-010 supervisor-e-agentes-de-dominio, [T027]): o
                     gestor não escolhe mais agente — o Supervisor roteia. O
                     chip do composer sai; quem respondeu aparece DEPOIS,
                     como badge por mensagem (chat-message.vue). Fixo em
                     `false` — a remoção do próprio componente `AgentSelect` é
                     do [T033], quando `agenteAtivoId`/persona também saem. -->
                <SendMessage
                  ref="composerHeroi"
                  :store-module="ns"
                  :ferramentas="ferramentasDoComposer"
                  :atalhos-de-negocio="atalhosDeNegocioDoCatalogo"
                  :ferramenta-ativa="ferramentaSelecionada"
                  :estilo-limpo="estiloLimpoDoComposer"
                  :value="messageInput"
                  :pulsar-envio="pulsarEnvioDoComposer"
                  :duracao-do-pulso-de-envio="duracaoDoPulsoDeEnvio"
                  :loading="turnoEmVoo"
                  :model-locked="isModelLocked"
                  :placeholder="placeholderNaTela"
                  :envio-bloqueado="envioTravado"
                  :show-agent-select="mostrarSeletorDeEspecialista"
                  :show-attachments="usaLayoutFundido"
                  :anexos-liberados="anexosLiberados"
                  :anexo-de-carteira-liberado="ofereceAnexoDeCarteira"
                  :focar-ao-montar="sidebarComoNavegacao"
                  :agentes="agentesDoComposer"
                  :agente-ativo-id="agenteAtivoIdDoComposer"
                  :agente-travado="agenteTravado"
                  :escopo-travado="escopoTravado"
                  :escopo-de-cliente="escopoDeCliente"
                  :clientes="clientesDoEscritorio"
                  :cliente-escopo="clienteEscopo"
                  :agente-ativo="agenteAtualDaConversa"
                  :id-cliente-anexo="idClienteDoAnexo"
                  :nome-cliente-anexo="nomeClienteAnexo"
                  :chave-da-fila-de-anexos="chaveDaFilaDeAnexos"
                  :superficie-de-voz="superficieDeVozTempoReal"
                  :delegar-voz="delegarVozTempoReal"
                  :ler-valor-parcial-de-voz="lerValorParcialDoTurnoVoz"
                  :id-conversa-de-voz="idConversaDeVoz"
                  :atalhos="atalhosDisponiveis"
                  mostrar-seletor-de-voz
                  hide-disclaimer
                  :sem-dica-de-teclado="semDicaDeTeclado"
                  large
                  @escolher-ferramenta="escolherFerramenta"
                  @limpar-ferramenta="limparFerramenta"
                  @escopo-change="onTrocarEscopo"
                  @input="onMessageInput"
                  @send="onSendMessage"
                  @enviar-voz="onEnviarVoz"
                  @abort="cancelarStream"
                  @change-agent="onTrocarAgenteDoComposer"
                  @descer-para-acoes="descerParaAcoes"
                  @nova-conversa="novaConversa"
                  @executar-atalho="executarAtalho"
                >
                  <!-- O slot tem DOIS moradores e uma régua: a faixa de créditos
                       (bloqueante — `mixins/aviso-de-creditos.js`) vence a de
                       sugestões a triar. A de sugestões continua só no composer
                       do estado vazio: com a conversa em andamento, uma faixa
                       sobre a fila de curadoria disputa atenção com a resposta
                       que está sendo escrita. -->
                  <template v-slot:cabecalho>
                    <!-- ★ A conversa quebrada VENCE a régua inteira: é o único
                         aviso aqui que diz que o próximo envio some e é
                         cobrado. -->
                    <ComposerAviso
                      v-if="trilhoQuebrado"
                      tom="danger"
                      :texto="TEXTO_COMPOSER.trilhoQuebradoFaixa"
                      :acao="TEXTO_COMPOSER.trilhoQuebradoAcao"
                      @acao="recarregarAPagina"
                    />
                    <ComposerAviso
                      v-else-if="avisoDeCreditos"
                      :texto="avisoDeCreditos.texto"
                      :acao="avisoDeCreditos.acao"
                      :fechavel="avisoDeCreditos.fechavel"
                      :rotulo-de-fechar="rotuloDeFecharAviso"
                      @acao="abrirCreditos"
                      @fechar="fecharAvisoDeSaldoBaixo"
                    />
                    <ComposerAviso
                      v-else-if="avisoDaApresentacao"
                      :texto="avisoDaApresentacao.TEXTO"
                      :acao="avisoDaApresentacao.ACAO"
                      @acao="dispensarApresentacao"
                    />
                    <ComposerAtencao
                      v-else
                      :quantidade="sugestoesATriar"
                      @abrir="$emit('abrir-sugestoes-a-triar')"
                    />
                  </template>
                </SendMessage>
              </template>
            </EmptyMessages>
          </template>
        </Messages>

        <!-- Rodapé no mesmo trilho da conversa (o respiro lateral já vem do
             `px-4` de cada filho, o mesmo que a lista de mensagens usa). -->
        <div class="intelligence-v2-chat__rodape" :class="classeTrilhoRodape">
          <!-- ★ [18/09/2026, D-009-5] O AVATAR da conversa falada do primeiro
               contato, no rodapé e FORA da rolagem — mesmo racional do cartão
               de perfil logo abaixo: quem diz de quem é a vez não pode sair da
               vista quando a conversa cresce. Ele não cobre a conversa; o
               rodapé é `flex-shrink: 0` e a área de mensagens encolhe o
               equivalente (a mesma correção que a orb do modo de voz recebeu
               na [T061]). Inerte fora do primeiro contato: quem o liga é o fim
               da boas-vindas, e nessa altura o composer já está aqui embaixo. -->
          <!-- As duas faixas são do AVATAR AO VIVO (spec-009). `null` é o
               estado normal: sem sessão aberta, o componente cai no clipe,
               no retrato ou no selo, exatamente como antes. -->
          <AvatarDaConversa
            v-if="conversaComAvatarAtiva"
            class="mb-3"
            :falando="avatarFalando"
            :provedor-de-clipe="provedorDoClipeDaApresentacao"
            :faixa-de-video="faixaDeVideoDoAvatar"
            :faixa-de-audio="faixaDeAudioDoAvatar"
            @encerrar="encerrarConversaComAvatar"
          />
          <!-- [spec-009 US-3] O cartão que propõe guardar quem é a pessoa fica
               ACIMA do composer e FORA da rolagem: o que pede consentimento não
               pode sair da vista quando a conversa cresce. Só o clique grava —
               ver `view-chat-memoria-do-perfil.mixin.js`. -->
          <ConfirmarPerfilCard
            v-if="mostrarCartaoDePerfil"
            class="mb-3"
            :proposta="propostaDePerfil"
            :salvando="salvandoPerfil"
            :erro="erroDoPerfil"
            @confirmar="confirmarPerfil"
            @dispensar="dispensarPerfil"
          />
          <!-- Input de mensagem. O "+" e o disclaimer S4 pertencem à
               composição nova: no popup e na tela hospedeira o rodapé
               continua o do #1939 (AC-8.3). O chip do agente SAIU — D6
               ([T027]), ver comentário no composer do herói acima. -->
          <SendMessage
            v-if="!composerNoHeroi"
            ref="composerRodape"
            :store-module="ns"
            :ferramentas="ferramentasDoComposer"
            :atalhos-de-negocio="atalhosDeNegocioDoCatalogo"
            :ferramenta-ativa="ferramentaSelecionada"
            :estilo-limpo="estiloLimpoDoComposer"
            :value="messageInput"
            :pulsar-envio="pulsarEnvioDoComposer"
            :duracao-do-pulso-de-envio="duracaoDoPulsoDeEnvio"
            :loading="turnoEmVoo"
            :model-locked="isModelLocked"
            :placeholder="placeholderNaTela"
            :envio-bloqueado="envioTravado"
            :show-agent-select="mostrarSeletorDeEspecialista"
            :show-attachments="usaLayoutFundido"
            :anexos-liberados="anexosLiberados"
                  :anexo-de-carteira-liberado="ofereceAnexoDeCarteira"
            :focar-ao-montar="sidebarComoNavegacao"
            :agentes="agentesDoComposer"
            :agente-ativo-id="agenteAtivoIdDoComposer"
            :agente-travado="agenteTravado"
            :escopo-travado="escopoTravado"
            :escopo-de-cliente="escopoDeCliente"
            :clientes="clientesDoEscritorio"
            :cliente-escopo="clienteEscopo"
            :agente-ativo="agenteAtualDaConversa"
            :id-cliente-anexo="idClienteDoAnexo"
            :nome-cliente-anexo="nomeClienteAnexo"
            :chave-da-fila-de-anexos="chaveDaFilaDeAnexos"
            :superficie-de-voz="superficieDeVozTempoReal"
            :delegar-voz="delegarVozTempoReal"
            :ler-valor-parcial-de-voz="lerValorParcialDoTurnoVoz"
            :id-conversa-de-voz="idConversaDeVoz"
            :atalhos="atalhosDisponiveis"
            mostrar-seletor-de-voz
            hide-disclaimer
            :sem-dica-de-teclado="semDicaDeTeclado"
            @escolher-ferramenta="escolherFerramenta"
            @limpar-ferramenta="limparFerramenta"
            @escopo-change="onTrocarEscopo"
            @input="onMessageInput"
            @send="onSendMessage"
            @enviar-voz="onEnviarVoz"
            @abort="cancelarStream"
            @change-agent="onTrocarAgenteDoComposer"
            @descer-para-acoes="descerParaAcoes"
            @nova-conversa="novaConversa"
            @executar-atalho="executarAtalho"
          >
            <!-- A faixa de créditos e a de conversa quebrada (esta vence): a
                 de sugestões é do estado vazio. -->
            <template v-slot:cabecalho>
              <ComposerAviso
                v-if="trilhoQuebrado"
                tom="danger"
                :texto="TEXTO_COMPOSER.trilhoQuebradoFaixa"
                :acao="TEXTO_COMPOSER.trilhoQuebradoAcao"
                @acao="recarregarAPagina"
              />
              <ComposerAviso
                v-else-if="avisoDeCreditos"
                :texto="avisoDeCreditos.texto"
                :acao="avisoDeCreditos.acao"
                :fechavel="avisoDeCreditos.fechavel"
                :rotulo-de-fechar="rotuloDeFecharAviso"
                @acao="abrirCreditos"
                @fechar="fecharAvisoDeSaldoBaixo"
              />
              <ComposerAviso
                v-else-if="avisoDaApresentacao"
                :texto="avisoDaApresentacao.TEXTO"
                :acao="avisoDaApresentacao.ACAO"
                @acao="dispensarApresentacao"
              />
            </template>
          </SendMessage>
        </div>

        <!-- Aviso persistente ABAIXO do campo, como no protótipo — e FORA do
             `ia-chat-trilho`: com os 768px do trilho de leitura a frase quebrava
             em duas linhas, e ela não é conteúdo da conversa para respeitar essa
             medida. Aqui usa a largura da coluna e fica centrada.
             O comentário anterior dizia que o SendMessage emitia o disclaimer no
             layout fundido — não emite: `hide-disclaimer` é passado
             incondicionalmente acima, então o texto regulatório sai só daqui. -->
        <PersonaAviso
          v-if="mostraPersonaAviso"
          centralizado
          :texto="textoPersonaAviso"
          class="flex-shrink-0 px-4 pt-2 pb-2"
        />
      </div>
    </div>
  </div>
</template>

<style lang="sass" scoped>
// O aviso e o composer viraram UM item flex (antes eram dois), então o rodapé
// precisa dizer que não encolhe — no popup a coluna é baixa e o `flex-shrink`
// padrão espremeria a caixa de texto. A LARGURA vem de `.ia-chat-trilho`.
.intelligence-v2-chat__rodape
  flex-shrink: 0


// Layout fundido: a sidebar quente encosta no conteúdo. O fundo do conteúdo
// continua o da página (o usuário confirmou que já dá conta) — quem separa as
// duas superfícies é a diferença de cor, não borda nem gap.
.intelligence-v2-chat__main--fundido
  background: var(--ia-content-bg)
  border-top-right-radius: var(--radius-card)
  border-bottom-right-radius: var(--radius-card)

// No popup (:widget="true") o painel externo (.chat-ia-pop-up-messages) já
// tem o cantos arredondados no topo — o az-card-bordered interno (classe
// global do DS, não mexer nela) duplicava o arredondamento logo abaixo do
// cabeçalho. Reto só no topo aqui, mantém o resto do az-card-bordered intacto.
.intelligence-v2-chat__main--widget
  border-top-left-radius: 0
  // Mesma superfície quente da rota cheia. O `az-card-bordered` pinta branco, e
  // sem sobrescrever aqui o popup ficava com corpo branco e rodapé quente — o
  // composer usa --ia-content-bg em qualquer superfície.
  background: var(--ia-content-bg)
  border-top-right-radius: 0

// Referência para o cartão de cliente flutuante do modo ancorado.
.intelligence-v2-chat__area
  position: relative

// Fora do fluxo: o estado do run mora no canto superior ESQUERDO da área, na
// mesma faixa do cartão flutuante do painel (canto direito) — empilhado, ele
// empurrava as mensagens e o cartão para baixo (achado do usuário, 17/09).
.intelligence-v2-chat__run-chip
  position: absolute
  top: 0
  left: 0
  z-index: 2

// Fora do fluxo: o cartão deixa de empurrar o herói e o composer quando o
// usuário escolhe (ou limpa) um cliente. Só no modo ancorado — na tela cheia
// tradicional ele continua empilhado acima das mensagens, que é onde faz
// sentido ler o contexto antes da conversa.
.intelligence-v2-chat__escopo--flutuante
  position: absolute
  top: 0
  left: 0
  right: 0
  z-index: 2
</style>
